export default {
  "100_items_page": "100条/页",
  "10_items_page": "10条/页",
  "50_items_page": "50条/页",
  abandon_editing: "放弃编辑",
  abbreviation: "简称",
  abbreviation_cannot_be_empty: "简称不能为空",
  abbreviation_must_be_letters_or_numbers_and_no_longer_than_8_cha:
    "简称为字母或数字，且长度不超过8",
  abnormal: "异常",
  abnormal_behavior_monitoring: "异常行为监测",
  abnormal_cage_layer: "异常笼层",
  abnormal_chicken_cage_statistics: "异常鸡笼统计",
  abnormal_file: "文件异常",
  abnormal_network: "网络异常",
  abnormal_pig_behavior_alarm: "猪只行为异常报警",
  abnormal_pig_count_heads: "异常猪数量",
  abnormal_pig_quantity_alarm: "猪只数量异常报警",
  abnormal_points: "异常点位",
  abnormal_quantity: "异常数量",
  abnormal_robot_restart: "机器人异常重启",
  abnormal_video_file_pls_confirm: "所选录像文件异常，请确认！",
  abn_cage: "异常笼位",
  about: "关于",
  about_the_device: "关于设备",
  above_alarm: "高温报警",
  above_alarm_temp_below_alarm_temp: "高温报警温度值需大于低温报警温度值",
  above_isotherm: "等温线上",
  accelerate: "加速",
  accessories: "配件",
  access_channel_quantity_limit: "接入通道数量限制",
  access_control_device: "门禁设备",
  access_control_terminal: "面板机",
  access_to_location_information_required_to_obtain_gps_data:
    "需要访问位置信息才能获取GPS数据",
  account: "账户",
  account_format_allows_letters_or_numbers_only: "账号格式仅允许字母或数字",
  account_format_should_be_letters_or_numbers_and_length_should_no:
    "账号格式为字母或数字，且长度不超过20",
  account_is_locked_unlocked_after_10_minutes: "账户已锁定,10分钟后解锁",
  account_login: "账号登录",
  account_management: "账户管理",
  account_must_be_numbers_or_chinese_characters_and_no_longer_than:
    "账号格式为数字或中文，且长度不超过20",
  account_not_exist: "账号不存在",
  account_password_modification: "账号密码修改",
  acrel: "安科瑞",
  actual_alarm_reason: "实际报警原因",
  actual_payments: "实付款",
  actual_time: "实际时间",
  add: "添加",
  added: "已添加",
  added_successfully: "新增成功",
  added_to_cloud: "添加到云平台",
  added_to_download_queue: "已添加至下载队列",
  adding_mode: "添加方式",
  adding_patrol_plan_failed: "添加轮训计划失败",
  adding_patrol_plan_succeeded: "添加轮巡计划成功",
  adding_qr_code_points_is_not_allowed: "二维码点位禁止添加",
  adding_recording_lock_failed: "添加录像锁定失败",
  adding_recording_lock_failed_conflicts_with_existing_recording_l:
    "添加录像锁定失败，与现有录像锁定时间有交集",
  adding_recording_lock_succeeded: "添加录像锁定成功",
  adding_recording_plan_failed: "添加录像计划失败",
  adding_recording_plan_succeeded: "添加录像计划成功",
  address: "地址",
  addr_manage: "地址管理",
  add_address: "新增地址",
  add_area: "新增区域",
  add_associated_group: "新增关联组",
  add_channels: "添加通道",
  add_company_information: "完善企业信息",
  add_curve: "添加曲线",
  add_data_permi: "添加数据权限",
  add_department: "添加部门",
  add_device: "添加设备",
  add_email: "新增邮箱",
  add_failed: "添加失败",
  add_img: "添加图片",
  add_inspection_point: "新增巡检点",
  add_manually: "手动添加",
  add_manufacturer: "新增厂商",
  add_map: "添加地图",
  add_new_cage_position: "新增笼位",
  add_new_point: "新增点位",
  add_new_shipping_address: "新增收获地址",
  add_patrol: "添加轮巡",
  add_point: "添加点位",
  add_push_notification_personnel: "新增推送人员",
  add_res: "添加资源",
  add_resource: "新增资源",
  add_res_type: "添加资源类型",
  add_robot: "添加机器人",
  add_row: "添加行",
  add_rule: "添加规则",
  add_shielded_area: "新增屏蔽区域",
  add_spin_drift_to_results: "将自旋漂移添加到结果中",
  add_successful: "添加成功",
  add_temp_difference_rule: "新增差值测温规则",
  add_temp_range: "增加温度范围",
  add_to_cart: "加入购物车",
  add_to_cloud_success: "添加到云平台成功",
  add_user: "添加用户",
  add_video: "添加视频",
  add_views: "添加视图",
  add_your_dedicated_engineer: "添加您的专属工程师",
  adjust_line_number: "调整行号",
  adjust_order: "调整顺序",
  adjust_volume_brightness_through_device_buttons:
    "通过设备按键来调整音量/亮度",
  admin: "超级管理员",
  administrative_region_vector_layer: "行政区域矢量图层",
  administrator_management: "管理员管理",
  admin_account: "管理员账号",
  admin_account_cannot_be_empty: "管理员账号不能为空",
  admin_account_must_be_letters_or_numbers_and_no_longer_than_20_c:
    "管理员账号为字母或数字，且长度不超过20",
  admin_cannot_be_deld: "管理员不可以删除",
  advance: "高级",
  advanced: "高级设置",
  ad_domain_login: "AD域登录",
  after_enabling_thermal_imgs_will_be_automatically_captured_when_:
    "开启后，报警发生时会自动抓拍热像图",
  after_locking_the_robot_will_only_stay_in_place_and_will_not_per:
    "锁定后机器人仅会停在原地，不会执行预设的巡检任务",
  after_logging_out_the_info_related:
    "注销后，账号相关的信息都会从系统移除，请谨慎操作",
  after_sales_service: "售后",
  after_successfully_modifying_the_wifi_information_you_need_to_re:
    "修改Wi-Fi信息成功后，需重启设备并修改手机热点后生效",
  after_switching_the_false_alarm_filtering_switch_the_fire_inform:
    "切换误报过滤开关后，将清空右上角火情消息，确定切换吗？",
  after_the_channel_is_seled_the_channel_info_including_video_prev:
    "勾选后，平台可以查看该通道信息，包括实时预览、录像回放、录像计划、业务报警查看、设备报警查看等",
  after_the_wifi_name_is_modified_you_need_to_reconnect_the_device:
    "修改后需要重新连接设备WiFi",
  after_unlocking_the_robot_will_perform_preset_inspection_tasks:
    "解锁后机器人会执行已预设的巡检任务",
  agent: "代理",
  agent_cannot_be_empty: "代理商不能为空",
  age_in_days: "日龄",
  agree: "同意",
  agreement: "协议",
  air_pressure: "气压",
  ais_layer: "AIS图层",
  ai_analysis_basis: "AI研判依据",
  ai_result_display: "AI结果显示",
  alarm: "报警",
  alarms_with_repeated_occurrences_equal_to_or_less_than_this_thre:
    "重复报警次数小于等于该阈值的报警将被过滤",
  alarm_analysis: "报警分析",
  alarm_area: "报警区域",
  alarm_attributes: "报警属性",
  alarm_auto_photo: "报警自动拍照",
  alarm_category: "报警分类",
  alarm_center: "报警中心",
  alarm_condition: "报警条件",
  alarm_config: "报警配置",
  alarm_count: "报警次数",
  alarm_count_threshold_times: "报警次数阈值（次）",
  alarm_description: "报警描述",
  alarm_details: "报警详情",
  alarm_device: "报警设备",
  alarm_enable_time: "报警启用时间",
  alarm_end_time: "报警结束时间",
  alarm_events: "报警事件",
  alarm_filter_duration_s: "报警过滤时长(s)",
  alarm_filter_time: "(报警)过滤时间",
  alarm_handling: "报警处置",
  alarm_handling_time: "报警处置时间",
  alarm_high_low_temp: "高低温报警",
  alarm_history: "历史报警",
  alarm_information: "报警信息",
  alarm_information_query_alm_info_qry: "告警信息查询",
  alarm_input: "报警输入",
  alarm_in_progress: "报警中",
  alarm_item: "报警项",
  alarm_item_config: "报警项配置",
  alarm_layer: "报警图层",
  alarm_level: "报警级别",
  alarm_linkage: "报警联动",
  alarm_management: "报警管理",
  alarm_name: "报警名称",
  alarm_occurred_times: "已报警*次",
  alarm_on_off: "报警开关",
  alarm_points: "报警点位",
  alarm_preview: "报警预览",
  alarm_processing: "报警处理",
  alarm_processing_template: "报警处理模板",
  alarm_prompt_control: "报警提示控制",
  alarm_query_aq: "告警查询",
  alarm_query_failed: "报警查询失败",
  alarm_record: "事件记录",
  alarm_record_handling: "报警记录处理",
  alarm_region_setting: "报警区域设置",
  alarm_report: "报警报告",
  alarm_result: "报警结果",
  alarm_result_details: "报警结果详情",
  alarm_result_storage_time: "报警结果存储时间",
  alarm_retrieval: "报警检索",
  alarm_sensitivity: "报警灵敏度",
  alarm_settings: "报警设置",
  alarm_shielding_rule_settings: "报警屏蔽规则设置",
  alarm_snapshot: "报警抓拍",
  alarm_snapshot_completed: "报警抓拍完成",
  alarm_snapshot_interrupted: "报警抓拍已中断",
  alarm_snapshot_in_progress: "报警抓拍中",
  alarm_sound: "报警声音",
  alarm_source: "报警源",
  alarm_source_name: "报警源名称",
  alarm_start_time: "报警开始时间",
  alarm_statistics: "报警统计",
  alarm_status: "报警状态",
  alarm_strategy: "报警策略",
  alarm_table: "报警报表",
  alarm_template: "报警模板",
  alarm_temp_setting: "报警温度设置",
  alarm_threshold: "报警阈值",
  alarm_time: "报警时间",
  alarm_trigger_time: "报警触发时间",
  alarm_type: "报警类型",
  alarm_viewing: "报警查看",
  album: "相册",
  algorithm_alarm: "算法报警",
  algorithm_information_not_configured: "未配置算法信息",
  algorithm_name: "算法名称",
  algorithm_operating_channel: "算法运行通道",
  algorithm_recognition: "算法识别",
  algorithm_recognition_failed: "算法识别失败",
  algorithm_syncing: "算法同步中",
  algorithm_type_cannot_be_empty: "算法类型不能为空",
  algorithm_ver_number: "算法版本号",
  alg_op_plan: "算法运行计划",
  alignment_distance: "对齐距离",
  align_style_setting: "对齐样式设置",
  alipay: "支付宝",
  aliyuncom: "阿里云",
  all: "全部",
  allow_input_of_1_to_20_characters_which_can_be_numbers_letters_o:
    "允许输入1~20位的数字、字母、-、_",
  all_alarm_areas_have_been_cleared: "所有报警区域已清空",
  all_anomalies: "全部异常",
  all_appraise: "全部评价",
  all_coops: "全部栋舍",
  all_day: "全天",
  all_day_alarm: "全天报警",
  all_devices: "全部设备",
  all_order: "全部订单",
  all_seled_files_have_been_downloaded: "选择的所有文件已经下载",
  all_shared_channels_of_the_platform_will_be_cleared:
    "平台已共享通道将全部清空",
  already_alarmed: "已报警",
  already_latest_ver: "已是最新版本",
  already_synchronized: "已同步",
  altitude: "海拔",
  ammonia: "氨气",
  amplify: "放大",
  analysis_settings: "分析设置",
  analyze: "分析",
  analyzed: "已分析",
  analyze_all: "分析全部素材",
  angle: "角度",
  angle_restricted_to_integers_in_the_range_90_90: "转角限制在[-90，90)的整数",
  animal_warning: "动物报警",
  anomalies_in_ope_pls_try_again: "异常操作，请重试",
  anomalies_in_points_need_to_retrieve_them_from_the_platform:
    "点位异常，需要从平台拉取点位",
  anonymity: "匿名",
  another_user_is_currently_operating_pls_try_again_later:
    "其他用户正在操作，请稍后重试",
  an_error_occurred: "操作出错了",
  an_existing_device_is_currently_connected_pls_wait:
    "已有设备处于连接状态，请等待",
  api_interface_timeout: "API接口超时",
  application: "应用",
  application_exception: "应用异常",
  application_name: "应用名称",
  application_restart: "应用重启",
  application_status: "应用状态",
  application_system_alarm: "应用系统报警",
  application_ver: "应用版本",
  applied_fov: "应用视场角",
  applying_for_memory_permission: "申请内存权限",
  appraise: "评价",
  app_binding_status: "app绑定状态",
  app_ver: "App版本",
  apr: "四月",
  arctic: "极地",
  area_intrusion: "区域入侵",
  area_name_cannot_be_empty: "区域名不能为空",
  are_there_other_hotspots_with_the_same_name_around_the_device:
    "设备周边是否有其他同名热点",
  are_you_sure_to_clear_all_area_rules_for_the_current_device:
    "确定要清空当前型号设备的所有区域规则？",
  are_you_sure_to_del_the_n1_inspection_task: "确认删除{n1}巡检任务吗？",
  are_you_sure_to_del_the_template: "是否删除模板",
  are_you_sure_to_del_this_resource: "确定删除该资源吗?",
  are_you_sure_to_del_this_resource_type: "确定删除该资源类型吗?",
  are_you_sure_to_del_this_shieled_area: "确定删除该屏蔽区域吗？",
  are_you_sure_to_del_this_will_affect_historical_information_view:
    "确定进行删除操作? (将影响设备实时预览、录像回放、录像计划、报警记录、测温数据的历史信息查看)",
  are_you_sure_to_exit: "是否确认退出",
  are_you_sure_you_want_to_del_the_data_item_named_n1:
    "是否确认删除名称为{n1}的数据项?",
  are_you_sure_you_want_to_del_the_data_item_with_resource_id_x:
    "是否确认删除数据权限编号为的数据项？",
  are_you_sure_you_want_to_del_the_line: "确定删除第？行吗",
  are_you_sure_you_want_to_del_the_seled_report: "确定删除选中报告？",
  are_you_sure_you_want_to_del_this_config: "确定删除该配置吗",
  are_you_sure_you_want_to_exit: "确定退出吗？",
  are_you_sure_you_want_to_exit_exiting_will_disable_the_alarm_lin:
    "是否确认退出？退出后会关闭报警联动",
  are_you_sure_you_want_to_export_all_data_permi_items:
    "是否确认导出所有数据权限数据项？",
  are_you_sure_you_want_to_restart_the_robot: "确定重启机器人吗？",
  are_you_sure_you_want_to_resume_re_execute_the_xxx_inspection_ta:
    "确定恢复/重新执行 XXX巡检任务吗",
  are_you_sure_you_want_to_resume_the_n1_inspection_task:
    "确定恢复{n1}巡检任务吗",
  are_you_sure_you_want_to_re_execute_the_n1_inspection_task:
    "确定重新执行{n1}巡检任务吗",
  are_you_sure_you_want_to_terminate_the_n1_inspection_task:
    "确定终止{n1}巡检任务吗",
  array_size: "阵列规模",
  asbestos_board: "石棉板",
  ascending: "正序",
  ascending_order_by_name: "按名称升序",
  ascending_order_by_time: "按时间升序",
  associated_cage_number: "关联笼号 ",
  associated_channel: "关联通道",
  associated_channel_cannot_be_empty: "关联通道不能为空",
  associated_code: "对应编码",
  associated_column_number: "关联列号",
  associated_component: "对应组件",
  associated_component_eg_menu: "对应组件,如Menu",
  associated_group: "关联组",
  associated_group_identifier_cannot_be_empty: "关联组标识不能为空",
  associated_group_names_cannot_be_duplicated: "关联组名称不可重复",
  associated_group_name_length_cannot_exceed: "关联组名称长度不能超过",
  associated_img_capture_direction: "关联拍照方向",
  associated_map: "所属地图",
  associated_organization: "关联组织",
  associated_point: "关联点位",
  associated_robot: "关联机器人",
  associated_task: "所属任务",
  associate_ir_img: "关联红外图片",
  associate_region: "关联区域",
  association_name: "关联名称",
  association_successful: "关联成功",
  asynchronous: "未同步",
  asynchronously_starting_recording_plan: "异步启动录像计划",
  atmospheric_ambient_temp: "大气环境温度",
  atmospheric_temp_is_out_of_range: "环境温度超出范围",
  atmospheric_temp_is_required: "环境温度不能为空",
  atmospheric_transmissivity: "大气透过率",
  atmos_temp: "环境温度",
  attribute: "属性",
  at_least_one_comprehensive_judgment_rule_must_be_seled:
    "综合研判规则至少选一项",
  audio: "声音",
  aug: "八月",
  authentication: "认证",
  authentication_failed_and_the_upload_was_terminated: "鉴权失败,上传终止",
  authorization_successful: "授权成功",
  authorization_successfully_revoked: "取消授权成功",
  authorize: "授权",
  authorize_use_of_robot_ope_information: "授权使用机器人运行信息",
  auth_failed: "认证失败",
  auth_failed_app_will_exit: "认证失败，应用即将退出。",
  auth_failed_incorrect_username_password_or_device_model:
    "认证失败，用户名、密码或设备型号错误",
  auto: "自动",
  autofocus_core_the_blackbody_temp_x_10:
    "有自动聚焦功能的机芯，黑体温度值乘10",
  automatically_turn_off_io: "自动关闭报警",
  automatic_blinding_succeeded: "自动打盲元成功",
  automatic_gain: "自动增益",
  automatic_time_synchronization: "自动校时",
  automatic_tracking_is_not_possible_pls_switch_the_linkage_contro:
    "无法进行自动追踪，请将设备联动控制切换至自动跟随模式。",
  automobile_night_vision: "汽车夜视",
  auto_0: "自动调整0",
  auto_brightness_adjustment: "自动调光",
  auto_change_gain_mode: "(ATU)自动切换增益",
  auto_cloud_connection_successful: "自动云端连接成功",
  auto_excl: "自动剔除",
  auto_excl_speed: "自动剔除速度",
  auto_focus: "自动聚焦",
  auto_login: "自动登录",
  auto_mode: "自动模式",
  auto_mode_restoration_time: "恢复自动模式时间",
  auto_power_off: "自动关机",
  auto_save: "自动保存",
  auto_temp_scale_enabled: "自动温宽已打开",
  auto_time_sync_set_successfully: "设置自动同步时间成功",
  average: "平均值",
  average_egg_production: "均产蛋数",
  average_egg_production_rate: "均产蛋率",
  average_temp: "平均温度",
  average_temp_equal_to: "平均温等于",
  average_weight: "均重",
  average_weight_per_pig: "猪只均重",
  avg: "平均温",
  avg_temp_big_than: "平均温大于",
  avg_temp_less_than: "平均温小于",
  axis: "安讯士",
  azimuth_angle: "方位角",
  a_channel_cannot_belong_to_multiple_associated_groups_whether_as:
    "一个通道不能从属于多个关联组。同一个关联组内，关联通道是否同时报警，将作为综合研判去误报的参考。",
  a_file_is_being_downloaded_pls_confirm_whether_to_modify_the_enc:
    "有文件正在下载，请确认是否修改加密类型",
  a_file_is_being_downloaded_pls_confirm_whether_to_modify_the_pwd:
    "有文件正在下载，请确认是否修改WiFi密码",
  a_file_is_being_downloaded_pls_confirm_whether_to_modify_the_wif:
    "有文件正在下载，请确认是否修改WiFi名称",
  a_locked_robot_cannot_execute_inspection_tasks_as_planned_confir:
    "闭锁状态下的机器人无法按照计划执行巡检任务，确定闭锁机器人吗?",
  a_max_of_6_video_streams_can_be_displayed_at_most: "最多只能展示6路视频",
  a_max_of_n_target_points_are_allowed: "最多允许添加{n}个目标点",
  a_max_of_n_videos_can_be_displayed: "最多只能展示{n}路视频",
  a_quick_report_is_created_pls_wait: "一个快速报告任务正在进行，请稍等",
  a_window: "一个视窗",
  background_api_ver: "后台API版本",
  back_to_home_page: "返回首页",
  back_to_ir_searcher_app: "返回 IR Searcher 应用",
  back_to_the_previous_menu: "返回上一级",
  ballistics: "弹道",
  ballistic_calculation: "弹道计算",
  ballistic_coefficient: "弹道系数",
  bark: "树皮",
  base_map: "底图",
  base_map_control: "底图控制",
  base_map_transparency: "底图透明度",
  basic_info: "基础信息",
  basic_information: "基本资料 ",
  basic_information_config: "基础信息配置",
  basic_setting: "基础设置",
  batch_add: "批量添加",
  batch_create: "批量新建",
  batch_delete: "批量删除",
  batch_dl: "批量下载",
  batch_download_logs: "日志批量下载",
  batch_import: "批量导入",
  batch_remove: "批量移除",
  batch_revoke_authorization: "批量取消授权",
  batch_settings: "批量设置",
  batch_sync: "批量同步",
  batch_unbind: "批量解绑",
  battery: "电池",
  battery_abnormal: "电池异常",
  battery_alarm_threshold: "电量报警阈值",
  battery_capacity: "电池容量",
  battery_current: "电池电流",
  battery_information: "电池信息",
  battery_is_low_and_will_be_shut_down_soon: "电池电量不足，即将关机",
  battery_level: "电量",
  battery_life: "工作时长",
  battery_model: "电池型号",
  battery_status: "电池状态",
  battery_temp: "电池温度",
  battery_type: "电池类型",
  battery_voltage: "电池电压",
  baud_rate: "波特率",
  below_alarm: "低温报警",
  below_alarm_temp_above_alarm_temp: "低温报警温度值需小于高温报警温度值",
  below_isotherm: "等温线下",
  beta: "内测版本",
  beyond_range: "超距",
  bill_management: "账单管理",
  binding_now: "立即绑定中",
  bind_app: "绑定app",
  bind_now: "立即绑定",
  bird: "观鸟",
  black_body_temp: "黑体温度",
  black_hot: "黑热",
  black_or_white_paint: "黑或白漆",
  blank_page: "空白页面",
  blind_element_settings_saved_successfully: "盲元设置保存成功",
  blind_element_setting_mode: "盲元设置模式",
  blind_element_setting_mode_has_exited: "盲元设置模式已退出",
  blind_spot_radius: "盲区半径",
  blink: "闪烁",
  blocked: "机器人停障",
  blue: "蓝",
  bluehot: "蓝热",
  bluetooth_authorization_is_required_to_discover_new_devices:
    "需要开启蓝牙授权才能发现新设备",
  bluetooth_device_disconnected: "蓝牙设备已断开",
  bluetooth_device_not_found_yet: "暂未查找到蓝牙设备",
  bluetooth_permi_required: "需要开启蓝牙权限",
  blue_shades: "渐变蓝",
  boat_with_ais: "有AIS船只",
  bottom_left: "左下",
  bottom_right: "右下",
  bound: "已绑定",
  bound_rebind: "已绑定,换绑",
  brass_mirror: "黄铜镜面",
  brass_oxide: "氧化黄铜",
  brazilian_portuguese: "巴葡语",
  brightness: "亮度",
  brightness_adjustment: "亮度调节",
  brightness_settings: "亮度设置",
  bright_black_paint: "黑亮漆(喷在粗糙铁上)",
  bright_paint: "亮漆(所有颜色)",
  broadcast_lan: "播放语言",
  browser_time: "浏览器时间",
  browsing_history: "浏览历史",
  building_details: "栋舍详情",
  building_name: "栋舍名称",
  building_statistics: "栋舍统计",
  built_in_firmware_ver_number: "内置固件版本号",
  bullet: "子弹",
  bullet_camera: "枪机",
  bullet_diameter: "子弹直径",
  bullet_information: "子弹信息",
  bullet_length: "子弹长度",
  bullet_list: "子弹列表",
  bullet_manufacturer: "子弹厂商",
  bullet_name_already_exists_pls_edit_again: "子弹名称已存在，请重新编辑",
  bullet_weight: "子弹重量",
  business_alarm: "业务报警",
  business_alarm_email_subject: "【系统通知】业务报警统计通知",
  business_execution_error: "业务执行出错",
  button_settings: "按键设置",
  buy_now: "立即购买",
  by_count: "按次数",
  by_day: "按天",
  by_frequency: "按频率",
  by_hour: "按时",
  by_level: "按等级",
  by_minute: "按分",
  by_month: "按月",
  by_name: "按名称",
  by_organization_structure: "按组织结构",
  by_second: "按秒",
  by_threshold: "按阈值",
  by_time: "按时间",
  by_week: "按周",
  by_year: "按年",
  cage: "*笼",
  cage_name: "笼位",
  cage_no: "笼位号",
  cage_view: "笼位查看",
  calcimine: "墙粉",
  calibrate: "标定",
  calibrated: "已校准",
  calibrate_device: "校准设备",
  calibrate_failed: "标定失败",
  calibrate_succeeded: "标定成功",
  calibration: "校准",
  calibration_method: "标定方法",
  calibration_status: "校准状态",
  camera: "摄像头",
  camera_ip: "摄像机IP",
  camera_ip_left: "摄像机IP（左）",
  camera_ip_right: "摄像机IP（右）",
  camera_name: "摄像机名称",
  camera_name_left: "摄像机名称（左）",
  camera_permi_required: "需要打开相机权限",
  camera_permi_required_to_accurately_obtain_azimuth_information:
    "需要开启相机权限，才能精准获取方位角信息",
  camera_status: "摄像机状态",
  camera_status_left: "摄像机状态（左 ）",
  camera_status_right: "摄像机状态（右）",
  camera_type: "摄像机类型",
  camera_type_right: "摄像机类型（右）",
  cancel: "取消",
  canceled: "取消成功",
  cancel_download: "取消下载",
  cancel_search: "取消搜索",
  cancel_sel: "取消选择",
  cancel_the_download: "是否取消下载",
  cannot_be_greater_than_the_max_val: "不能大于最大值",
  cannot_be_less_than_the_min_val: "不能小于最小值",
  cannot_duplicate_with_other_rules: "不可与其他规则重复",
  cannot_sel_two_constants_at_the_same_time: "不能同时选择两个常量",
  can_be_purchased_after_login_auth: "登录认证后可购买",
  can_not_join_group_shop_from_cart: "从购物车结算不会参加团购",
  capacity: "容量",
  capacity_is_less_than_200_mb: "Sd卡剩余空间不足200M,录制终止",
  capacity_is_less_than_200_mb_cannot_recording:
    "剩余空间不足200M,无法进行录制",
  caps_lock_is_on: "大写锁定已打开",
  capture_time: "抓图时间",
  car: "汽车",
  carbon_dioxide: "二氧化碳",
  carbon_dioxide_cloud_map: "二氧化碳云图",
  carbon_dioxide_concentration: "二氧化碳浓度",
  carbon_dioxide_ppm: "二氧化碳(ppm)",
  carbon_dioxide_sensor_status: "二氧化碳传感器状态",
  carbon_monoxide: "一氧化碳",
  carbon_plate: "碳片",
  cargo_ship: "货船",
  cart: "购物车",
  category: "类别",
  category_cannot_be_empty: "类别不能为空",
  category_featured: "分类精选",
  celsius: "摄氏度",
  center_ip: "中心IP",
  center_port: "中心端口",
  center_spot: "中心点",
  certificated: "认证通过",
  certificate_information_retrieval_error_pls_contact_the_administ:
    "证书信息获取错误，请联系管理员",
  certificate_installation_error_pls_contact_the_administrator:
    "证书安装错误，请联系管理员",
  certificate_must_be_in_lic_format: "证书只能是 .lic 格式",
  certificate_verification_failed: "证书验证失败",
  change_avatar: "修改头像",
  change_bound_phone_number: "换绑手机号",
  change_from_0_to_1: "从{0}变到{1}",
  channel: "通道",
  channels: "个通道",
  channels_not_shared: "未共享通道",
  channel_addition_exception: "添加通道异常",
  channel_data_does_not_exist: "信道数据不存在",
  channel_does_not_exist: "通道不存在",
  channel_id: "通道编号",
  channel_information: "通道信息",
  channel_no: "通道数",
  channel_not_found_in_the_platform: "平台内没有添加该通道",
  channel_no_is_required: "通道数不能为空",
  channel_number: "通道号",
  channel_offline: "通道离线",
  channel_type: "通道类型",
  chan_id: "通道ID",
  chan_name: "通道名称",
  charging: "充电中",
  charging_point: "充电点",
  charging_points: "充电点位",
  chars_less_than: "字符数小于",
  chart_combination_of_numbers_capital_and_lowercase: "备注：名称1-32位",
  chassis: "底盘",
  chassis_malfunction: "底盘故障",
  checking: "校验中",
  check_for_updates: "检查更新",
  check_if_its_the_device_network: "检查是否是设备网络",
  chicken_cage: "鸡笼",
  chicken_coop: "鸡舍",
  chicken_coop_management: "鸡舍管理",
  chicken_mouth_open_alarm: "鸡张嘴",
  chicken_recognition: "鸡只识别",
  china_bright: "瓷器(亮)",
  chinese_characters_not_permitted: "密码不能包含中文",
  choose_bullet: "选择子弹",
  choose_every_time: "每次选择",
  choose_firearm: "选择枪支",
  choose_from_the_dropdown_list_do_not_copy_and_paste_from_other_f:
    "下拉选择，请勿从其他文件复制粘贴",
  circle: "圆",
  city: "城市",
  clean_up_alarm_interval: "清理报警数据间隔",
  clean_up_by_space: "按空间清理",
  clean_up_temp_interval: "清理温度数据间隔",
  clear: "清空",
  clear_cache: "清除缓存",
  clear_calibration_failed: "清除标定失败",
  clear_calibration_succeeded: "清除标定成功",
  clear_cart: "清空购物车",
  clear_model_information: "清除型号信息",
  clear_successful: "清除成功",
  clicks: "咔哒",
  click_on_the_map_to_retrieve_information_from_any_location:
    "点击地图任一位置获取",
  click_resource_to_see_detail_infomation: "点击素材查看详情",
  click_to_sel_alarm_source: "点击选择报警源",
  click_to_sel_export_information: "点击选择导出信息",
  click_to_sel_parent_directory: "点击选择上级目录",
  click_to_upload: "点击上传",
  click_to_upload_avatar: "点击上传头像",
  click_to_view: "点击查看",
  clip: "裁剪",
  clip_failed: "裁剪失败",
  clip_success: "裁剪成功",
  clockwise: "顺时针",
  clockwise_deviation_from_due_north_angle: "顺时针偏离正北",
  close: "关闭",
  close_all: "关闭所有",
  close_all_playback: "关闭全部回放",
  close_distance_highlight: "近距离凸显效果",
  close_distance_highlight_display: "近距离凸显效果显示",
  close_distance_pedestrian_warning: "行人近距离报警",
  close_distance_vehicle_warning: "车辆近距离报警",
  close_factory_password: "关闭工厂模式密码",
  close_playback: "关闭回放",
  close_prompt: "关闭提示",
  close_video: "关闭视频",
  closing_pls_wait: "关闭中，请稍候...",
  cloud: "云平台",
  cloud_connection_successful: "云端连接成功",
  cloud_download: "云端下载",
  cloud_import: "云端导入",
  cloud_import_directory: "云端导入路径",
  cloud_login: "云平台登录",
  cloud_platform_connection_failed: "云平台连接失败",
  cloud_platform_connection_successful: "云平台连接成功",
  cloud_platform_settings: "云平台设置",
  cloud_resource: "云端资源库",
  cloud_status: "云端状态",
  cloud_user: "云平台用户",
  coarse_tuning: "粗调",
  cold_spot: "冷点追踪",
  collect_interval: "采集间隔",
  color: "颜色",
  color_highlights: "颜色凸显",
  color_palette: "伪彩",
  column_cage_layer_suspected_discovery: "*列*笼*层疑似发现*",
  column_name: "栏位名称",
  column_x_cage_x_layer_x: "x列x笼x层",
  commodity_amount: "商品金额",
  communication_status: "通信状态",
  company_n: "公司名称",
  compiled_ver_number: "编译版本号",
  complete: "完成",
  composite_report: "合成报告",
  comprehensive_analysis_basis: "综合研判依据",
  comprehensive_intelligent_analysis_level: "智能综合研判等级",
  com_is_required: "COM不能为空",
  concrete: "混凝土",
  config: "配置",
  configure_device_wifi: "配置设备Wi-Fi",
  configure_rules: "配置规则",
  configure_storage_strategy: "设置存储策略",
  config_not_supported: "不支持配置。",
  config_region: "配置区域",
  config_tool: "配置工具",
  config_tool_is_running: "配置工具已运行。",
  confirm: "确认",
  confirmed: "已确认",
  confirm_and_continue: "确认并继续",
  confirm_clearing_all_map_markers: "确定清空所有的地图标注？",
  confirm_deletion: "确定删除",
  confirm_deletion_of_xxx_inspection_task: "确认删除XXX巡检任务吗？",
  confirm_intelligent_import_ope: "确定进行智能导入操作?",
  confirm_its_an_anomaly: "确认是异常",
  confirm_its_a_false_alarm: "确认是误报",
  confirm_logout: "确定退出登录",
  confirm_log_in_again: "是否重新登录",
  confirm_new_password: "确认新密码",
  confirm_or_not: "是否确认",
  confirm_permanent_deletion_this_action_is_not_recoverable:
    "确认永久删除吗？此操作不可恢复",
  confirm_pwd: "确认密码",
  confirm_restore_default_ope: "确定进行恢复默认操作",
  confirm_stopping_device_alarm: "确定停止设备报警",
  confirm_termination_of_xxx_inspection_task: "确定终止XXX巡检任务吗",
  confirm_the_cull_after_culling_the_target_will_no_longer_be_dete:
    "确认剔除吗?剔除后将不再检测该目标。",
  confirm_the_unbinding_ope: "确定进行解绑操作",
  confirm_to_del: "确定删除吗",
  confirm_to_delrobot: "确定删除...机器人吗?",
  confirm_to_deltenant: "确定删除...租户吗？",
  confirm_to_del_all_regions: "确定删除所有区域吗",
  confirm_to_del_the_cur_path: "确定移除当前路径吗",
  confirm_to_del_the_file: "是否确认删除文件",
  confirm_to_del_the_selected_file: "确认删除选中文件",
  confirm_to_del_this_chicken_house: "确定删除该鸡舍吗",
  confirm_to_del_this_pig_house: "确定删除该猪舍吗",
  confirm_to_del_this_pig_pen: "确定删除该猪栏吗",
  confirm_to_disableuser: "确定禁用...用户吗？",
  confirm_to_exit: "确定退出吗",
  confirm_to_exit_the_upgrade: "确认退出升级吗",
  confirm_to_export_all_tenant_management_data_items:
    "是否确认导出所有租户管理数据项？",
  confirm_to_export_all_user_data_items: "是否确认导出所有用户数据项？",
  confirm_to_format: "确定格式化SD卡吗",
  confirm_to_import_all_points: "确定导入所有点位吗",
  confirm_to_remove_this_robot: "确定移除该机器人吗？",
  confirm_to_resetpassword: "确认重置...的密码？",
  confirm_to_reset_password: "确定重置的密码吗?",
  confirm_to_restart: "确定重启吗",
  confirm_to_restore: "确定恢复出厂设置吗",
  confirm_to_revoke_authorization_for_this_user_role: "确认要取消该用户角色吗?",
  confirm_to_revoke_this_userrole: "确认要取消该用户...角色吗？",
  confirm_to_unbind_the_user: "确定解绑用户吗",
  confrim_to_del_the_row: "确定删除第/行吗",
  connect: "连接",
  connected: "已连接",
  connected_devices: "已连接设备",
  connecting: "连接中",
  connecting_to_the_device: "连接设备中",
  connection_disconnected: "连接断开",
  connection_disconnected_pls_exit_and_try_again: "连接已断开，请退出重试",
  connection_failed_incorrect_ip_port_or_device_network:
    "连接失败，IP、端口错误或设备网络异常",
  connection_guide: "连接指南",
  connection_succeeded: "连接成功",
  connect_device: "连接设备",
  connect_device_manually: "手动连接设备",
  connect_failed: "连接失败",
  connect_port_failed_device_is: "连接端口失败,设备为",
  connect_via_device_access_point: "手机连接设备",
  consignee_phone_number: "收货人手机号",
  constant: "常量",
  consumer_hotline: "客服电话",
  contact: "联系人",
  contact_cannot_be_empty: "联系人不能为空",
  contact_customer_service: "联系客服",
  contact_information: "联系方式",
  contact_phone_number: "联系电话",
  content: "内容",
  content_page: "内容页",
  continue_patrol: "继续轮巡",
  continue_recording: "继续录制",
  continuous: "持续",
  continuous_rangefinding: "连续测距",
  contrast: "对比度",
  control_commands_cannot_be_enabled_during_video_recording:
    "录像时不能启用控制命令",
  control_switch: "控制开关",
  conventional_resolution: "常规分辨率",
  coop_name: "舍位名称",
  coordinate_conversion_failed: "坐标转换失败",
  coordinate_system: "坐标系",
  copper_coated_with_solder: "涂焊料的铜",
  copper_wire: "铜丝",
  copy: "复制",
  copy_to_clipboard_failed: "复制到剪贴板失败",
  copy_to_clipboard_succeed: "复制到剪贴板成功",
  core_ver: "机芯版本",
  coriolis_effect: "科里奥利效应",
  corporate_account: "对公帐号",
  corporate_jurisdical_person: "公司法人",
  corporate_name: "企业名称",
  corresponding_internal_network_port: "对应内网端口",
  corresponding_permission_is_required:
    "如果要使用此功能，需要在设置中为应用程序提供相应的权限",
  cotton_textiles_all_colors: "棉纺织品(全颜色)",
  count: "次数",
  counterclockwise: "逆时针",
  county: "区县",
  coupon: "优惠券",
  coupon_simple: "券",
  cpu_overload: "负载过高",
  cracked_eggs: "破蛋",
  cracked_egg_alarm: "破蛋报警",
  cracked_egg_analysis: "破蛋分析",
  create: "创建",
  create_account: "新建账户",
  create_config: "新建配置",
  create_new_group: "新建分组",
  create_new_house: "新建舍位",
  create_new_page: "新建页面",
  create_new_patrol: "新建轮巡",
  create_new_pen: "新建栏位",
  create_new_role: "新建角色",
  create_new_task: "新建任务",
  create_new_template: "新建模板",
  create_new_user: "新建用户",
  create_new_view: "新建视图",
  create_order: "创建订单",
  create_organization: "新建组织",
  create_success: "创建成功",
  create_time: "创建时间",
  creation_date: "创建日期",
  creation_failed: "创建失败",
  creation_successful: "新建成功",
  creator: "创建人",
  critical: "严重",
  crossing_areas_are_not_allowed_to_be_drawn_pls_redraw:
    "不允许绘制交叉区域，请重新绘制！",
  cruise_ship: "游轮",
  cumulative_sales: "累计销售",
  currently_in_continuous_rangefinding_mode: "当前处于连续测距状态",
  current_channel_has_no_downloadable_recordings: "当前通道无可下载录像",
  current_computer_has_not_occupied_the_config_lock: "当前计算机未占用配置锁",
  current_coop: "当前栋舍",
  current_graphics_card_does_not_support_playing_h265_stream_pls_d:
    "当前显卡不支持播放h265码流，请下载操作文档进行设置",
  current_height: "当前高度",
  current_location: "当前位置",
  current_network_is_lan_pls_switch: "当前网络为局域网，请切换外网分享",
  current_organization: "当前组织",
  current_patrol: "当前轮巡",
  current_patrol_is_previewing_cant_del: "正在轮巡，不能删除",
  current_phone_number: "当前手机号",
  current_point: "当前点位",
  current_recording_plan_and_linked_recording_stream_do_not_match_:
    "当前录像计划和联动录像码流不一致，将录制两份文件，占用存储空间资源翻倍, 是否继续",
  current_software_ver_beta: "当前软件版本beta",
  current_view: "当前视图",
  current_view_has_been_associated_with_patrol_and_cannot_be_deld:
    "当前视图已被轮巡计划关联，暂不能删除",
  current_view_is_in_preview_mode_and_cannot_be_deld:
    "当前视图正在预览，不能删除。",
  current_view_is_using_and_cannot_be_deld: "当前视图正在使用，无法删除。",
  cur_device: "当前设备",
  customer_service: "客服",
  custom_spot: "自定义点",
  custom_time_period: "自定义时间段",
  cycle_setting_cannot_be_empty: "周期设置不能为空",
  d: "日",
  daily_new: "日新增",
  daily_new_alarms: "每日新增报警",
  daily_weight_gain: "舍日增重",
  data: "数据",
  database_table: "数据库表",
  data_already_exists: "数据已存在",
  data_append_failed: "数据添加失败",
  data_cannot_be_empty: "数据不能为空",
  data_center: "数据中心",
  data_collection: "数据采集",
  data_deletion_failed: "数据删除失败",
  data_does_not_exist: "数据不存在",
  data_duplicate: "数据重复",
  data_error: "数据有误",
  data_format_error_pls_contact_the_administrator: "数据格式错误，请联系管理员",
  data_insertion_failed: "资料插入失败",
  data_load_failed: "数据加载失败",
  data_monitoring: "数据监控",
  data_out_of_range: "数据越界",
  data_permis: "数据权限",
  data_permi_class_name: "数据权限类名",
  data_permi_class_name_cannot_be_empty: "数据权限类名不能为空",
  data_permi_field: "数据权限字段",
  data_permi_field_cannot_be_empty: "数据权限字段不能为空",
  data_permi_name: "数据权限名称",
  data_permi_name_cannot_be_empty: "数据权限名称不能为空",
  data_permi_range: "数据权限值域",
  data_permi_remarks: "数据权限备注",
  data_permi_type: "数据权限类型",
  data_permi_type_cannot_be_empty: "数据权限类型不能为空",
  data_retrieval_failed: "数据获取失败",
  data_source: "数据源",
  data_statistics: "数据统计",
  data_status: "数据状态",
  data_type: "数据类型",
  data_update_failed: "数据更新失败",
  date: "日期",
  date_and_time: "日期时间",
  date_setting: "日期设置",
  day: "白天",
  days: "*天",
  day_age_days: "日龄（天）",
  day_age_must_be_0_or_a_positive_integer_and_no_longer_than_5_cha:
    "日龄格式为0或正整数，且长度不超过5",
  day_ago: "天前",
  dde: "图像增强",
  dead_chickens: "死鸡",
  dead_chicken_alarm: "病死鸡",
  dead_chicken_analysis: "死鸡分析",
  dec: "十二月",
  decelerate: "减速",
  default_anti_keyword: "默认",
  default_charging_point: "默认充电点",
  default_group: "默认分组",
  default_keyword: "默认关键字",
  default_map: "默认地图",
  default_organiztion: "默认组织",
  default_password_is_12345678: "备注：默认密码为12345678",
  default_path_cannot_be_removed: "默认路径不能移除",
  default_role: "默认角色",
  default_settings: "默认设置",
  default_template: "默认模板",
  default_template_cannot_be_deld: "默认范本禁止删除",
  default_template_name_cannot_be_modified: "默认模板禁止修改名称",
  del: "删除",
  deld_inspection_point_successfully: "删除巡检点成功",
  delete_original_file: "删除原文件!",
  deleting: "正在删除",
  deleting_linkage_strategy_failed: "删除联动策略失败",
  deleting_linkage_strategy_succeeded: "删除联动策略成功",
  deleting_patrol_plan_failed: "删除轮巡计划失败",
  deleting_patrol_plan_succeeded: "删除轮巡计划成功",
  deleting_qr_code_points_is_not_allowed: "二维码点位禁止删除",
  deleting_the_area_will_also_del_related_push_notifications_are_y:
    "将同时删除区域相关的推送信息，确定进行删除操作?",
  del_account: "注销账号",
  del_all: "删除所有",
  del_chicken_house: "删除鸡舍",
  del_config: "删除配置",
  del_control: "删除控件",
  del_failed: "删除失败",
  del_from_cloud: "从云平台删除",
  del_map: "删除地图",
  del_page: "删除页面",
  del_pig_house: "删除猪舍",
  del_pig_pen: "删除猪栏",
  del_point: "删除点位",
  del_robot: "删除机器人",
  del_role: "删除角色",
  del_selected: "删除选中",
  del_sel_file: "删除选中文件",
  del_success: "删除成功",
  del_task: "删除任务",
  del_template: "删除模板",
  del_tenant: "删除租户",
  del_user: "删除用户",
  department: "所属部门",
  department_name: "部门名称",
  department_name_cannot_be_empty: "部门名称不能为空",
  department_status: "部门状态",
  deposit: "押金",
  depth_camera: "深度相机",
  depth_camera_abnormal: "深度相机异常",
  descending: "倒序",
  descending_order_by_name: "按名称降序",
  descending_order_by_time: "按时间降序",
  description_of_alarm_handling: "报警处置描述",
  desel_all: "全不选",
  desel_user_authorization: "是否取消选中用户授权数据项？",
  desert: "沙漠",
  details: "详情",
  detail_info: "详细信息",
  detect: "发现",
  detection_distance: "探测距离",
  detection_item: "检测项",
  detection_value: "检测值",
  detector_temp: "探测器温度",
  developing: "开发中",
  device: "设备",
  device_alarm: "设备报警",
  device_alarm_source: "设备报警源",
  device_alarm_stopped_successfully: "设备停止报警成功",
  device_alarm_stop_failed: "设备停止报警失败",
  device_alarm_subscription: "设备报警订阅",
  device_alarm_template_number: "设备报警模板编号",
  device_alias_already_exists_in_this_organization: "当前组织已有该别名的设备",
  device_alias_required: "设备别名(必填)",
  device_already_added: "设备已添加",
  device_authority: "设备权限",
  device_auth_failed: "设备认证失败",
  device_battery_level: "设备电量",
  device_calibration: "设备校准",
  device_channel_number_error: "设备通道号错误",
  device_command_parameter_error: "设备指令参数错误",
  device_config: "设备配置",
  device_connected: "设备已连接",
  device_connected_to_the_app: "设备与App已连接",
  device_connection_failed: "设备连接失败",
  device_deletion_failed: "设备删除失败",
  device_disconnected: "设备断开",
  device_disconnected_pls_reconnect: "设备已断开，请重新连接",
  device_discovery: "设备发现",
  device_does_not_exist: "设备不存在",
  device_driver: "设备驱动",
  device_exception: "设备异常",
  device_file: "设备文件",
  device_find_error: "设备查询失败",
  device_id: "设备编码",
  device_import_failed_information_table: "设备导入失败信息表",
  device_import_information_table: "设备导入信息表",
  device_import_information_table_do_not_include_empty_lines_or_sp:
    "设备导入信息表（请勿空行、空格）",
  device_info: "设备信息",
  device_information_management: "设备信息管理",
  device_ip: "设备IP",
  device_ip_or_port_number_error: "设备IP或埠号错误",
  device_ip_or_port_number_is_incorrect: "设备IP或端口号错误",
  device_is_not_added_to_cloud: "设备未添加到云平台",
  device_is_offline: "设备已离线",
  device_is_offline_no_stream_information: "设备不在线无流信息",
  device_language_sel: "设备语言选择",
  device_layer: "设备图层",
  device_linkage: "设备联动",
  device_link_guide: "设备链接指南",
  device_list: "设备列表",
  device_location: "设备位置",
  device_login: "登录设备",
  device_malfunction: "设备故障",
  device_mgt: "设备管理",
  device_model: "设备型号",
  device_monitoring: "设备监控",
  device_name: "设备名称",
  device_name_cannot_be_empty: "设备名称不能为空",
  device_name_exists: "设备名称重复",
  device_network_connection_exception: "设备网络连接异常",
  device_network_issue: "设备网络异常",
  device_not_found_in_the_platform: "平台内没有添加该设备",
  device_not_retrieved: "未获取到设备",
  device_offline: "设备离线",
  device_ops: "设备运维",
  device_or_channel_does_not_exist: "设备或通道不存在",
  device_or_channel_query_failed: "设备或通道查询失败",
  device_pan_tilt_control_stop_exception_pls_check_the_device:
    "设备云台控制停止异常，请检查设备",
  device_password: "设备密码",
  device_playback_streaming_failed: "设备播放推流失败",
  device_preset_control_exception_pls_check_the_device:
    "设备预置位控制异常，请检查设备",
  device_preset_deletion_exception_pls_check_the_device:
    "设备预置位删除异常，请检查设备",
  device_ptz_control_start_failed_pls_check_the_device:
    "设备云台控制启动异常，请检查设备",
  device_reboot: "设备重启",
  device_rebooted_successfully: "设备重启成功",
  device_rebooting_pls_wait: "设备重启中，请耐心等待",
  device_registration_save_error: "设备注册保存出错",
  device_registration_save_error_pls_check_if_the_device_and_chann:
    "设备注册保存出错，请检查设备及信道信息是否正确",
  device_sdk_invocation_error: "设备SDK调用错误",
  device_searching: "设备搜索中",
  device_service_read_failed_pls_disconnect_and_reconnect:
    "设备服务读取失败，请断开后重新连接",
  device_status: "设备状态",
  device_status_left: "设备状态（左）",
  device_status_right: "设备状态（右）",
  device_type: "设备类型",
  device_username: "设备用户名",
  device_ver: "设备版本",
  device_view: "设备视图",
  device_wifi_has_been_modified_manual_device_restart_required_for:
    "设备wifi已修改，手动重启设备后生效",
  diagonal_flip: "对角翻转",
  dialog_box: "对话框",
  dictionary_label: "字典标签",
  dictionary_name: "字典名称",
  digital_camera: "数码相机",
  digital_camera_exception: "可见光相机异常",
  digital_camera_information: "可见光相机信息",
  dimension: "尺寸",
  diopter_adjustment_range: "视度调节范围",
  directory: "目录",
  directory_name: "目录名称",
  direct_switching: "直接切换",
  dirty_chicken_cage_alarm: "鸡笼脏污",
  disable: "停用",
  disabled_successfully: "禁用成功",
  disable_audio: "关闭声音",
  disable_img_super_resolution: "关闭图片超分",
  disable_img_super_resolution_and_reboot: "是否关闭图片超分，重启生效",
  disable_ipc_popup: "关闭IPC弹窗",
  disable_panor_popup: "关闭全景弹窗",
  disable_popup: "禁用弹窗",
  disable_successful: "关闭成功",
  disable_super_resolution_and_reboot: "是否关闭超分，重启生效",
  disagree: "不同意",
  disaster: "灾难",
  disconnect: "断开",
  disconnected: "连接已断开",
  discount_amount: "折扣金额",
  disk_offline: "硬盘离线",
  display: "显示",
  display_brightness: "屏幕亮度",
  display_order: "显示排序",
  display_order_cannot_be_empty: "显示排序不能为空",
  display_resolution: "显示器分辨率",
  display_settings: "显示设置",
  display_time: "时间显示",
  disposal_advice: "处置意见",
  disposal_advice_cannot_be_empty: "处置意见不能为空",
  disposal_advice_should_not_exceed_100_characters: "处置意见字数不超过100字",
  disposal_status: "处置状态",
  distance: "距离",
  distance_cost: "里程费用",
  distance_from_origin: "距原点距离",
  distance_from_origin_cannot_be_empty: "距原点距离不能为空",
  distance_from_origin_meters: "距原点距离（米）",
  distance_from_origin_should_be_a_non_negative_number: "距原点距离为非负数",
  distance_is_out_of_range: "距离超出范围",
  distance_is_required: "距离不能为空",
  distance_price: "里程单价",
  distance_unit: "距离单位",
  distance_value: "距离值",
  diving_support_vessel: "潜水作业船",
  dmc: "电子罗盘",
  does_not_support_low_energy_bluetooth: "不支持低功耗蓝牙",
  dont_have_an_account: "还没有账号",
  dont_have_an_account_yet: "还没有账号？",
  down: "下",
  download: "下载",
  downloaded: "已下载",
  downloading: "下载中",
  download_center: "下载中心",
  download_completed: "完成下载",
  download_completed_pls_check_in_phone_gallery: "下载完成，请到手机相册查看",
  download_exception_pls_try_again_later: "下载异常，请稍后重试",
  download_failed: "下载失败",
  download_failed_items: "下载失败条目",
  download_finish: "下载完成",
  download_firmware: "下载固件",
  download_logs: "下载日志",
  download_management: "下载管理",
  download_path: "下载路径",
  download_start: "下载开始",
  download_success: "下载成功",
  download_success_install_now: "下载完成，立即安装",
  download_template: "下载模板",
  download_the_upgrade_package_to_your_phone: "下载升级包至手机",
  do_not_encode_manually: "请勿自行编码",
  do_not_power_off_during_the_upgrade: "设备升级中，请勿断电",
  do_not_remind_again: "不再提醒",
  do_you_want_to_del: "确定移除任务吗？",
  do_you_want_to_logout: "确定注销吗？",
  do_you_want_to_overwrite_this_file: "是否覆盖该文件",
  do_you_want_to_upgrade_to: "是否要升级为",
  drag_model: "阻力模型",
  draw_temp_ellipse: "绘制测温椭圆形",
  dredging_or_subsea_ope_ship: "挖掘或水下作业船",
  drone: "无人机",
  dual_spectrum_fusion_registration: "双光融合配准",
  dual_spectrum_registration: "双光配准设置",
  duplicated_group_name_pls_rename: "分组名称与已有的重复，请重新命名",
  duplicated_patrol_name_pls_rename: "轮巡名称与已有的重复，请重新命名",
  duplicated_view_name_pls_rename: "视图名称与已有的重复，请重新命名",
  duplicate_area: "区域重复",
  duplicate_domain_value: "域值重复",
  duplicate_field_value: "字段值重复",
  duplicate_name: "名称重复",
  duplicate_resource_name_as_in_the_0th_row: "和第{0}行资源名称重复",
  duplicate_resource_name_as_in_the_2nd_row: "和第2行资源名称重复",
  duplicate_task_name: "任务名称重复",
  duplicate_template_name: "模板名称重复",
  duplication_file_name: "文件名重复",
  duration: "时长",
  duration_for_ai_recognition_frame_extraction: "AI识别取帧时长",
  during_the_acquisition_of_device_io_channel_information_if_there:
    "设备IO通道信息获取中，如超过5分钟无数据，请与设备厂商或技术支持联系。",
  dwell_time: "停留时间",
  d_view: "3D视图",
  each_page: "每页",
  east_northeast: "东偏北",
  east_southeast: "东偏南",
  edit: "编辑",
  edit_address: "编辑地址",
  edit_associated_group: "编辑关联组",
  edit_inspection_actions: "巡检动作编辑",
  edit_integrated_judgment_rules: "编辑综合研判规则",
  edit_manufacturer: "编辑厂商",
  edit_patrol: "编辑轮巡",
  edit_report_conclusions: "编辑报告结论",
  edit_shielded_area: "编辑屏蔽区域",
  egg_laying_chicken_customer_administrator: "蛋鸡客户管理员",
  egg_production: "产蛋",
  egg_production_analysis: "产蛋分析",
  egg_production_count: "产蛋数统计",
  egg_production_rate: "产蛋率",
  egg_production_rate_statistics: "产蛋率统计",
  egg_production_statistics: "产蛋情况统计",
  electric: "电力",
  electric_ceramies: "电瓷",
  elevating_inspection: "升降巡检",
  email: "邮件",
  email_address_cannot_be_empty: "邮箱地址不能为空",
  email_cannot_be_empty: "邮箱不能为空",
  email_server_account: "邮件服务器账户",
  email_server_ip: "邮件服务器IP",
  email_server_password: "邮件服务器密码",
  email_server_port: "邮件服务器端口",
  email_server_settings: "邮件服务器设置",
  emap: "电子地图",
  emap_module: "电子地图模块",
  emergency_event: "紧急事件",
  emergency_event_videos_are_only_stored_on_the_deviceif_you_want_:
    "紧急事件仅存储在设备上，若希望保存至手机，请下载到本地",
  emergency_stop: "急停",
  emergency_stop_status: "急停状态",
  emergency_stop_switch: "急停开关",
  emissivity: "发射率",
  emissivity_is_out_of_range: "发射率超出范围",
  emissivity_is_required: "发射率不能为空",
  empty: "空空如也",
  empty_task_file: "任务文件为空",
  empty_username_or_pwd: "用户名或密码不能为空",
  enable: "生效",
  enabled_successfully: "启用成功",
  enable_audio: "打开声音",
  enable_avg_temp: "显示平均温",
  enable_device_wifi: "打开设备WiFi",
  enable_edge_alarm_bar: "开启侧边报警栏",
  enable_frame: "显示整帧温度",
  enable_gpu: "启用GPU",
  enable_img_super_resolution: "开启图片超分",
  enable_img_super_resolution_and_reboot: "是否开启图片超分，重启生效",
  enable_ipc_popup: "开启IPC弹窗",
  enable_level: "启用级别",
  enable_max_temp: "显示最高温",
  enable_min_temp: "显示最低温",
  enable_opengles: "启用OpenGLES",
  enable_panor_popup: "开启全景弹窗",
  enable_popup: "启用弹窗",
  enable_pwd: "启用密码",
  enable_status: "启用状态",
  enable_successful: "开启成功",
  enable_super_resolution_and_reboot: "是否开启超分，重启生效",
  enable_temp_rise_alarm: "启用温升报警",
  enable_the_device_hotspot_with_which_pair_the_phone_wlan:
    "打开设备热点，将手机无线网络与设备热点配对",
  enable_the_phone_hotspot_with_which_pair_the_device_wlan:
    "打开手机热点，将设备无线网络与手机热点配对",
  enable_zeroing_weather: "启用归零天气",
  encapsulation: "浸渍",
  encoder: "编码设备",
  encryption_type: "加密类型",
  end: "结束",
  ended: "已结束",
  end_action: "结束动作",
  end_date: "结束日期",
  end_date_can_not_be_earlier_than_current_data: "结束日期不能早于当前日期",
  end_date_required: "结束日期不能为空",
  end_multiplier: "结束倍数",
  end_page: "尾页",
  end_time: "结束时间",
  end_time_required: "结束时间不能为空",
  end_tour: "结束巡航",
  end_zoom_speed: "结束变倍速度",
  end_zoom_speed_should_be_lower_than_start_zoom_speed:
    "结束变倍速度要求低于启动变倍速度",
  enforcement_vessel: "执法船",
  english: "英语",
  enlarge: "电子变倍",
  ensure_the_mobile_hotspot_settings_match_the_device:
    "手机热点设置与设备一致；",
  enter_alias: "请输入别名",
  enter_channel_alias_for_filtering: "输入通道别名筛选",
  enter_content_filter: "请输入内容筛选",
  enter_latitude_longitude_eg_27658_120255:
    "输入纬度,经度(例如:27.658,120.255)",
  enter_password_to_unlock: "输入密码以解锁",
  enter_the_wifi_settings_of_the_smartphone: "进入手机WiFi设置页面",
  entries_page: "*条/页",
  entry_date: "入栏日期",
  entry_time: "入栏时间",
  env_monitoring: "环控监测",
  env_param: "环境参数",
  "env_temp_alarm_threshold_℃": "环境温度报警阈值(度)",
  env_temp_monitoring: "环境温度监控",
  eos_base_map_management: "周扫底图管理",
  eos_device: "周扫设备",
  eos_name: "周扫名称",
  epidemic_prevention_and_control: "疫情防控",
  epoxy_glass_substrate: "环氧玻璃板",
  equal_to: "等于",
  equipment_channel: "设备通道",
  error: "错误",
  error_device: "设备有误",
  error_in_the_0_row: "第{0}行错误",
  error_in_the_1st_row: "第1行错误",
  error_in_video_file: "录像文件出错",
  error_prompt: "错误提示",
  estimated_execution_time: "预计执行时间",
  estimated_weight_of_pigs: "猪只估重",
  evaluate: "待评价",
  event: "事件",
  event_alarm_config: "业务报警配置",
  event_alarm_data: "业务报警数据",
  event_alarm_linkage: "业务报警联动",
  event_alarm_settings: "业务报警设置",
  event_alarm_statistics_sending_settings: "业务报警统计发送设置",
  event_alarm_subscription: "业务报警订阅",
  event_alarm_template_number: "业务报警模板编号",
  event_alarm_voice_settings: "业务报警语音设置",
  event_does_not_exist: "事件不存在",
  event_handle: "事件处理",
  event_level: "事件级别",
  event_linkage: "事件联动",
  event_linkage_is_already_added_for_the_device_source:
    "设备源已经添加事件联动",
  event_record_does_not_exist: "事件记录不存在",
  event_type: "事件类型",
  every_day: "每天",
  every_hour: "每一小时",
  every_six_hours: "每六小时",
  every_three_hours: "每三小时",
  every_twelve_hours: "每十二小时",
  every_twenty_four_hours: "每二十四小时",
  every_two_hours: "每两小时",
  example_set_from_1800_to_600_meaning_enable_from_600_pm_to_600_a:
    "例：设置18点-6点，即下午18点到次日6点开启",
  excavator: "挖掘机",
  exceptional: "是否异常",
  execute: "执行",
  execute_immediately: "立即执行",
  execution_frequency: "执行频率",
  execution_method: "执行方式",
  execution_strategy: "执行策略",
  exercise_caution: "谨慎操作",
  exit: "退出登录",
  exited: "已退出",
  exiting_pls_wait: "正在关闭",
  exiting_will_disable_the_alarm_linkage: "退出后会关闭报警联动",
  exit_successful: "退出成功",
  exit_system: "退出系统",
  expiration_time: "过期时间",
  expired: "已失效",
  export: "导出",
  exporting: "导出中",
  export_all_reports: "导出全部报告",
  export_all_rules: "导出全部规则",
  export_as_fvms_player_format: "导出为FVMS Player格式",
  export_as_fvms_specific_format_only_playable_with_fvms_player:
    "导出FVMS特定格式，仅可使用FVMS Player播放器播放。",
  export_as_media_format: "导出为媒体格式",
  export_as_vis_3000_player_format: "导出为VIS-3000 Player格式",
  export_as_vis_3000_specific_format_only_playable_with_vis_3000_p:
    "导出VIS-3000特定格式，仅可使用VIS-3000 Player播放器播放。",
  export_curve: "导出曲线",
  export_data: "数据导出",
  export_failed: "导出失败",
  export_information: "导出信息",
  export_media_format_files_such_as_mkv_mp4_etc_which_can_be_playe:
    "导出Mkv、MP4等媒体格式文件，可使用本地播放器播放。",
  export_report: "导出报告",
  export_report_successfully: "导出报表成功",
  export_success: "导出成功",
  export_table: "导出报表",
  export_temp: "导出温度数据",
  export_template: "导出模板",
  export_time: "导出时间",
  export_user_files: "导出用户文件",
  export_video: "导出视频",
  export_video_failed: "导出视频失败",
  export_video_success: "导出视频成功",
  external_network: "外网",
  external_network_address_settings: "外网映射地址设置",
  ext_connect_dev_online_ratio: "外联设备在线比例",
  e_mail: "邮箱",
  face_capture: "人脸抓拍",
  face_img_path: "人脸图片路径",
  factory_reset: "恢复出厂",
  factory_reset_failed: "恢复出厂设置失败",
  factory_reset_succeeded: "恢复出厂设置成功",
  fahrenheit: "华氏度",
  failed: "失败",
  failed_to_add_belonging_map_has_been_deld: "新增失败，所属地图已被删除",
  failed_to_add_device_pls_confirm_the_connection_is_normal:
    "添加设备失败，请确认网络是否正常",
  failed_to_add_inf_temp_measurement_area: "添加红外测温区域失败",
  failed_to_add_preset: "添加预置位失败",
  failed_to_add_role_name_already_exists: "新增失败，角色名称已存在",
  failed_to_add_role_permis_already_exist: "新增失败，角色权限已存在",
  failed_to_add_template: "添加模板失败",
  failed_to_be_deleted_pls_plug_and_unplug_sd_card:
    "部分文件删除失败,请重新插拔SD卡",
  failed_to_create_facial_recognition_database: "人脸库创建失败",
  failed_to_create_new_inspection_point_duplicate_point_name:
    "新建巡检点失败，点位名称重复",
  failed_to_create_upgrade_file: "建立升级文件失败",
  failed_to_del_data_in_cloud: "从云平台删除失败",
  failed_to_del_inf_temp_measurement_area: "删除红外测温区域失败",
  failed_to_del_inspection_point: "删除巡检点失败",
  failed_to_del_map_associated_with_inspection_template:
    "地图关联巡检模板，删除失败",
  failed_to_del_map_point_associated_with_inspection_task:
    "地图点位关联巡检任务，删除失败",
  failed_to_del_map_point_associated_with_inspection_template:
    "地图点位关联巡检模板，删除失败",
  failed_to_del_preset: "删除预置位失败",
  failed_to_del_template: "删除模板失败",
  failed_to_exchange_templates: "交换模板失败。",
  failed_to_export_alarm_records: "导出报警记录失败",
  failed_to_get_canvas: "获取画布失败",
  failed_to_get_certificate_information: "获取证书信息失败",
  failed_to_get_inf_temp_measurement_area: "获取红外测温区域失败",
  failed_to_get_points_network_connection_abnormal:
    "拉取点位失败，网络连接异常",
  failed_to_get_preset_patrol_plan: "获取预置位巡航计划失败",
  failed_to_get_scan_patrol_plan: "获取扫描巡航计划失败",
  failed_to_get_template_list: "获取模板列表失败",
  failed_to_get_the_first_alarm_event: "获取首个报警事件失败",
  failed_to_get_the_upgrade_status_pls_check_the_device_connection:
    "获取升级状态失败，请确认设备连接是否正常",
  failed_to_get_video_information_pls_retry: "获取视频信息失败，请重试",
  failed_to_invoke_preset: "调用预置位失败",
  failed_to_invoke_wiper: "调用雨刷失败",
  failed_to_modify_email_account_already_exists: "修改失败，邮箱账号已存在",
  failed_to_modify_mute_notifications: "修改免打扰失败",
  failed_to_modify_phone_number_already_exists: "修改失败，手机号码已存在",
  failed_to_modify_push_switch: "修改推送开关失败",
  failed_to_modify_role_name_already_exists: "修改失败，角色名称已存在",
  failed_to_modify_role_permis_already_exist: "修改失败，角色权限已存在",
  failed_to_modify_template: "修改模板失败",
  failed_to_obtain_location: "未能获取地点",
  failed_to_obtain_the_certificate_pls_contact_the_administrator:
    "获取证书失败，请联系管理员",
  failed_to_obtain_the_machine_code_pls_contact_the_administrator:
    "获取机器码失败，请联系管理员",
  failed_to_play_audio: "播放音频失败",
  failed_to_play_pls_refresh_and_reload: "播放失败，请刷新重新加载",
  failed_to_query_recording_plan: "查询录像计划失败",
  failed_to_rename: "重命名失败",
  failed_to_retrieve_address: "获取地址失败",
  failed_to_retrieve_channel_information: "获取通道信息失败",
  failed_to_retrieve_location_information: "获取定位信息失败",
  failed_to_retrieve_navigation_device_information: "获取导航设备信息失败",
  failed_to_retrieve_recording_plan: "获取录像计划失败",
  failed_to_retrieve_upgrade_information: "获取升级信息失败",
  failed_to_retrieve_upgrade_status_pls_check_if_the_device_is_con:
    "获取升级状态失败，请检查设备是否连接",
  failed_to_save_blind_element_settings: "盲元设置保存失败",
  failed_to_save_img: "保存照片失败",
  failed_to_set_auto_time_sync_pls_contact_administrator:
    "设置自动同步时间失败，请联系管理员",
  failed_to_set_manual_time_sync_the_reason_for_failure_is_an_inva:
    "设置手动同步时间失败，失败原因是无效的日期，请重新输入正确的日期",
  failed_to_set_parameters_for_inf_temp_measurement_area:
    "设置红外测温区域参数失败",
  failed_to_set_template: "设置模板失败",
  failed_to_start_analysis: "开始分析失败",
  failed_to_stop_rangefinding: "停止测距失败",
  failed_to_update_bullet_library: "子弹库更新失败",
  failed_to_update_firearm_library: "枪支库更新失败",
  failed_to_update_fire_severity: "火情等级更新失败",
  failed_to_update_inspection_point: "更新巡检点失败",
  failed_to_update_manufacturer_library: "厂商库更新失败",
  failed_to_update_sight_library: "瞄镜库更新失败",
  fail_to_send_pls_update_again: "发送次数失败,请重新更新",
  false_alarm: "误报",
  false_alarm_shielding: "误报屏蔽",
  far_focus: "远焦",
  fast: "快放",
  fast_forward: "快进",
  fast_play_speed: "快速回放速度",
  fattening_pig_customer_administrator: "育肥猪客户管理员",
  fault: "故障",
  favorite: "我的收藏",
  favorites: "收藏",
  feather: "羽",
  feathers: "*羽",
  feb: "二月",
  febrile_pigs: "发烧猪",
  feedback: "意见反馈",
  feeder: "食槽",
  feeder_analysis: "食槽分析",
  fee_mode: "计费模式",
  female: "女",
  file_already_exists: "文件已存在",
  file_downloading_pls_wait: "文件下载中，请等待",
  file_format: "文件格式",
  file_format_error_pls_upload_img_types_such_as_jpg_or_png:
    "文件格式错误，请上传图片类型,如：JPG，PNG后缀的文件。",
  file_format_validation_failed: "文件格式校验失败",
  file_library: "文件库",
  file_name: "文件名称",
  file_name_is_required: "文件名不能为空",
  file_name_should_not_contain_special: '文件名不支持*<>|\\`":.?/',
  file_not_found: "文件不存在",
  file_not_found_pls_confirm_device:
    "未搜索到文件，请确定已连接设备并且设备sd卡正常插入",
  file_path: "文件路径",
  file_saving_period: "文件保存天数",
  file_saving_period_can_not_be_empty: "文件保存天数不能为空",
  file_size: "文件大小",
  file_type: "文件类型",
  file_upload_failed_pls_check_ftp_server_config:
    "文件上传失败，请检查ftp服务器配置",
  file_upload_size_cannot_exceed_200mb: "上传文件大小不能超过200MB!",
  file_verification_failed_pls_replace_the_upgrade_file_or_re_impo:
    "文件校验失败，请更换升级文件或重新导入",
  filter: "滤波",
  filter_criteria: "筛选条件",
  filter_false_alarm: "误报过滤",
  filter_time: "过滤时间",
  find: "查找",
  fine_tuning: "微调",
  fingerprint: "指纹",
  finished: "已完成",
  fire: "火灾",
  firearm_information: "枪支信息",
  firearm_list: "枪支列表",
  firearm_name_already_exists_pls_edit_again: "枪支名称已存在，请重新编辑",
  fire_alarmfa: "火情告警",
  fire_area: "火情面积",
  fire_behavior_change_thermal: "火势变化(热成像)",
  fire_detection: "火点检测",
  fire_extinguished: "火已扑灭",
  fire_info: "火点信息",
  fire_level_cannot_be_empty: "火情等级不能为空",
  fire_location: "火点位置",
  fire_point_altitude: "火点海拔",
  fire_point_coordinates: "火点坐标",
  fire_recognition_algorithm_visible: "火识别算法(可见光)",
  fire_setting: "火灾设置",
  fire_severity: "火情等级",
  fire_status: "火情状态",
  fire_type: "火灾类型",
  firmware: "固件",
  firmware_transfer_requires_phone_to_be_connected_to_the_devices_:
    "传输固件需确保手机连接至设备WiFi网络",
  firmware_update: "固件更新",
  firmware_upgrade: "固件升级",
  firmware_version: "固件版本",
  firmware_ver_is_low_pls_upgrade_to_the_latest_ver:
    "固件版本低，请升级至最新版本",
  first_execution_time: "首次执行时间",
  first_login_pls_change_your_password: "初次登录，请修改您的密码",
  fishing_boat: "渔船",
  five_minutes: "5分钟",
  flip: "翻转",
  flower_blue: "花青",
  focal_length: "焦距",
  focus: "聚焦",
  fold: "折叠",
  folder: "文件夹",
  font: "字体",
  font_color: "字体颜色",
  font_setting: "字体设置",
  font_size: "字体大小",
  forest_fire: "森林火灾",
  forest_fire_alarm_merge_rule_settings: "森林防火报警合并规则设置",
  forest_fire_false_alarm_filtering_rule_settings: "森林防火误报过滤规则设置",
  forest_fire_integrated_judgment_rule_settings: "森林防火综合研判规则设置",
  forest_fire_intelligent_judgment_rule_settings: "森林防火智能研判规则设置",
  forest_fire_intelligent_judgment_switch_settings: "森林防火智能研判开关设置",
  forest_fire_overview: "林火一张图",
  forest_fire_prevention: "森林防火",
  forest_green: "丛林绿",
  forgot_pwd: "忘记密码",
  format_sd_card: "格式化SD卡",
  format_success: "格式化成功",
  forsale: "上架",
  for_rent: "待租赁",
  for_the_alarm_rule_of_high_temp_greater_than_the_alarm_level_tem:
    "报警规则为高温大于时，报警等级温度应逐级增高",
  four_windows: "四个视窗",
  fov: "视场角",
  fpa_temp: "FPA温度",
  fps: "帧频",
  fpv: "FPV",
  frames_with_ai_recognition_confidence_equal_to_or_less_than_this:
    "单帧AI识别可信值小于等于该阈值将被认为：图像帧指定位置非识别对象",
  frame_range: "帧范围",
  frame_rate: "帧率",
  frame_rate_setting: "帧率设置",
  frame_temp: "整帧温度",
  free_shipping: "免运费",
  french: "法语",
  frequency: "频率",
  friday: "周五",
  front_of_the_car: "车头",
  front_radar: "前雷达",
  front_radar_exception: "前雷达异常",
  front_radar_information: "前雷达信息",
  ft: "英尺",
  ftp_connection: "FTP连接",
  ftp_service_error_pls_quit_and_login_again:
    "FTP服务异常，请尝试退出后重新登录",
  ftp_settings: "FTP设置",
  full_frame: "整帧",
  full_region_name: "区域全名",
  full_region_name_is_required: "区域全名不能为空",
  full_screen: "全屏",
  function: "功能",
  function_authority: "功能权限",
  function_name: "功能名称",
  fuse: "融合",
  fuse_mode: "融合模式",
  fusion_ratio: "融合比例",
  gain_mode: "增益模式",
  gallery: "素材库",
  galvanized_bright_iron_plate: "镀锌亮铁板",
  gas_concentration: "气体浓度",
  gas_detection_mode: "气体检测档位",
  gas_enhancement: "气体增强",
  gas_parameter_settings: "气体参数设置",
  gas_sensor: "气体传感器",
  gas_sensor_information: "气体传感器信息",
  gas_sensor_malfunction: "气体传感器异常",
  gateway: "网关",
  gear_shifting_in_progress_pls_try_again_later: "档位切换中，请稍后再试",
  gender: "性别",
  general: "通用",
  general_prompt: "常规提示",
  geographical_location_info_not_obtained_yet: "暂未获取地理位置信息",
  german: "德语",
  get_array_size_failed: "获取阵列规模失败",
  get_atmospheric_temp_failed: "获取环境温度失败",
  get_brightness_failed: "获取亮度失败",
  get_contrast_failed: "获取对比度失败",
  get_dde_enabled_failed: "获取图像增强使能失败",
  get_dde_failed: "获取图像增强失败",
  get_detector_temp_failed: "获取探测器温度失败",
  get_distance_failed: "获取距离失败",
  get_emissisivity_failed: "获取发射率失败",
  get_encryption_type_failed: "获取加密类型失败",
  get_filter_enabled_failed: "获取滤波使能失败",
  get_from_compass: "从指南针获取",
  get_from_gps: "从GPS获取",
  get_gain_mode_failed: "获取增益模式失败",
  get_image_flip_failed: "获取图像翻转失败",
  get_img_again: "重新获取图片",
  get_measurement_range_failed: "获取测温范围失败",
  get_osd_failed: "获取网板叠加状态失败",
  get_palette_failed: "获取伪彩失败",
  get_parameters: "获取参数",
  get_product_id_failed: "获取产品序列号失败",
  get_product_number_failed: "获取产品编号失败",
  get_product_temp_failed: "获取产品温度失败",
  get_reflected_temp_failed: "获取反射温度失败",
  get_the_price_after_login_auth: "登录认证后获取价格",
  get_transmittance_failed: "获取透过率失败",
  get_weather: "获取天气",
  glass_surface: "玻璃(面)",
  global: "全局",
  going: "进行中",
  gold_plated_copper: "镀金铜片",
  got_it: "我知道了",
  go_here: "去这里",
  go_to: "转到",
  go_to1: "前往",
  go_to_enable: "去开启",
  go_to_page_: "前往*页",
  go_to_settings: "去设置",
  go_to_wifi_settings_on_the_phone: "进入手机wifi设置",
  gps_malfunction: "GPS故障",
  gps_status: "GPS状态",
  gps_status_display: "GPS状态显示",
  graphics_card_does_not_suppot: "显卡不支持",
  graphic_details: "图文详情",
  greater_than: "大于",
  green: "绿",
  greenhot: "绿热",
  greenred: "青红",
  green_shades: "渐变绿",
  group: "分组",
  group_buy: "立即参团",
  group_shop: "团购",
  guidance_throughout_product_usage_upgraded_experience_more_fan_b:
    "全程指导产品使用，优享升级体验，更多粉丝福利......",
  h: "时",
  h265_playback_instructions: "h265播放说明",
  handheld_device: "手持设备",
  handheld_mode: "手持模式",
  handheld_online_mode: "手持+在线模式",
  handled_successfully: "处置成功",
  handler: "处置人",
  handle_and_push: "处置并推送",
  handling: "处置",
  handling_result: "处置结果",
  header_title: "页眉标题",
  header_title_setting: "页眉标题设置",
  heads: "*头",
  health: "健康",
  healthy_illumination_threshold: "健康点亮阈值",
  height_rangefinding: "高度测距",
  hello_0_detection_1_triggered_a_fire_alarm_at_2_with_an_alarm_le:
    "您好，{0}检测{1}在{2}发生火情报警，告警等级为{3}，火点坐标为{4}",
  help: "帮助",
  hide: "隐藏",
  hierarchical_alarm_information_shielding: "分级报警信息屏蔽",
  high: "高",
  highlight: "凸显",
  highlight_type: "凸显类型",
  high_frequency: "高频",
  high_gain: "高增益",
  high_highlight: "高温凸显",
  high_speed_vessel: "高速船",
  high_temp: "高温阈值",
  high_temperature: "高温",
  high_temperature_low_temperature: "高温温度值需大于低温温度值",
  high_temp_equal_to: "高温等于",
  high_temp_mode: "高温档",
  high_temp_value: "高温值",
  hikvision: "海康",
  histogram: "直方图",
  historical_data: "历史数据",
  ho: "高温设置",
  home_page: "首页",
  horizontal: "水平",
  horizontal_angle: "水平角",
  horizontal_angle_offset: "水平角偏移量",
  horizontal_click_value: "水平咔哒刻度",
  horizontal_mounting_angle: "安装水平角",
  horizontal_right_left: "水平（右、左-）",
  hot_iron: "热铁",
  hot_sale: "热销产品",
  hot_spot: "热点追踪",
  hours: "小时",
  hour_ago: "小时前",
  house_name_must_be_numbers_or_chinese_characters_and_no_longer_t:
    "舍位名称格式为数字或中文，且长度不超过20",
  hovercraft: "地效应船",
  how_to_connect_the_device: "如何连接设备",
  human: "人",
  humidity: "湿度",
  humidity_cloud_map: "湿度云图",
  humidity_rh: "湿度(%RH)",
  humidity_sensor_status: "湿度传感器状态",
  hungarian: "匈牙利语",
  hydrogen_sulfide: "硫化氢",
  ice: "冰",
  icefire: "冰火",
  icon: "图标",
  icon_size_limit_5mb: "上传图标大小不能超过5M!",
  identical: "相同",
  identification_distance: "辨认距离",
  idle: "空闲中",
  idle_action: "空闲动作",
  idle_action_trigger_time: "空闲动作触发时间",
  if_either_is_set_to_blank_no_statistical_notifications_will_be_s:
    "二者任意设置为空时，不会发送统计通知",
  if_the_above_steps_are_correct_you_can_reset_the_wifi_and_reconn:
    "若上述均排查无误，可通过将音量调到最大值后，连续点击5次音量+键的方式，重置WIFI，重新连接。",
  if_the_black_body_temp_is_30_the_set_temp_is_300:
    "如黑体温度30度，需设置温度为300度",
  if_the_device_is_not_connected_for_a_long_time_you_can_try_the_f:
    "如果设备长时间未连接，可尝试以下方法排查：",
  if_the_ratio_of_the_total_number_of_frames_recognized_to_the_num:
    "识别到指定对象单帧总数/取帧数的比例小于等于该阈值将被认为：过程中无识别对象",
  if_the_robot_is_currently_performing_a_patrol_task_one_key_retur:
    "若机器人当前有正在执行的巡检任务，一键回桩会使当前巡检任务异常结束",
  if_you_confirm_the_ope_the_download_will_be_terminated_after_the:
    "确认操作将终止下载任务，修改后需要重新连接设备WiFi",
  if_you_want_to_add_new_alarms_and_alarm_sources_for_already_set_:
    "已设置人员如果要添加新报警和报警源，请在修改页面设置",
  if_you_want_to_add_new_alarms_and_linkage_actions_for_already_se:
    "已设置报警源如果要添加新报警和联动动作，请在修改页面设置",
  ignore_aspect_ratio: "忽略纵横比",
  illegal_region_name: "非法区域名称",
  illegal_role_name: "角色名称非法",
  illuminator: "补光灯",
  image: "图片",
  image_adjust: "图像调节",
  image_analysis: "图片分析",
  image_capture: "拍照",
  image_flip: "图像翻转",
  image_fusion: "图像融合",
  image_mode: "图片模式",
  imgs_for_ai_recognition_will_be_extracted_within_the_specified_d:
    "用于AI识别的图像将从触发时刻附近的指定时长内提取",
  img_brightness: "图像亮度",
  img_captured_successfully_pls_check_in_the_phone_gallery:
    "拍照成功，请到手机相册中查看",
  img_capture_failed: "拍照失败",
  img_capture_succeeded: "拍照成功",
  img_contrast: "图像对比度",
  img_loading_failed: "图片加载失败",
  img_offset: "图像偏移量",
  img_preview: "图片预览",
  img_saved_successfully: "图片保存成功",
  img_save_failed: "图片保存失败",
  img_stabilization: "稳像",
  img_upload_failed_pls_contact_the_administrator: "上传图片异常，请联系管理员",
  img_viewing: "图片查看",
  imix: "细节增强",
  imix_mode: "细节增强模式",
  imo_code: "国际海事组织编码",
  impor: "导入",
  importing: "导入中",
  importing_closing_will_stop_the_import_process:
    "导入中，关闭将会停止导入信息",
  import_all_rules: "导入全部规则",
  import_authorization_certificate: "导入授权证书",
  import_by_cage: "按笼导入",
  import_by_column: "按列导入",
  import_by_map: "按地图导入",
  import_failed: "导入失败",
  import_img: "导入图片",
  import_logo: "导入Logo",
  import_method: "导入方式",
  import_points: "导入点位",
  import_status: "导入状态",
  import_success: "导入成功",
  import_template: "导入模板",
  imu_anomaly: "imu异常",
  imu_information: "imu信息",
  incomplete_device_information_retrieval: "获取设备信息不完整",
  incomplete_request_parameters_pls_check_if_devid_starttime_endti:
    "请求参数不完整，请检查是否设置了devId, startTime, endTime",
  incorrect_cage_columns_format: "鸡笼列数格式错误",
  incorrect_cage_layers_format: "鸡笼层数格式错误",
  incorrect_cage_rows_format: "鸡笼行数格式错误",
  incorrect_email_format: "邮箱格式不正确",
  incorrect_import_img_format: "导入图片格式不正确",
  incorrect_input: "输入有误",
  incorrect_latitude_format: "纬度格式不对",
  incorrect_longitude_format: "经度格式不对",
  incorrect_menu_route_format_format_should_be_sys_menu:
    "菜单路由格式错误，格式为：/sys/menu",
  incorrect_number_of_common_channels_or_abnormal_channel_status_p:
    "普通通道数量不正确或者通道状态异常，请检查设备配置",
  incorrect_number_of_eos_channels_or_abnormal_channel_status_pls_:
    "周扫通道数量不正确或者通道状态异常，请检查设备配置",
  incorrect_original_pwd: "原密码错误",
  incorrect_or_expired_verification_code: "验证码错误或已过期",
  incorrect_password_entered: "输入的密码有误",
  incorrect_phone_number_format: "联系电话格式输入错误",
  incorrect_phone_number_or_password: "手机号或密码错误",
  incorrect_resource_name_format: "资源名称格式不对",
  incorrect_user_type: "用户类型错误",
  incorrect_verification_code: "验证码错误",
  independent_report: "独立报告",
  index_mode: "索引模式",
  individual_analysis_for_atp_device: "ATP设备只能单独分析",
  info: "信息",
  infrared_flashlight: "红外手电",
  inf_camera_abnormal: "红外相机异常",
  inf_enhancement: "红外增强",
  inf_full_frame_temp_data: "红外整帧温度数据",
  inf_light: "红外光",
  inf_malfunction: "红外故障",
  inf_panoramic_eos_360: "周扫",
  inf_panoramic_eos_360_nvr: "周扫NVR",
  inf_polarity: "红外极性",
  inf_pseudo_color: "红外伪彩",
  inf_pseudo_color_enabled_successfully_effective_in_inf_fusion_im:
    "红外伪彩切换成功，需在红外/融合图像模式下生效",
  inf_scenarios: "红外场景",
  inf_snapshot: "红外抓图",
  inf_temp_measurement_area_exceeds_limit: "红外测温区域超出限制",
  inf_visible_light_split_screen: "红外-可见光分屏",
  initialization_point: "初始化点",
  initiate_closure: "主动关闭",
  input_information_is_illegal_pls_correct_it: "输入信息非法,请纠正!",
  input_the_new_password_again: "再次输入新密码",
  insert_sd_card_or_restart_the_device: "请插入sd卡或重启设备",
  inspected: "已巡检",
  inspected_points: "已巡检点位",
  inspection_actions: "巡检动作",
  inspection_anomaly: "巡检异常",
  inspection_completed: "巡检完成",
  inspection_count: "巡检次数",
  inspection_failed: "巡检失败",
  inspection_in_progress: "巡检中",
  inspection_method: "巡检方式",
  inspection_point: "巡检点",
  inspection_point_order: "巡检点顺序",
  inspection_point_result: "巡检点结果",
  inspection_progress: "巡检进度",
  inspection_results: "巡检结果",
  inspection_result_report: "巡检结果报告",
  inspection_result_storage_time: "巡检结果存储时间",
  inspection_robot: "巡检机器人",
  inspection_status: "巡检状态",
  inspection_tasks: "巡检任务",
  inspection_task_abnormality_points_completed_points_remaining_un:
    "巡检任务异常，已完成*点，剩余*个点未执行",
  inspection_task_exception_completed_point_count:
    "巡检任务异常，已完成点位数：",
  inspection_task_issued_but_the_robot_did_not_respond:
    "巡检任务下发后机器人边端未响应",
  inspection_task_is_being_started_pls_wait: "巡检任务开启中,请稍候",
  inspection_task_start_time_cannot_be_earlier_than_3_minutes_from:
    "巡检任务开始时间不能早于当前时间3分钟",
  inspection_template: "巡检模板",
  inspection_type: "巡检类型",
  install: "安装",
  installation_position: "安装位置",
  installing: "正在安装",
  install_failed_click_to_install_again: "安装失败，点击重新安装",
  install_firmware: "安装固件",
  install_now: "立即安装",
  install_on_non_system_disk_or_run_as_administrator:
    "请将软件安装在非系统盘或以管理员权限运行此软件",
  install_success_click_to_restart: "安装完毕，点击重启",
  instruction_issued_successfully: "指令下发成功",
  insufficient_device_battery_level: "设备电池电量不足",
  insufficient_device_space: "设备空间不足",
  insufficient_disk_pls_clean: "磁盘空间不足，请清理磁盘",
  insufficient_disk_space: "硬盘不足",
  insufficient_memory: "内存不足",
  insufficient_storage_space_alarm: "存储空间不足报警",
  insulation_sheet: "绝缘片",
  integrated_judgment_switch_settings: "综合研判开关设置",
  intelligent_analysis: "智能研判",
  intelligent_analysis_level: "智能研判等级",
  intelligent_analysis_result: "智能研判结果",
  intelligent_application: "智能应用",
  intelligent_import: "智能导入",
  intelligent_import_successful: "智能导入成功",
  interface_access_failed: "接口访问失败",
  interface_access_timeout: "接口访问超时",
  internal: "时间间隔",
  interpupillary_distance_adjustment_range: "瞳距调节范围",
  interval: "间隔",
  interval_period_days: "间隔周期（天）",
  intg_assess_settings: "综合研判设置",
  introduction: "简介",
  invalid_atmospheric_temp: "环境温度无效",
  invalid_distance: "距离无效",
  invalid_email_address: "邮箱输入不合法",
  invalid_emissivity: "发射率无效",
  invalid_ftp_connection: "FTP服务连接已失效",
  invalid_ip: "输入的ip不合法",
  invalid_ip_address: "ip地址不合法",
  invalid_ip_or_mac_address: "ip或mac地址不合法",
  invalid_mac_address: "mac地址不合法",
  invalid_recording_plan_id: "无效的录像计划id",
  invalid_reflected_temp: "反射温度无效",
  invalid_transmittance: "透过率无效",
  invalid_user: "不合法用户",
  inventory: "库存",
  inventory_analysis: "盘点分析",
  in_auto_mode_now_pls_switch_to_other_modes_for_calibration:
    "当前自动档，请切换至其他档位进行标定！",
  in_extreme_cases_pls: "极端情况请",
  in_progress: "执行中",
  in_statistics: "统计中",
  in_stock: "库存中",
  in_the_device_option_settings_privacy_imgs_pls_allow_this_app_to:
    "请在设备的 设置-隐私-照片 选项中，允许此App访问你的手机相册",
  in_transition: "转换中",
  in_use: "在用",
  iot_device: "物联网设备",
  iot_threshold_settings: "物联阈值设置",
  io_alarm: "IO报警",
  io_alarm_name: "IO报警名称",
  io_channel: "IO通道",
  io_channel_no: "IO通道编号",
  io_device: "IO设备",
  io_linkage: "联动IO",
  io_settings: "IO设置",
  io_status: "IO设备状态",
  ipc_event_popup: "IPC事件弹窗",
  ipc_popup_switch: "IPC弹窗开关",
  ip_address: "IP地址",
  ip_address_required: "IP地址(必填)",
  ip_already_exists: "IP已存在",
  ip_error: "IP有误",
  ip_information: "IP信息",
  ip_is_required: "IP不能为空",
  ip_or_url: "IP或网址",
  ip_whitelist: "IP白名单",
  ir: "红外",
  iron: "铁红",
  irt_vms: "工业测温监控系统",
  ir_detector: "红外探测器",
  ir_discovery: "睿探",
  ir_farm_tech: "睿牧",
  ir_farm_tech_comprehensive_cloud_platform_all_rights_reserved:
    "睿牧综合云平台版权所有",
  ir_farm_tech_comprehensive_management_cloud_platform: "睿牧综合管理云平台",
  ir_farm_tech_robot_management_cloud_platform: "睿牧机器人管理云平台",
  ir_img: "红外图片",
  ir_mode: "红外模式",
  ir_setting: "红外设置",
  ir_threshold_settings: "红外阈值设置",
  isotherm: "等温线",
  isothermal: "等温带",
  isothermal_setting: "等温带设置",
  isotherm_cannot_be_enabled_in_non_inf_mode: "非红外模式下不允许开启等温线",
  isotherm_cannot_be_enabled_in_white_hot_or_black_hot_mode:
    "白热、黑热伪彩模式下不允许开启等温线",
  isotherm_disabled: "等温线功能已关闭",
  isotherm_off: "等温线：关",
  isotherm_on: "等温线：开",
  isotherm_switch: "等温线开关",
  issue: "下发",
  issued_successfully: "下发成功",
  italian: "意大利语",
  its_empty_here: "这里空空如也",
  it_can_be_expanded_to_more_than_1000_channels_by_re_licensing:
    "可通过重新授权，扩展至1000路以上",
  it_is_recommended_to_input_n1_sets_of_data_or_more_distribute_th:
    "建议输入{n1}组及以上数据，观测目标尽可能分散，最大云台转角差异最好为{n2}度",
  ivs: "算法盒子",
  ivs_box_channel_id: "盒子通道编号",
  i_have_read_and_agree: "我已阅读并同意",
  i_know: "知道了",
  jan: "一月",
  japanese: "日语",
  join_the_company: "加入企业",
  judgment_rule_identifier_cannot_be_empty: "研判规则标识不能为空",
  judg_ch_assoc_plan: "研判通道关联计划",
  judg_rule_settings: "研判规则设置",
  jul: "七月",
  jun: "六月",
  jungle: "丛林",
  just_browsing: "随便逛逛",
  just_now: "刚刚",
  keep_close_to_the_device_and_make_sure:
    "请靠近设备，确保设备已连上手机热点或在一个局域网",
  keep_close_to_the_device_and_select_one:
    "请靠近设备并选择以下任一方式进行设备连接",
  kelvin: "开尔文",
  keywords: "关键字",
  kg_head: "kg/头",
  knight_blue: "骑士蓝",
  knot: "节",
  korean: "韩语",
  language: "语言",
  language_option: "语言选择",
  language_switch_is_valid_after_software_restart: "语言切换重启后生效",
  laser: "激光",
  laser_range_finder: "激光测距仪",
  laser_range_finding: "激光测距",
  lastest_inspection_time: "最近巡检时间",
  last_24_hours: "近24小时",
  last_48_hours: "近48小时",
  last_72_hours: "近72小时",
  last_connection_time: "上次连接时间",
  last_inspection_time: "上次巡检时间",
  last_login_ip: "上次登录IP",
  last_login_time: "上次登录时间",
  last_month: "最近一个月",
  last_occurrence: "最近一次",
  last_seven_days: "近七天",
  last_six_months: "近半年",
  last_three_days: "近三天",
  last_three_months: "最近三个月",
  last_updated_time: "最后更新时间",
  last_week: "最近一周",
  latitude: "纬度",
  latitude_and_longitude: "经纬度",
  latitude_cannot_be_empty: "纬度不能为空",
  latitude_out_of_current_map_area: "纬度超出当前地图区域",
  latitude_required: "纬度(必填)",
  lava: "熔岩",
  layer: "图层",
  layer1: "层*",
  layer_may_exist: "*层疑似存在",
  layer_sel: "图层选择",
  layout: "布局",
  led_alarm: "LED报警",
  led_light_malfunction: "LED灯异常",
  left: "左",
  left_hand_twist: "左旋膛线",
  left_hand_twist_right_hand_twist: "左右膛线",
  left_right_flip: "左右翻转",
  left_side: "左侧",
  left_side_device_status: "左侧设备状态",
  legal_disclaimer: "法律声明",
  length_must_be_between_6_to_20_characters: "长度在 6 到 20 个字符",
  length_must_not_exceed_20_characters: "长度不得超过20个字符",
  lens_config: "镜头配置",
  lens_obstruction: "镜头遮挡",
  lens_offset: "镜头偏移量",
  less_than: "小于",
  level: "级别",
  level1: "一级",
  level2: "二级",
  level3: "三级",
  level4: "四级",
  level_span: "温宽拉伸",
  lift: "升降",
  lifting_height: "升降高度",
  lifting_pole: "升降杆",
  lifting_rod_information: "升降杆信息",
  lifting_strategy: "升降策略",
  lift_control: "升降杆控制",
  lift_rod_anomaly: "升降杆异常",
  lift_to: "升降至",
  light_aluminium_oxide: "轻度氧化铝",
  limited_time: "限时",
  limited_time_shield: "限时屏蔽",
  limited_to_20_characters: "限制20个字",
  limit_of_100_characters: "限制100个字符",
  line: "线",
  line_chart: "折线图",
  line_number_reach_limit: "线测温数量达到上限",
  linkage: "联动",
  linkage_channel: "联动通道",
  linkage_control: "联动控制",
  linkage_recording: "联动录像",
  linkage_record_directory: "联动录像路径",
  linkage_record_duration: "联动录像时长",
  linkage_snapshot: "联动抓图",
  linkage_snapshot_directory: "联动抓拍路径",
  linkage_sound: "联动声音",
  linkage_strategy_setting_successful: "联动策略设置成功",
  linked_data_exists_and_deletion_is_not_supported: "存在关联数据，不支持删除",
  linked_devices: "联动设备",
  linked_device_not_set: "未设置联动设备",
  linked_ptz_name: "联动云台名称:",
  link_alarm_refresh: "刷新联动报警",
  link_alarm_refresh_time: "联动报警刷新时间",
  link_snapshot_path: "联动抓图路径",
  live: "实时视频",
  livestock_egg_laying_chickens: "畜牧蛋鸡",
  livestock_fattening_pigs: "畜牧育肥猪",
  livestock_meat_chickens: "畜牧肉鸡",
  live_preview: "实时预览",
  lo: "低温设置",
  loading: "加载中",
  loading_pls_wait: "加载中，请稍候...",
  load_failed: "加载失败",
  load_succeeded: "加载成功",
  local_device: "本地设备",
  local_file: "本地文件",
  local_file_verification_failed: "文件本地校验失败",
  local_import: "本地导入",
  local_platform_code: "本级平台编码",
  local_platform_name: "本级平台名称",
  local_resource: "本地资源库",
  locate_failed_pls_try_again_later: "定位失败，请稍候重试",
  location: "位置",
  location_permi_required: "需要打开定位权限",
  location_permi_required_to_discover_new_devices:
    "需要开启位置权限才能发现新设备",
  location_permi_required_to_obtain_gps_data: "需要开启位置权限才能获取GPS数据",
  lock: "锁定",
  locked: "闭锁",
  lock_failed: "锁定失败",
  lock_robot: "闭锁机器人",
  lock_succeeded: "锁定成功",
  lock_the_robot: "锁定机器人",
  log: "日志",
  login: "登录",
  login_account: "登录账号",
  login_again: "重新登录",
  login_attempts_are_too_frequent_pls_try_again_in_1_minute:
    "登录过于频繁，请1分钟后重试",
  login_expired_pls_log_in_again: "登录过期，请重新登录",
  login_failed: "登录失败",
  login_success: "登录成功",
  logout: "退出",
  logout_successful: "登出成功",
  logo_setting: "Logo设置",
  log_query: "日志查询",
  longitude: "经度",
  longitude_cannot_be_empty: "经度不能为空",
  longitude_out_of_current_map_area: "经度超出当前地图区域",
  longitude_required: "经度(必填)",
  long_distance_pedestrian_warning: "行人远距离报警",
  long_distance_vehicle_warning: "车辆远距离报警",
  loop_task_already_exists: "已存在循环任务",
  low: "低",
  lower_threshold: "阈值下限",
  low_battery: "电池电量低",
  low_battery_alarm: "低电量",
  low_battery_threshold: "低电量阈值",
  low_frequency: "低频",
  low_gain: "低增益",
  low_highlight: "低温凸显",
  low_temp: "低温阈值",
  low_temperature: "低温",
  low_temperature_high_temperature: "低温温度值需小于高温温度值",
  low_temp_equal_to: "低温等于",
  low_temp_mode: "低温档",
  low_temp_value: "低温值",
  l_of_rule_n_cannot_be_empty: "规则{n}的{l}不能为空",
  m: "分",
  machine_code_cannot_be_empty: "机器码不能为空",
  mac_address: "MAC地址",
  mac_whitelist: "MAC白名单",
  magnification: "放大倍数",
  maintenance_due_time: "维护到期时间",
  main_application: "主应用",
  main_stream: "主码流",
  male: "男",
  management: "管理",
  management_and_config: "管理与配置",
  manager: "管理员",
  manual: "手动",
  manual_adjustment: "手动调整",
  manual_analysis_level: "人工研判等级",
  manual_control: "人工控制",
  manual_event: "手动事件",
  manual_events_are_only_stored_on_the_device_if_you_want_to_save_:
    "手动事件仅存储在设备上，若希望保存至手机，请下载到本地",
  manual_excl: "手动剔除",
  manual_focus: "手动调焦",
  manual_follow: "手动跟随",
  manual_layer_labeling: "手动标注图层",
  manual_markup_layer_not_displayed_pls_display_it_in_layer_sel:
    "手动标注图层未展示，请至图层选择处展示该图层",
  manual_mode: "手动模式",
  manual_time_calibration: "手动校时",
  manual_time_sync_set_successfully: "设置手动同步时间成功",
  manufacturer: "生产厂商",
  manufacturer_list: "厂商列表",
  manufacturer_name_already_exists_pls_edit_again: "厂商名称已存在，请重新编辑",
  man_overboard_detection: "落水人员检测",
  map: "地图",
  map_config: "地图配置",
  map_display: "地图展示",
  map_management: "地图管理",
  map_name: "地图名称",
  map_name_cannot_be_empty: "地图名称不能为空",
  map_name_should_consist_of_letters_numbers_or_chinese_characters:
    "地图名称为字母、数字或中文，且长度不超过20",
  map_survey: "地图测绘",
  map_sync_failed_network_connection_abnormal: "地图同步失败，网络连接异常",
  map_update_failed: "地图更新失败",
  map_ver_number_or_point_ver_number_update_failed:
    "地图版本号或者点位版本号更新失败",
  mar: "三月",
  marble: "大理石",
  marker: "标记",
  marking_area: "标面",
  marking_line: "标线",
  marking_point: "标点",
  markup_information: "标注信息",
  material: "材料",
  matte_paint: "非亮漆",
  max: "最高温",
  maximize: "最大化",
  max_10_linkage_channels: "联动通道数量最多为10个",
  max_alarm_data_retention_period: "报警数据最大保存天数",
  max_count_per_cage: "单笼最大次数",
  max_egg_production: "最大产蛋数",
  max_egg_production_rate: "最大产蛋率",
  max_number_of_files_that_can_be_seled: "最多可选择文件个数",
  max_number_of_intelligent_judgment_repetitions: "智能研判最大重复次数",
  max_number_of_intelligent_judgment_repetitions_cannot_be_empty:
    "智能研判最大重复次数不能为空",
  max_number_of_temp_difference_rules_is: "温度差值规则最大数量为",
  max_offset_cannot_be_empty: "最大偏移量不能为空",
  max_offset_m: "最大偏移量(米)",
  max_of_0_resources_allowed_currently_1_resources_exist:
    "资源总数最多{0}条，目前已有{1}条",
  max_of_1000_resources_allowed_currently_1000_resources_exist:
    "资源总数最多1000条，目前已有1000条",
  max_of_8_imgs_are_seled: "最多选择8张图片",
  max_sel_quantity: "最大选择数量",
  max_temp: "最大温度",
  max_temp_big_than: "最高温大于",
  max_temp_big_than_min_temp: "最高温必须大于最低温",
  max_temp_is_required: "最高温不能为空",
  max_temp_less_than: "最高温小于",
  max_time_interval: "最大时间间隔",
  max_time_interval_cannot_be_empty: "最大时间间隔不能为空",
  may: "五月",
  mearge_alarm_export: "合并报警导出",
  measurement: "测量设置",
  measurement_range: "测温范围",
  measure_area: "测面",
  meat_chicken_customer_administrator: "肉鸡客户管理员",
  media_format: "媒体格式",
  media_library: "媒体库",
  medical: "医疗",
  medical_transport_vessel: "医疗运输船",
  medium: "中",
  menu: "设备菜单",
  menu_management: "菜单管理",
  menu_name: "菜单名称",
  menu_permissions: "菜单权限",
  menu_route: "菜单路由",
  menu_url: "菜单URL",
  merge: "合并",
  merge_alarm: "合并报警",
  merge_failed: "合并失败",
  merge_repeated_alarms: "合并重复报警",
  merge_time_interval_s: "合并时间间隔(s)",
  merging: "合并中",
  messagebox: "消息框",
  message_prompt: "消息提示",
  message_push: "消息推送",
  message_queue_exception: "消息队列异常",
  metal: "金属",
  meter: "米",
  methane: "甲烷",
  method_1: "方式一",
  method_2: "方式二",
  method_3: "方式三",
  microphone: "麦克风",
  microservice_invocation_exception: "调用微服务异常",
  middleware_ver: "中间层版本",
  midgrey: "中灰",
  military_opes_vessel: "军事作业船",
  min: "最低温",
  mine: "我的",
  minimize: "最小化",
  minor: "轻微",
  minutes: "分钟",
  minutes_15: "15分钟",
  minutes_30: "30分钟",
  min_15_seconds_for_linkage_recording_duration: "联动录像时长最少15秒",
  min_ago: "分钟前",
  min_data_collection_period_is_5_minutes: "数据采集周期最少5分钟",
  min_egg_production: "最低产蛋数",
  min_egg_production_rate: "最低产蛋率",
  min_temp: "最小温度",
  min_temp_big_than: "最低温大于",
  min_temp_is_required: "最低温不能为空",
  min_temp_less_than: "最低温小于",
  mirage: "幻彩",
  mirror_display: "镜像显示",
  mirror_img: "镜像",
  missed_cage_report: "漏报笼位",
  missed_coop_report: "漏报栋舍",
  missed_inspection_report: "漏检上报",
  missed_report_entry: "漏报补录",
  missed_report_img: "漏报图片",
  mmenu: "菜单",
  mmsi: "海上移动业务识别码",
  mobile: "手机号码",
  mobile_binding_successful: "手机绑定成功",
  mobile_login: "手机登录",
  mobile_number_binding: "手机号绑定",
  mobile_number_changed_successfully: "换绑手机号成功",
  mobile_number_format_error: "手机号格式错误",
  mobile_number_not_bound_unable_to_modify_via_phone_verification:
    "未绑定手机号，无法进行手机验证修改",
  mobile_phone_imei: "手机IMEI",
  mobile_robot: "轮式机器人",
  mobile_verification_modification: "手机验证修改",
  mode: "模式",
  model: "型号",
  model_confirmed_reboot_soon: "确定型号，即将重启",
  moderate: "一般",
  mode_setup: "设置档位",
  mode_switching_failed_due_to_no_mode_seled_or_incorrect_mode_sel:
    "未选择切换模式或选择模式错误，切换失败",
  modification_failed: "修改失败",
  modify: "修改",
  modify_alias: "修改别名",
  modify_all: "修改全部",
  modify_area: "修改区域",
  modify_cage: "修改笼位",
  modify_config: "修改配置",
  modify_data_permi: "修改数据权限",
  modify_department: "修改部门",
  modify_device_name: "修改设备名称",
  modify_house: "修改舍位",
  modify_map: "修改地图",
  modify_organization: "修改组织",
  modify_point: "修改点位",
  modify_push_notification_personnel: "修改推送人员",
  modify_pwd: "修改密码",
  modify_role: "修改角色",
  modify_success: "修改成功",
  modify_template: "修改模板",
  modify_the_same_channel: "修改同一通道",
  modify_this_point_only: "仅修改该点",
  modify_time: "修改时间",
  modify_user: "修改用户",
  module: "模块",
  module_temperature: "机芯温度",
  monday: "周一",
  monitoring_description: "运维描述",
  monitoring_devices: "监控设备",
  monitoring_device_details: "监控设备详情",
  monitoring_end_time: "监控结束时间",
  monitoring_frequency: "监测次数",
  monitoring_handling_time: "监控处置时间",
  monitoring_range_layer: "监控范围图层",
  monitoring_record: "监控记录",
  monitoring_records: "运维记录",
  monitoring_record_processing: "监控记录处理",
  monitoring_screen: "监控大屏",
  monitoring_start_time: "监控开始时间",
  monitoring_type: "监控类型",
  month: "月",
  monthly: "每月",
  monthly_alarm_count: "本月报警数",
  more: "更多",
  morning: "上午",
  motion_detection: "移动检测",
  motor: "电机",
  motor_anomaly: "电机异常",
  motor_information: "电机信息",
  motor_malfunction: "电机故障",
  mounted_equipment: "挂载设备",
  mouse_follow: "鼠标跟随",
  move_down: "下移",
  move_down_failed: "下移失败",
  move_failed: "移动失败",
  move_to: "移动到…",
  move_to1: "运动至",
  move_up: "上移",
  move_up_failed: "上移失败",
  ms_word_required: "注意：PDF类型需先安装MS-Word",
  multichannel: "多通道",
  multi_frame_occurrence_confidence_threshold: "多帧/次可信阈值",
  mute_alarm_sound: "屏蔽报警声音",
  mute_notifications: "消息免打扰",
  mute_notifications_setting_succeeded: "免打扰设置成功",
  mute_notifications_time: "免打扰时间",
  muzzle_velocity: "初速度",
  mysubmailcom: "赛邮云",
  my_coupon: "我的优惠券",
  my_equipment: "我的设备",
  my_order: "我的订单",
  my_patrol: "我的轮巡",
  my_view: "我的视图",
  m_serial: "M系列",
  n1_an_inspection_task_is_being_delivered: "{n1}巡检任务下发中",
  n1_inspection_task_is_resuming: "{n1}巡检任务恢复中",
  n1_inspection_task_is_re_executing: "{n1}巡检任务重新执行中",
  n1_inspection_task_resumption_execution_failed_network_connectio:
    "{n1}巡检任务恢复执行失败，网络连接异常",
  n1_inspection_task_resumption_succeeded: "{n1}巡检任务恢复成功",
  n1_inspection_task_re_execution_failed_network_connection_error:
    "{n1}巡检任务重新执行失败，网络连接异常",
  n1_inspection_task_re_execution_failed_robot_unresponsive:
    "{n1}巡检任务重新执行失败，*机器人未响应",
  n1_inspection_task_re_execution_succeeded: "{n1}巡检任务重新重新执行成功",
  n1_the_inspection_task_fails_to_be_delivered_and_the_n2_robot_do:
    "{n1}巡检任务下发失败，{n2}机器人未响应",
  n1_the_inspection_task_fails_to_be_delivered_because_the_point_o:
    "{n1}巡检任务下发失败，{n2}机器人点位与平台不一致",
  n1_the_inspection_task_fails_to_be_restarted_because_the_n2_robo:
    "{n1}巡检任务重新执行失败，{n2}机器人未响应",
  n1_the_inspection_task_fails_to_be_restored_and_the_n2_robot_doe:
    "{n1}巡检任务恢复失败，{n2}机器人未响应",
  n1_the_inspection_task_fails_to_be_terminated_and_the_n2_robot_d:
    "{n1}巡检任务终止失败，{n2}机器人未响应",
  n1_the_inspection_task_fails_to_be_terminated_because_the_networ:
    "{n1}巡检任务终止失败，网络连接异常",
  n1_the_inspection_task_is_delivered_successfully: "{n1}巡检任务下发成功",
  n1_the_inspection_task_is_terminated: "{n1}巡检任务终止中",
  n1_the_inspection_task_is_terminated_successfully: "{n1}巡检任务终止成功",
  name: "名称",
  names_can_only_contain_chinese_characters_numbers_english_and_:
    "名称仅允许输入汉字、数字、英文、“-”、“_”",
  name_already_exists: "名称已存在",
  name_already_exists_pls_enter_a_new_name: "已有该名称，请重新填写名称",
  name_is_required: "名称不能为空",
  name_must_be_less_than_10: "网络名称需小于10",
  national_sip_domain: "国标SIP域",
  navigate_to_this_location: "导航到这",
  navigation_camera: "导航相机",
  navigation_camera_illuminator: "导航相机补光灯",
  navigation_camera_information: "导航相机信息",
  navigation_point: "导航点",
  near_focus: "近焦",
  need_to_access_your_camera_to_capture_imgs: "需要访问您的相机来拍摄照片",
  need_your_permission_to_access_the_album:
    "需要您的同意，才能访问相册。若不允许,您将无法将图片或视频保存到本地相册",
  network_abnormal_login_failed: "网络异常,登录失败",
  network_communication_error_xxx_inspection_task_generation_faile:
    "网络通信异常，XXX巡检任务生成失败",
  network_congestion: "网络拥挤",
  network_connection_timed_out: "网络连接超时",
  network_device: "网络设备",
  network_exception_pls_check_the_network_settings:
    "网络连接异常，请检查网络设置",
  network_issue_download_interrupted: "网络原因,下载中断",
  network_name: "网络名称",
  network_or_service_exception_pls_check_and_retry:
    "网络或服务异常，请检查后重试",
  network_setup: "网络设置",
  network_status: "网络状态",
  never_end: "永不结束",
  newdual_targetkb: "新-双目标定",
  newly_added_today: "今日新增",
  newsingle_targetkb: "新-单目标定",
  new_alarms_today: "本日新增报警",
  new_firmware_ver_detected_for_this_device_would_you_like_to_upgr:
    "检测到该设备有新固件版本，是否升级",
  new_name: "新名称",
  new_page: "新增页面",
  new_password_cannot_be_the_same_as_old_password: "新密码与旧密码不能相同",
  new_pwd: "新密码",
  new_pwd_is_required: "新密码不能为空",
  new_ver_exist: "有新版本",
  new_ver_found: "发现新版本",
  next: "下一步",
  next_frame: "下一帧",
  next_page: "下一页",
  next_point: "下一点位",
  nickname: "昵称",
  nickname_not_set: "未设置昵称",
  night: "黑夜",
  no: "否",
  none: "无",
  non_administrators_cannot_add_linkage_strategies: "非管理员无法添加联动策略",
  non_admin_users_cannot_del_linkage_strategies: "非管理员无法删除联动策略",
  non_armed_conflict_state_ships_and_aircraft: "非武装冲突国家船和飞行器",
  non_car: "非汽车",
  non_excavator: "非挖掘机",
  non_fire: "非火灾",
  non_laying_hens: "绝产鸡",
  non_laying_hen_analysis: "绝产鸡分析",
  non_preset: "非预置位",
  non_productive_chicken_alarm: "绝产鸡报警",
  non_standard_inf_file: "非标准红外文件",
  normal: "常规",
  note: "备注",
  noteclick_this_button_then_click_on_the_map_to_draw_the_area:
    "说明：点击该按钮后，在地图点击进行区域绘制。",
  note_excluding_coriolis_effect_from_calculations:
    "备注：删除科里奥利效应则不参与计算",
  note_if_you_want_to_add_new_personnel_and_alarm_sources_pls_set_:
    "提示：已设置报警如果要添加新的人员和报警源，请在修改页面设置",
  note_the_robot_can_only_issue_one_loop_task_and_loop_tasks_canno:
    "注：机器人仅能下发一个循环任务，且循环任务与定时任务不能同时存在",
  notice: "通知公告",
  notification_channel: "通知渠道",
  notification_channel_setting: "通知渠道设置",
  notification_method: "告知方式",
  notification_personnel: "告知人员",
  not_added: "未添加",
  not_a_false_alarm: "非误报",
  not_binding_for_now: "暂不绑定",
  not_calibrated: "未校准",
  not_connected: "未连接",
  not_connected_to_original_device: "未连接原设备",
  not_executed: "未执行",
  not_filled_in: "未填写 ",
  not_null: "不可为空",
  not_online: "网络未连接",
  not_picked: "未拣出",
  not_supported: "不支持",
  not_upgrading_for_now: "暂不升级",
  not_yet_added_temp_measurement_area: "还未添加测温区域",
  nov: "十一月",
  no_account: "没有账号",
  no_alarm: "不报警",
  no_alarms: "暂无报警",
  no_anomaly: "无异常",
  no_available_channels_found_pls_check_the_device:
    "未发现可用通道，请检查设备",
  no_available_location_provider: "没有可用的位置提供器",
  no_base_map: "暂无底图",
  no_column_currently_requires_synchronizing_age_in_days:
    "当前无栏位需要同步日龄",
  no_content: "暂无内容",
  no_data: "无数据",
  no_data_available: "暂无数据",
  no_data_exported: "没有导出数据",
  no_data_reported_by_robot: "机器人无上报数据",
  no_devices_connected: "无设备连接",
  no_devices_seled_or_devices_under_the_organization_not_loaded:
    "未选中设备或组织下的设备未加载",
  no_device_detected_if_no_device_is_connected_for_a_long_time_pls:
    "未检测到设备，若长时间无设备连接请检查：",
  no_device_found_nearby: "没有找到附近设备",
  no_device_info: "无设备信息",
  no_downloads_yet: "暂无下载任务",
  no_file: "暂无文件",
  no_files: "该设备没有文件",
  no_files_selected: "无选中文件",
  no_files_seled_for_download: "没有选择可下载文件",
  no_flip: "不翻转",
  no_highlight: "不凸显",
  no_image_to_analyze: "没有可分析的图片",
  no_inspection_points_in_the_map_associated_with_this_robot:
    "该机器人下属地图无巡检点",
  no_inspection_results: "无巡检结果",
  no_inspection_tasks: "无巡检任务",
  no_installation_permi: "无安装权限",
  no_linkage_chan: "暂无联动通道",
  no_linkage_strategy_information_found: "未查询到联动策略信息",
  no_more_data: "没有更多数据",
  no_more_data_available: "没有更多数据了",
  no_offline_information_for_this_device: "没有该设备的脱机信息",
  no_off_not_allowed_during_linkage_recording:
    "有通道联动录像中，不可开启或关闭",
  no_other_streams: "无其他码流",
  no_pdf: "暂无PDF",
  no_permission: "没有权限",
  no_permi_to_access_this_video_stream_or_recording:
    "无访问该视频流或录像的权限",
  no_photo: "暂无图片",
  no_photos_in_sd_card: "Sd卡中没有图片！",
  no_playback: "无回放",
  no_preview: "无预览",
  no_preview_of_panoramic_window_found: "没有发现正在预览的全景窗口",
  no_processing_template: "无处理模板",
  no_prompt: "不再提示",
  no_ptz_control_permi_pls_contact_the_administrator_for_config:
    "无云台控制权限，请联系管理员配置。",
  no_push_recipients: "无推送人",
  no_real_time_preview_permi_pls_contact_the_administrator_for_con:
    "无实时预览权限，请联系管理员配置",
  no_recording: "没有录像",
  no_relevant_locations_found: "没有找到相关地点",
  no_robot_associated: "未关联机器人",
  no_rule: "无规则",
  no_sdcard: "Sd卡未插入",
  no_signal: "无信号",
  no_snapshot: "没有抓图",
  no_statistics_data: "没有统计数据",
  no_storage_permi: "没有存储权限",
  no_strategies_submitted_ope_failed: "未提交任何策略，操作失败",
  no_strategy_seled_for_deletion: "未选中需要删除的策略",
  no_such_recording: "无此录像",
  no_task_template: "无任务模版",
  no_task_templates_available: "暂无任务模版",
  no_temp_video_recording_in_visible_mode: "可见光模式不支持温度视频录制",
  no_track_information_for_this_individual: "该人员无轨迹信息",
  no_update_directory_detected: "未检测到更新目录",
  no_video: "暂无视频",
  no_videos_during_the_seled_time_period: "所选时间段内无视频",
  ntp_port: "NTP端口",
  ntp_time_calibration: "NTP校时",
  num: "拍摄张数",
  number_of_alarm_snapshots: "报警抓拍张数",
  number_of_bound_firearms: "已绑枪支数量",
  number_of_broken_eggs: "破蛋数",
  number_of_cages_with_dead_chickens: "死鸡笼数",
  number_of_cage_columns: "鸡笼列数",
  number_of_chickens: "鸡数",
  number_of_chicken_cages: "鸡笼笼数",
  number_of_chicken_cage_layers: "鸡笼层数",
  number_of_connected_devices: "已接入数量",
  number_of_dead_chicken_cages: "病死鸡笼数",
  number_of_eggs: "蛋数",
  number_of_eggs_produced: "产蛋数",
  number_of_failed_tasks_today: "今日失败任务数",
  number_of_failures: "故障次数",
  number_of_laying_hens: "产蛋鸡存栏",
  number_of_online_devices: "在线设备数量",
  number_of_pigs: "猪只数量",
  number_of_pigs_heads: "猪只数量（头）",
  number_of_tasks_completed_today: "今日完成任务数",
  number_of_times: "持续次数",
  number_order: "序号",
  numeric_or_rate_val_cannot_be_empty: "数值或率值不能为空",
  observation: "观察",
  observation_distance: "观测距离",
  obsidian_black: "曜石黑",
  obtaining_device_config: "获取设备配置",
  obtain_verification_code: "获取验证码",
  obtain_via_bluetooth_device: "通过蓝牙设备获取",
  oct: "十月",
  odometer_information: "odom信息",
  odom_anomaly: "odom异常",
  off: "关",
  offline: "离线",
  offline_analysis: "离线分析",
  offline_analyzed_and_cannot_be_deleted: "此视频正在离线分析，不可删除",
  offline_status_setting_failed: "设置脱机状态失败",
  ok: "确定",
  old_password: "旧密码",
  old_password_cannot_be_empty: "旧密码不能为空",
  on: "开启",
  once_only: "仅一次",
  once_the_algorithm_judgment_begins_alarms_with_repeated_occurren:
    "开始进入算法研判后，重复报警次数小于等于【重复报警次数阈值+该阈值】的报警将被连续触发AI识别",
  one_click_clear: "一键清空",
  one_click_import: "一键导入",
  one_click_preview: "一键预览",
  one_click_return_to_charging_pile: "一键回桩",
  one_click_return_to_charging_pile_failed: "一键回桩失败",
  one_cropping_task_is_running_do_you_want_to_exit_the_program:
    "当前有尚未完成的视频导出任务，关闭软件后该任务将自动取消，确定退出吗",
  one_cropping_task_is_running_pls_wait: "一个裁剪任务正在进行，请稍等",
  one_week_ago: "一周前",
  ongoing: "持续中",
  online: "在线",
  online_analysis: "在线分析",
  online_ratio: "在线比例",
  only_allow_drawing_areas_with_3_or_more_points: "只允许绘制3个点及以上区域",
  only_available_in_inf_mode_except_for_black_hot_and_white_hot_ps:
    "仅在红外模式下可用（除黑热、白热以外伪彩）",
  only_csv_files_allowed: "只允许上传csv文件!",
  only_dead_chickens: "仅病死鸡",
  only_jpg_png_jpeg_files_can_be_uploaded_and_no_larger_than_500kb:
    "只能上传.jpg/.png/.jpeg文件，且不超过500kb",
  only_numbers: "仅允许数字",
  only_one_device_can_be_seled: "只能选择一个设备",
  only_one_file_can_be_renamed_at_a_time: "每次仅可以重命名一份文件",
  only_one_image_can_be_shared_at_a_time: "每次仅可分享一张图片",
  only_today: "仅今日",
  only_upload_imgs_in_jpg_jpeg_bmp_tif_png_formats:
    "只能上传jpg、jpeg、bmp、tif、png格式的图片",
  onvif_protocol: "ONVIF协议",
  on_site_pictures: "现场图片",
  opaque_plastic: "不透明塑料",
  open: "打开",
  openid_error: "openId错误",
  opening_bank: "开户银行",
  open_a_local_file: "打开本地文件",
  open_device: "打开设备",
  open_device_for_firmware_upgrade: "打开设备进行固件升级",
  open_directory: "打开目录",
  open_factory_password: "打开工厂模式密码",
  open_failed: "打开失败",
  open_file: "打开文件",
  open_file_failed: "文件打开失败",
  open_folder: "打开所在文件夹",
  open_source_component_license: "开源组件许可",
  open_source_software_license: "开源软件许可证",
  open_source_software_licenses: "开源声明",
  open_wifi: "开启WiFi",
  operating_channel_sel: "运行通道选择",
  operation: "操作",
  operation_temperature_range: "工作温度",
  operator: "操作员",
  opes_are_too_frequent: "操作频率过快。",
  opes_center: "运维中心",
  opes_information: "运维信息",
  opes_too_frequent_pls_try_again_later: "操作太过频繁，请稍后再试",
  ope_and_maintenance_management: "运维管理",
  ope_and_maintenance_monitoring: "运维监控",
  ope_and_maintenance_record: "运维记录",
  ope_behavior: "操作行为",
  ope_details: "运维详情",
  ope_failed: "操作失败",
  ope_information: "操作信息",
  ope_information_only_includes_the_robots_own_status_data_used_on:
    "运行信息仅包括机器人自身状态数据，仅在运维人员排查问题使用，不会授予他用；",
  ope_logs: "操作日志",
  ope_monitoring: "运行监测",
  ope_permis: "操作权限",
  ope_prohibited: "禁止操作",
  ope_succeeded: "操作成功",
  ope_time: "操作时间",
  ope_too_frequent_pls_try_again_later: "操作频繁，请稍后再试",
  optional: "选填",
  opt_img: "可见光图片",
  order: "顺序",
  order_appraise: "评价订单",
  order_channel: "订单渠道",
  order_info: "订单详情",
  order_number: "订单编号",
  order_of_temp_rise_threshold_is_wrong: "各级别温升阈值顺序有误",
  order_of_temp_threshold_is_wrong: "各级别温度阈值顺序有误",
  order_status: "订单状态",
  ordinary_recording_mode: "普通录像模式",
  organization: "所属组织",
  organizational_settings: "组织机构设置",
  organization_administrator: "组织管理员",
  organization_cannot_be_empty: "所属组织不能为空",
  organization_does_not_exist_pls_download_the_latest_template:
    "组织机构不存在，请下载最新模板",
  organization_id: "组织机构ID",
  organization_information: "组织信息",
  organization_name: "组织名称",
  organization_name_cannot_be_empty: "组织名称不能为空",
  organization_name_must_be_letters_numbers_or_chinese_characters_:
    "组织名称为字母、数字或中文，且长度不超过20",
  organization_not_enabled_unable_to_log_in: "组织未启用，无法登录",
  organization_remarks: "组织备注",
  organization_required: "所属组织(必填)",
  organization_type: "组织类型",
  organization_type_error: "组织类型错误",
  original_frame: "设备原始帧频",
  original_pwd: "原密码",
  original_pwd_is_required: "原密码不能为空",
  osd: "网板叠加",
  oss_get_error: "oss访问信息获取失败,请重新登录",
  other: "其他",
  other_features: "其他整机特性",
  other_img: "其他图片",
  other_reasons: "其他原因",
  other_setting: "其它设置",
  other_types: "其他类型",
  outdoor: "户外",
  outline: "勾边",
  overlay_traj_point_count: "叠加轨迹点数",
  p: "张",
  page: "页",
  page_permis: "页面权限",
  palette: "伪彩设置",
  panorama: "全景图",
  panoramic_area_intrusion: "全景区域入侵",
  panoramic_device_config: "全景设备配置",
  panoramic_event_popup: "全景事件弹窗",
  panoramic_popup_switch: "全景弹窗开关",
  pan_angle: "转角",
  pan_angle_must_be_an_integer_within_0_360: "转角限制在[0-360)的整数",
  pan_tilt_control_failed: "云台控制失败",
  pan_tilt_control_request_failed: "云台控制请求失败",
  pan_tilt_position_not_recorded_in_event_log: "事件记录未记录云台位置",
  paper: "纸",
  parameters: "参数",
  parameters_cannot_be_empty: "参数不能为空",
  parameters_cannot_be_repeated: "参数不能重复",
  parameter_error: "参数错误",
  parameter_missing_addition_failed: "参数缺失，添加失败",
  parameter_setting: "参数设置",
  parameter_validation_failed: "参数校验失败",
  parent_child_linkage: "父子联动",
  parent_department: "上级部门",
  parent_department_cannot_be_empty: "上级部门不能为空",
  parent_directory: "上级目录",
  parent_menu: "上级菜单",
  passenger_ship: "客船",
  passwords_do_not_match: "密码不一致",
  passwords_entered_do_not_match: "两次输入的密码不一致",
  password_changed_successfully: "密码修改成功",
  password_changed_successfully_pls_log_in_again: "密码修改成功，请重新登录",
  password_format_should_be_letters_and_numbers_with_a_length_of_8:
    "密码格式为字母和数字，且长度8~20",
  password_length_is_less_than_10: "密码长度需小于10",
  password_login: "密码登录",
  password_required: "密码(必填)",
  password_reset_successful: "密码重置成功",
  paste: "粘贴",
  path: "路径",
  path_length_exceeds_256_characters: "路径长度超出256字符",
  path_to_open_files: "打开文件夹路径",
  patrol: "巡逻",
  patrol_fast_backward: "轮巡快退",
  patrol_fast_forward: "轮巡快进",
  patrol_track: "巡检轨迹",
  pause: "暂停",
  pause_manual_control: "暂停（手动控制中）",
  pause_patrol: "暂停轮巡",
  pause_recharging: "暂停（回充中）",
  pay: "支付",
  payment_channel: "支付渠道",
  pay_success: "支付成功",
  pdf_library: "PDF库",
  pebble: "石子",
  pedestrian_animal_alarm: "行人/动物报警",
  pedestrian_target_frame_display: "行人目标框显示",
  pending_alarms: "待处理报警",
  pending_outbound: "待出库",
  pen_management: "栏位管理",
  pen_name_must_be_numbers_or_chinese_characters_and_no_longer_tha:
    "栏位名称格式为数字或中文，且长度不超过20",
  periodic_time: "周期时间",
  period_setting: "周期设置",
  permanent: "永久",
  permi_character: "权限字符",
  permi_character_cannot_be_empty: "权限字符不能为空",
  permi_character_must_be_chinese_characters_or_letters_and_no_lon:
    "权限字符为中文或字母，且长度不超过20",
  permi_config: "权限配置",
  permi_scope: "权限范围",
  personal_information: "个人资料",
  personnel_coordinates: "人员坐标",
  person_in_charge: "责任人",
  phone: "电话",
  phone_number_cannot_be_empty: "手机号不能为空",
  photos: "照片",
  photo_interval: "拍照间隔",
  photo_setting: "拍照设置",
  photo_taken: "拍照完成",
  picked: "已拣出",
  pic_data_error: "图片数据错误",
  piece: "件",
  pieces: "枚",
  pieces_per_hen: "枚/羽",
  piece_cost: "时间段费用",
  piece_price: "时间段单价",
  pigpen_details: "猪栏详情",
  pigsty_data_statistics: "猪栏数据统计",
  pigsty_management: "猪舍管理",
  pig_age_in_days: "猪只日龄",
  pig_temp_measurement: "猪只温度测量",
  "pig_temp_threshold_℃": "猪只温度阈值(度)",
  pilot_boat: "引航船",
  pip: "画中画",
  pip_adjustment: "画中画调整",
  pip_mode: "画中画模式",
  pip_settings: "画中画设置",
  pitch: "沥青",
  pitch_angle: "俯仰角",
  pitch_angle_information: "俯仰角信息",
  pitch_angle_must_be_an_integer_within_90_90: "俯仰角限制在[-90,90]的整数",
  pitch_angle_n_offset: "俯仰角{n}偏移量",
  pitch_angle_offset: "俯仰角偏移量",
  pixel: "像素",
  place_the_crosshair_on_the_target_and_click_confirm:
    "将十字准线放在目标上并点击“确定”",
  plain_text: "普通文本",
  plan_name_required: "计划名称不能为空",
  plan_type: "计划类型",
  plastic_pvc: "塑料(PVC)",
  platform_authorization: "平台授权",
  platform_cascading: "平台级联",
  platform_name: "平台名称",
  platform_name_settings: "平台名称设置",
  platform_national_code_settings: "平台国标编码设置",
  platform_terminates_inspection_task: "平台终止巡检任务",
  play: "播放",
  playback: "回放",
  playback_ended: "回放结束",
  playback_error: "回放有误",
  playback_failed_pls_refresh_and_load_again: "播放失败，请重新刷新加载",
  playback_history: "回放历史",
  playback_speed: "倍速",
  playback_start_failed: "开始回放失败",
  playback_timeout: "播放等待超时",
  play_audio: "播放音频",
  play_failed: "播放失败",
  play_list: "播放列表",
  please_calibrate_the_device: "请校准设备",
  please_enter_a_network_name: "请输入网络名称",
  please_enter_file_name: "请输入文件名",
  please_select_a_picture_or_video_to_delete: "请先选择需要删除的图片或视频",
  please_wait: "请稍候",
  pls_add_at_least_one_view: "请添加至少一个视图。",
  pls_add_channel: "请添加通道。",
  pls_add_preset: "请添加预置位。",
  pls_add_the_inspection_action_list: "请添加巡检动作列表",
  pls_add_view: "请添加视图",
  pls_check_network_connection: "请检查网络情况",
  pls_check_the_mobile_hotspot_and_the_device_connection_status:
    "请检查手机热点及设备连接状态",
  pls_check_the_network_connection: "请检查网络连接",
  pls_check_the_path: "请检查路径",
  pls_check_the_sms_platform: "请在短信平台查找",
  pls_check_your_network_and_try_connecting_again: "请检查网络后再次连接",
  pls_choose_associated_ir_img: "请选择关联红外图片",
  pls_clear_device_channels_first: "请先清空设备通道",
  pls_click_here_to_complete_the_shipping_address: "请点击此处完善收货地址",
  pls_click_the_settings_button_to_add_a_channel: "请在设置中添加通道",
  pls_complete_the_information: "请完善信息",
  pls_complete_the_shipping_address: "请完善收货地址",
  pls_confirm_information_modification: "请确认是否修改信息",
  pls_confirm_the_password: "请确认密码",
  pls_confirm_whether_to_modify_the_encryption_type: "请确认是否修改加密类型",
  pls_confirm_whether_to_modify_the_wifi_name: "请确认是否修改WiFi名称",
  pls_confirm_whether_to_modify_the_wifi_password: "请确认是否修改WiFi密码",
  pls_connect_the_device: "请链接设备",
  pls_connect_the_device_first: "请先连接设备",
  pls_connect_the_hotspot_first: "请先连接设备热点",
  pls_contact_the_administrator_to_assign_roles: "请联系管理员分配角色",
  pls_del_after_sel: "请选择后删除",
  pls_del_device_first: "请先删除设备",
  pls_disable_isotherm_function_first: "请先关闭等温线功能",
  pls_end_the_stated_tasks_first: "请先结束开启的任务",
  pls_end_the_tasks_in_electric_mode_first: "请先结束电力模式中开启的任务",
  pls_end_the_tasks_in_general_mode_first: "请先结束通用模式中开启的任务",
  pls_ensure_device_battery_and_storage_space_are_sufficient:
    "请保持设备电量和存储空间充足",
  pls_ensure_you_are_connected_to_the_devices_wifi_network:
    "请确保您已经连接至设备Wifi网络",
  pls_enter_abbreviation: "请输入简称",
  pls_enter_account_name: "请输入账号名称",
  pls_enter_administrator: "请输入管理员",
  pls_enter_alarm_device: "请输入报警设备",
  pls_enter_an_email: "请输入邮箱",
  pls_enter_associated_cage_number: "请输入关联笼号",
  pls_enter_associated_column_number: "请输入关联列号",
  pls_enter_associated_point: "请输入关联点位",
  pls_enter_associated_task: "请输入所属任务",
  pls_enter_a_channel_name: "请输入通道名称",
  pls_enter_a_correct_email_address: "请正确输入邮箱地址",
  pls_enter_a_mac: "请输入MAC",
  pls_enter_a_name: "请输入名称",
  pls_enter_a_new_device_name: "请输入新设备名称",
  pls_enter_a_new_password: "请输入新密码",
  pls_enter_a_new_wifi_name: "请输入新WiFi名称",
  pls_enter_a_valid_email_address: "请输入正确的邮箱地址",
  pls_enter_a_valid_phone_number: "请输入正确的手机号码",
  pls_enter_a_valid_value: "请输入有效值",
  pls_enter_browser_time: "请输入浏览器时间",
  pls_enter_building_name: "请输入栋舍名称",
  pls_enter_bullet_name: "请填写子弹名称",
  pls_enter_bullet_notes: "请填写子弹备注信息",
  pls_enter_cage_name: "请输入笼位名称",
  pls_enter_cage_number: "请输入笼位号",
  pls_enter_contact_information: "请输入联系方式",
  pls_enter_contact_number: "请输入联系电话",
  pls_enter_content: "请输入内容",
  pls_enter_correct_latitude_and_longitude: "请输入正确的经纬度",
  pls_enter_database_table: "请输入数据库表",
  pls_enter_data_permi_field: "请输入数据权限字段",
  pls_enter_data_permi_name: "请输入数据权限名称",
  pls_enter_data_permi_remarks: "请输入数据权限备注",
  pls_enter_day_age: "请输入日龄",
  pls_enter_department_name: "请输入部门名称",
  pls_enter_device_name: "请输入设备名称",
  pls_enter_dictionary_label: "请输入字典标签",
  pls_enter_dictionary_name: "请输入字典名称",
  pls_enter_disposal_opinion: "请输入处理意见",
  pls_enter_distance_from_origin: "请输入距原点距离",
  pls_enter_firearm_name: "请填写枪支名称",
  pls_enter_firearm_notes: "请填写枪支备注信息",
  pls_enter_handler: "请输入处置人",
  pls_enter_house_name: "请输入舍位名称",
  pls_enter_inspection_point: "请输入巡检点",
  pls_enter_integers_1_2: "请输入%1~%2之间的整数",
  pls_enter_ip_address: "请输入IP",
  pls_enter_keywords: "请输入关键字",
  pls_enter_lift_height: "请输入升降高度",
  pls_enter_map_name: "请输入地图名称",
  pls_enter_monitoring_device: "请输入监控设备",
  pls_enter_new_phone_number: "请输入新手机号",
  pls_enter_ntp_port: "请输入NTP端口",
  pls_enter_numbers_between_1_2: "请输入%1~%2之间的数",
  pls_enter_number_of_cage_columns: "请输入鸡笼列数",
  pls_enter_number_of_cage_layers: "请输入鸡笼层数",
  pls_enter_number_of_cage_rows: "请输入鸡笼行数",
  pls_enter_old_password: "请输入旧密码",
  pls_enter_operator: "请输入操作员",
  pls_enter_organization_name: "请输入组织名称",
  pls_enter_password: "请输入密码",
  pls_enter_pen_name: "请输入栏位名称",
  pls_enter_permi_character: "请输入权限字符",
  pls_enter_person_in_charge: "请输入负责人",
  pls_enter_phone_number: "请输入手机号码",
  pls_enter_point_name: "请输入点位名称",
  pls_enter_point_type: "请输入点位类型",
  pls_enter_port: "请输入端口",
  pls_enter_reason_description: "请输入原因描述",
  pls_enter_remarks: "请输入备注",
  pls_enter_remarks_no_more_than_100_characters: "请输入备注，不超过100字",
  pls_enter_report_title: "请输入报表标题",
  pls_enter_resource_id: "请输入资源编号",
  pls_enter_resource_type: "请输入资源类型",
  pls_enter_robot: "请输入机器人",
  pls_enter_robot_model: "请输入机器人型号",
  pls_enter_robot_name: "请输入机器人名称",
  pls_enter_robot_name_or_channel_name_to_filter:
    "请输入机器人名称或通道名称筛选",
  pls_enter_robot_type: "请输入机器人类型",
  pls_enter_role_name: "请输入角色名称",
  pls_enter_scope_notes: "请填写瞄准镜备注信息",
  pls_enter_server_address: "请输入服务器地址",
  pls_enter_sn_code: "请输入SN码",
  pls_enter_task_name: "请输入任务名称",
  pls_enter_text_content: "请输入文本内容",
  pls_enter_the_admin_username_to_create: "请输入要创建的管理员用户名",
  pls_enter_the_affiliated_map: "请输入所属地图",
  pls_enter_the_affiliated_robot: "请输入所属机器人",
  pls_enter_the_area_code: "请输入区域编号。",
  pls_enter_the_association_name_up_to_50_characters: "请输入关联名称,最多50字",
  pls_enter_the_column_number: "请输入列号",
  pls_enter_the_correct_verification_code: "请输入正确的验证码",
  pls_enter_the_graphic_verification_code: "请输入图形验证码",
  pls_enter_the_missed_cage_position_in_the_order_of_column_cage_a:
    "请依次按照列、笼、层方式输入漏报笼位，例如上述输入3、2、1 对应3列-2笼-1层",
  pls_enter_the_new_password_again: "请再次输入新密码",
  pls_enter_the_password_again: "请再次输入密码",
  pls_enter_the_shielded_area_name: "请输入屏蔽区域名称",
  pls_enter_the_sms_verification_code: "请输入短信验证码",
  pls_enter_the_template_name: "请输入模板名称",
  pls_enter_the_template_name_first: "请先输入模板名称",
  pls_enter_the_users_name_not_exceeding_20_characters:
    "请输入用户姓名，不超过20字",
  pls_enter_the_verification_code: "请输入验证码",
  pls_enter_title: "请输入标题",
  pls_enter_username: "请输入用户名",
  pls_enter_users_name: "请输入用户姓名",
  pls_enter_user_entity_corresponding_field: "请输入user实体类对应字段",
  pls_enter_user_table_corresponding_field: "请输入用户表对应字段",
  pls_enter_verification_code: "请填写验证码",
  pls_enter_wifi_name: "请输入Wi-Fi名称",
  pls_enter_your_account: "请输入您的帐号",
  pls_enter_your_mobile_number: "请输入您的手机号",
  pls_enter_your_new_password: "请输入您的新密码",
  pls_enter_your_original_password: "请输入您的原密码",
  pls_enter_your_password: "请输入您的密码",
  pls_exit_account: "请退出云账户",
  pls_fill_in_a_description_of_more_than_10_characters_so_that_we_:
    "请填写10个字以上的问题描述以便我们提供更好的帮助",
  pls_fill_in_the_angle_val: "请填写角度值",
  pls_fill_in_the_manufacturer: "请填写生产厂商",
  pls_fill_in_the_remarks: "请填写备注信息",
  pls_follow_the_path_below_to_modify_the_mobile_hotspots_password:
    "请参照以下路径修改手机热点的密码与设备一致：设置-个人热点-开启允许其他人加入-修改无线局域网密码。",
  pls_go_to_the_area_settings_module_to_add_an_area: "请至区域设置模块添加区域",
  pls_import_task_template: "请导入任务模板",
  pls_include_deviceid_in_request_parameters: "请在请求参数中携带deviceId参数",
  pls_input: "请输入",
  pls_input_account: "请输入登录帐号",
  pls_input_correct_phone_number: "请输入正确手机号",
  pls_input_details: "请输入详情",
  pls_input_phone_number: "请输入手机号",
  pls_input_price: "请输入价格",
  pls_input_pwd: "请输入账户密码",
  pls_input_sequence: "请输入顺序",
  pls_input_serial_number: "请输入序列号",
  pls_input_the_calibrated_temp: "请输入修正温度",
  pls_input_the_new_name: "请输入新名称",
  pls_keep_the_device_on: "请保持设备处于开机状态",
  pls_keep_this_page_open_during_the_upgrade_and_do_not_put_the_ap:
    "设备升级时，请保持该页面，不要退出该页面或将APP置于后台",
  pls_light_the_star: "请点亮星星",
  pls_login_first: "请登录账户",
  pls_log_in_the_cloud_first: "请先登录云平台",
  pls_operate_after_stop_recording: "请停止录像再操作!",
  pls_plug_in_the_device: "请插入设备",
  pls_press_again_to_exit: "请再按一次退出",
  pls_read_carefully_and_agree_to_the_following_terms:
    "请仔细阅读并同意以下条款",
  pls_remove_all_patrols_under_this_group_before_deleting_the_grou:
    "删除分组前，需移出该分组下的所有轮巡",
  pls_remove_all_views_under_this_group_before_deleting_the_group:
    "删除分组前，需移出该分组下的所有视图",
  pls_renew_it_promptly: "请及时续期",
  pls_scan_qr_code: "请扫描二维码",
  pls_sel: "请选择",
  pls_select_a_file: "请选择文件",
  pls_select_device_first: "请先选择设备",
  pls_select_first: "请先选择",
  pls_select_media_first: "请先选择需要上传的图片或视频",
  pls_select_the_device_model: "请选择设备型号",
  pls_select_the_file_to_analyze_first: "请先选择可分析的文件",
  pls_select_time_type_again: "请重新调整开始或结束时间",
  pls_sel_alarm_name: "请选择报警名称",
  pls_sel_alarm_name_and_export_by_type: "请选择报警名称，按类型查询导出",
  pls_sel_alarm_name_query__export_by_type: "请选择报警名称，按类型查询汇出",
  pls_sel_alarm_source: "请选择报警源",
  pls_sel_alarm_type: "请选择报警类型",
  pls_sel_an_alarm_item: "请选择报警项",
  pls_sel_an_organization: "请选择组织",
  pls_sel_a_file_to_download: "请选择文件下载",
  pls_sel_a_robot: "请选择机器人",
  pls_sel_a_type: "请选择类型",
  pls_sel_category: "请选择类别",
  pls_sel_channel: "请选择通道",
  pls_sel_channels_under_the_robot: "请选择机器人下属通道",
  pls_sel_data_permi_type: "请选择数据权限类型",
  pls_sel_date: "请选择日期",
  pls_sel_device_type: "请选择设备类型",
  pls_sel_end_action: "请选择结束动作",
  pls_sel_execution_frequency: "请选择执行频率",
  pls_sel_execution_method: "请选择执行方式",
  pls_sel_execution_strategy: "请选择执行策略",
  pls_sel_fee_mode: "请选择计费模式",
  pls_sel_file_format: "请选择文件格式",
  pls_sel_inspection_point: "请选择巡检点",
  pls_sel_inspection_result: "请选择巡检结果",
  pls_sel_layout: "请选择布局。",
  pls_sel_linkage_action: "请选择联动动作",
  pls_sel_linkage_channel: "请选择联动通道",
  pls_sel_monitoring_type: "请选择监控类型",
  pls_sel_notification_personnel: "请选择告知人员",
  pls_sel_point_type: "请选择点位类型",
  pls_sel_preview_channel: "请选择预览通道",
  pls_sel_region_first: "请先选择区域",
  pls_sel_start_time: "请选择开始时间",
  pls_sel_statistics_rule: "请选择统计规则",
  pls_sel_system_time: "请选择系统时间",
  pls_sel_target_location_first: "请先选择目标位置",
  pls_sel_target_point: "请选择目标点",
  pls_sel_task_status: "请选择任务状态",
  pls_sel_the_alarm_frequency: "请选择报警次数",
  pls_sel_the_alarm_level: "请选择报警级别",
  pls_sel_the_alarm_reason: "请选择报警原因",
  pls_sel_the_alarm_status: "请选择报警状态",
  pls_sel_the_associated_map: "请选择所属地图",
  pls_sel_the_associated_robot: "请选择所属机器人",
  pls_sel_the_charging_point: "请选择充电点位",
  pls_sel_the_chicken_coop_first: "请先选择鸡舍",
  pls_sel_the_device_again_for_a_wifi_connection_if_the_connection:
    "请重新选择设备WiFi进行连接，如果无法连接建议您重启设备",
  pls_sel_the_inspection_record: "请选择巡检记录",
  pls_sel_the_record_status: "请选择记录状态",
  pls_sel_the_target_inspection_point: "请选择目标巡检点",
  pls_sel_the_user_to_unbind: "请选择需要解绑的用户",
  pls_sel_time: "请选择时间",
  pls_share_after_wifi_enabled: "请打开网络后分享",
  pls_switch_device_network: "请切换设备网络",
  pls_try_again_in_good_network_condition: "请在良好网络状态下重试",
  pls_try_again_later: "请稍后再试。",
  pls_turn_on_wifi: "请开启WiFi",
  pls_unbind_the_firearm_before_deleting: "删除前请先与枪支解绑",
  pls_wait: "正在打开图库",
  pn_and_sn_is_required: "PN或SN不能为空",
  pn_sn_exists: "PN/SN重复",
  point: "点",
  point_associated_with_inspection_template_deletion_failed:
    "点位关联巡检模板，删除失败",
  point_does_not_exist: "点位不存在",
  point_exists_in_unfinished_tasks_deletion_failed:
    "点位存在于未完成的任务中，删除失败",
  point_information: "点位信息",
  point_invalid_belonging_map_has_been_deld: "点位无效，所属地图已被删除",
  point_list: "点位列表",
  point_management: "点位管理",
  point_name: "点位名称",
  point_name_already_exists_pls_modify_and_try_again:
    "点位名称已存在，请修改后重试",
  point_name_cannot_be_empty: "点位名称不能为空",
  point_name_should_consist_of_letters_numbers_or_chinese_characte:
    "点位名称为字母、数字或中文，且长度不超过20",
  point_not_associated: "未关联点位",
  point_order: "点位顺序",
  point_status_update_failed: "点位状态更新失败",
  point_sync_failed: "点位同步失败",
  point_sync_failed_network_connection_error: "点位同步失败，网络连接异常",
  point_sync_successful: "点位同步成功",
  point_type: "点位类型",
  polish: "波兰语",
  polished_aluminium_or_aluminum_foil: "抛光铝或铝箔",
  polished_cast_iron: "抛光铸铁",
  polygon: "多边形",
  port: "端口",
  port_is_required: "端口不能为空",
  port_number: "端口号",
  port_number_must_be_numeric: "端口号为数字",
  port_range_1_65535: "端口范围1-65535",
  port_required: "端口(必填)",
  port_supply_vessel: "港口供应船",
  positioning_3d: "3D定位",
  positioning_3d_failed: "3D定位失败",
  position_reset: "复位",
  power: "电源",
  power_supply: "供电",
  preset: "预置位",
  preset_name: "预置位名称",
  preset_name_for_this_channel_already_exists_pls_choose_another_n:
    "设备此信道预置位名称重复，请更换名称",
  preset_number: "预置位编号",
  preset_patrol_plan_setting_failed: "预置位巡航计划设置失败",
  preset_tour: "预置位巡航",
  press_back_button_to_quit: "退出定时拍照",
  press_enter_to_search: "按回车键搜索",
  preview: "预览",
  preview_failed: "预览失败",
  preview_module: "视频预览模块",
  preview_not_supported: "不支持预览。",
  preview_playback: "预览和回放",
  previous: "上一步",
  previous_frame: "上一帧",
  previous_inspection_task_not_completed: "前置巡检任务未完成",
  previous_page: "上一页",
  previous_point: "前一点位",
  previous_task_incomplete: "前置任务未完成",
  pre_upload_failed: "预上传失败",
  price: "价格",
  primary_server_status: "主服务器状态",
  privacy_agreement: "隐私协议",
  privacy_policy: "隐私政策",
  process: "处理",
  processed: "已处理",
  processed_or_not: "是否处理",
  processing: "处理中",
  processing_cast_iron: "加工铸铁",
  processing_comments: "处理意见",
  processing_comments_cannot_be_empty: "处理意见不能为空。",
  processing_failed: "处理失败",
  processing_time: "处理时间",
  processing_user: "处理用户",
  production_data: "生产数据",
  production_report: "生产报告",
  production_report_statistics: "生产报告统计",
  production_statistics: "生产统计",
  product_: "产品序列号",
  product_added_to_your_cart: "添加购物车成功",
  product_collection: "商品收藏",
  product_does_not_exist: "商品不存在",
  product_info: "产品信息",
  product_list: "商品列表",
  product_name: "产品名称",
  product_number: "产品编号",
  product_temp: "产品温度",
  profile: "个人中心",
  progress: "进度",
  prompt: "提示",
  proprietary_protocol: "私有协议",
  protocol: "协议类型",
  province: "省",
  pseudo_color_config_not_possible_for_the_current_channel:
    "当前信道无法配置伪彩",
  pseudo_color_settings_not_supported_for_the_current_channel:
    "当前通道不支持伪彩设置",
  ptz_adjustment: "云台调节",
  ptz_angle: "云台转角",
  ptz_commands: "云台指令",
  ptz_control: "云台控制",
  ptz_control_failed: "云台控制失败。",
  ptz_mode: "云台模式",
  ptz_pitch_angle: "云台俯仰角",
  ptz_reset: "云台归零",
  ptz_sensitivity: "云台灵敏度",
  ptz_settings: "云台设置",
  ptz_tracking_failed: "云台跟随失败",
  public_patrol: "公共轮巡",
  public_view: "公共视图",
  pull_down_to_refresh: "下拉刷新",
  pull_up_to_load: "上拉加载",
  pull_up_to_show_more: "上拉显示更多",
  puor: "紫橙",
  purchase_type: "购买类型",
  push_area: "推送区域",
  push_config_settings_succeeded: "推送配置设置成功",
  push_notification_settings: "推送设置",
  push_successful: "推送成功",
  pwd: "密码",
  pwd_cannot_be_empty: "密码不能为空",
  pwd_combination_rules_8_16: "密码为8-16位，数字、大小写字母的组合",
  pwd_confirm_is_required: "确认密码不能为空",
  pwd_control: "密码管控",
  pwd_error: "密码错误",
  pwd_inconformity: "两次密码不一致",
  p_serial: "P系列",
  qa: "常见问题Q&A",
  qr_code: "二维码",
  qr_code_number: "二维码号",
  qr_code_point: "二维码点",
  qr_code_point_retrieval_failed: "二维码点位获取失败",
  qr_code_point_retrieval_successful: "二维码点位获取成功",
  quantity: "数量",
  quantity_up_to_limit: "数量已达到上限",
  query: "查询",
  query_current_robot_inspection_progress_successful:
    "查询当前机器人巡检进度成功",
  query_record_is_empty: "查询记录为空",
  query_time: "查询时间",
  questions_and_comments: "问题和意见",
  questions_and_suggestions: "问题和建议",
  quick_guide: "快速指南",
  quick_input: "快捷输入",
  quick_report: "快速报告",
  quick_report_completed: "快速报告完成",
  quick_report_failed: "快速报告失败",
  quit_alarm_snapshot: "报警自动拍照关闭",
  quit_editing: "确定要退出编辑吗",
  quit_the_inspection_task: "退出巡检任务",
  quit_timelapsed_image_capture: "定时拍照关闭",
  radar: "雷达",
  radar_chart: "雷达图",
  radar_malfunction: "雷达故障",
  rail_robot: "轨道机器人",
  rainbow: "彩虹",
  rainbow_hc: "彩虹HC",
  random: "随机",
  range: "测程",
  rangefinder: "测距仪",
  rangefinding: "测距",
  rangefinding_for_p2: "P2测距",
  range_inner: "区间内",
  range_outer: "区间外",
  raythink: "燧石",
  rdgy: "黑红",
  read: "读取",
  reading_files: "读取文件中…",
  ready: "就绪",
  read_files: "读取设备文件",
  read_status: "状态读取",
  realtime_alarm: "实时报警",
  real_name: "真实姓名",
  real_name_cannot_be_empty: "真实姓名不能为空",
  real_time: "实时监控",
  real_time_data: "实时数据",
  real_time_temp_curve: "实时温度曲线",
  rear_radar: "后雷达",
  rear_radar_anomaly: "后雷达异常",
  rear_radar_information: "后雷达信息",
  reason: "原因",
  reauthorize: "重新授权",
  rebuild_cache: "重建缓存",
  receiving_email: "接收邮箱",
  receiving_failed: "接收失败",
  recently_used_devices: "最近使用设备",
  recent_alarm_time: "最近报警时间",
  recent_trigger_time: "最近触发时间",
  recognition_distance: "识别距离",
  recognition_failed: "识别失败",
  recognition_result: "识别结果",
  recognition_successful: "识别成功",
  recommended_size: "推荐大小",
  reconnect: "重连",
  reconnecting: "重连中",
  reconnect_failed: "重连失败",
  record: "录音",
  recording: "正在录音",
  recordings: "录像(s)",
  recording_directory: "录像路径",
  recording_failed: "录制失败",
  recording_file: "录像文件",
  recording_file_duration: "录像文件时长",
  recording_method: "记录方式",
  recording_pause: "录制暂停",
  recording_plan_deld_successfully: "录像计划删除成功",
  recording_plan_deletion_failed: "录像计划删除失败",
  recording_plan_disabled_successfully: "关闭录像计划成功",
  recording_plan_enabled_successfully: "开启录像计划成功",
  recording_plan_is_in_progress_cannot_be_deld: "录像计划正在执行，禁止删除",
  recording_plan_time_conflicts_with_0: "录像计划设置时间与：{0}有冲突",
  recording_plan_update_failed: "录像计划更新失败",
  recording_playback_ended: "录像播放结束",
  recording_pls_try_again_later: "正在录像，请稍后再试",
  recording_saved_successfully: "保存录像成功",
  recording_save_failed: "保存录像失败",
  recording_source_platform: "录像来源：平台",
  recording_succeeded: "录制完成",
  recording_type: "录像类型",
  recording_video_save_and_exit: "正在录制中,是否保存并退出",
  record_does_not_exist: "记录不存在",
  record_from_d1_to_d2: "从 d1 开始录像，到 d2 结束",
  record_status: "记录状态",
  record_the_min_storage_time: "记录最低存储时间",
  record_video: "录像",
  rectangle: "矩形",
  recurring_task: "循环任务",
  red: "红",
  reddish_brown: "红棕",
  redhot: "红热",
  redis_server_exception: "redis服务器异常",
  redownload: "重新下载",
  red_brick: "红砖",
  red_shades: "渐变红",
  reflected_temp: "反射温度",
  reflected_temp_is_out_of_range: "反射温度超出范围",
  reflected_temp_is_required: "反射温度不能为空",
  refresh: "刷新",
  refreshing: "刷新中",
  refreshing_list: "正在刷新列表",
  refresh_alarm_subscription: "刷新报警订阅",
  refresh_cloud_platform_ip: "刷新云平台IP",
  refresh_completed: "刷新完成",
  refresh_device: "刷新设备",
  refresh_failed: "刷新失败",
  refresh_map: "刷新地图",
  refresh_successful: "刷新成功",
  refresh_the_list: "刷新列表",
  refresh_user_permissions: "刷新用户权限",
  refund: "退款",
  refunding: "退款中",
  refund_and_service: "退款&售后",
  refund_success: "退款成功",
  region: "区域",
  regional_statistics: "区域统计",
  region_config: "区域设置",
  region_io: "区域IO",
  region_linkage: "区域联动",
  region_name: "区域名称",
  region_number: "区域编号",
  region_number_reach_limit: "区域测温数量达到上限",
  region_or_font_color: "区域&字体颜色",
  region_qty_less_than: "区域数不能超过",
  region_temp: "区域温度",
  region_thermometry: "区域测温",
  region_type: "区域类型",
  register: "去注册",
  registered_password: "国标SIP设备注册密码",
  registration: "注册",
  regular_devices: "普通设备",
  reg_now: "立即注册",
  reissue: "再次下发",
  related_records: "关联记录",
  relative_time: "相对时间",
  relay: "继电器",
  release_to_load: "松开加载",
  release_to_refresh: "松手刷新",
  release_to_start_loading_data: "松手开始加载数据",
  relocation_completed: "重新定位完成",
  relocation_failed: "重新定位失败",
  remaining_unexecuted_point_count: "，剩余未执行点位数：",
  remaining_valid_duration: "剩余有效时长",
  remarks: "备注说明",
  remarks_cannot_exceed_100_characters: "备注不超过100字",
  remarks_should_not_exceed_100_characters: "备注字数不超过100字",
  remember_information: "记住信息",
  reminder_for_driving_distance: "行驶车距提醒",
  reminder_for_front_vehicle_start: "前车起步提醒",
  reminder_for_starting_distance: "起步车距提醒",
  remind_me_later: "以后再说",
  remote_battery_capacity: "遥控电量",
  remote_device: "远程设备",
  remote_device_control_live_img_view: "远程控制设备，实时查看图像",
  remote_files: "远程文件",
  remote_gallery: "远程图库",
  removal_successful: "移除成功",
  remove: "移除",
  remove_coriolis_effect: "删除科里奥利效应",
  remove_robot: "移除机器人",
  remove_target_failed: "剔除目标失败",
  rename: "重命名",
  renting: "租赁中",
  repeated_alarm_count: "重复报警次数",
  repeated_alarm_n_times: "重复报警{n}次",
  repeat_count: "重复次数",
  repeat_event_alarm_interval: "重复业务报警间隔",
  report_designer: "报告编辑器",
  report_downloaded_successfully: "报告下载成功",
  report_download_failed: "报告下载失败",
  report_export_failed: "报告导出失败",
  report_generating: "报正在生成",
  report_generation_time: "报告生成时间",
  report_has_been_downloaded: "报告已下载",
  report_info: "报告信息",
  report_loading: "报告加载中",
  report_number: "报告单号",
  report_template_settings: "报告模板设置",
  report_title: "报告标题",
  report_to_center: "上报到中心",
  report_type: "报告类型",
  reposition: "重新定位",
  requesting: "请求中",
  request_canceled: "请求被取消",
  request_error: "请求错误",
  reset: "重置",
  reset_alarm: "重置报警",
  reset_alarm_failed: "重置报警失败。",
  reset_failed: "重置失败",
  reset_password: "重置密码",
  reset_successful: "重置成功",
  reset_to_default_successful: "恢复默认成功",
  resolution: "分辨率",
  resolved: "已解决",
  resource: "资源",
  resource_id: "资源编号",
  resource_id_cannot_be_empty: "资源编号不能为空",
  resource_import_file_is_empty: "资源导入文件为空",
  resource_import_template_generation_failed: "资源导入模板生成失败",
  resource_information_management: "资源信息管理",
  resource_layer: "资源图层",
  resource_management: "资源管理",
  resource_name: "资源名称",
  resource_name_already_exists: "资源名称已存在",
  resource_name_cannot_be_empty: "资源名称不能为空",
  resource_name_only_allows_chinese_characters_numbers_english:
    "资源名称仅允许输入汉字、数字、英文、“-”、“_”",
  resource_name_required_name_must_be_unique: "资源名称(必填，名称不可重复)",
  resource_type: "资源类型",
  resource_type_cannot_be_empty: "资源类型不能为空",
  resource_type_name_only_allows_chinese_characters_numbers_englis:
    "资源类型名称仅允许输入汉字、数字、英文、“-”、“_”",
  resource_type_required: "资源类型(必填)",
  restart: "重启",
  restart_successful: "重启成功",
  restart_the_robot: "重启机器人",
  restart_to_take_effect: "切换成功，重启后生效",
  restore: "还原",
  restore_default: "恢复默认",
  restore_factory_settings: "恢复出厂设置",
  restore_task: "恢复任务",
  results_are_being_synchronized: "结果同步中",
  resume_execution: "重新执行",
  reticle: "分划",
  retry: "重试",
  retry_after_seconds: "秒后重新获取",
  retry_after_x_seconds: "X秒后重新获取",
  retu: "返回",
  return_to_app: "返回APP",
  return_to_charging_pile: "返回充电桩",
  return_to_charging_point: "返回充电点",
  return_to_charging_station: "返回充电仓",
  reverse_img: "倒像",
  reverse_img_display: "倒像显示",
  reverse_linkage: "反向联动",
  review_order: "查看订单",
  review_route: "查看轨迹",
  revoke_authorization: "取消授权",
  re_search: "重新搜索",
  right: "右",
  right_hand_twist: "右旋膛线",
  right_side: "右侧",
  right_side_device_status: "右侧设备状态",
  ring_graph: "环状图",
  robot: "机器人",
  robots_are_not_allowed_to_be_duplicated: "机器人不允许重复",
  robot_application_system: "机器人应用系统",
  robot_battery_config: "机器人电量配置",
  robot_control: "机器人控制",
  robot_details: "机器人详情",
  robot_hardware_failure_unable_to_continue_navigation:
    "机器人硬件故障无法继续导航",
  robot_has_reached_the_target_point: "机器人已到达目标点",
  robot_inspection_config: "机器人巡检配置",
  robot_integration: "机器人接入",
  robot_is_already_associated_with_an_organization_pls_unassociate:
    "机器人已关联组织，请解除关联后删除",
  robot_is_in_auto_mode_confirm_to_switch_to_manual_mode:
    "机器人处于自动模式，确定切换为手动模式吗?",
  robot_is_moving_task_cannot_be_resumed: "机器人处于移动中，无法恢复任务",
  robot_is_moving_to_the_target_point_manual_control_is_not_possib:
    "机器人正在前进到目标点中，无法进行手动控制",
  robot_is_offline: "机器人已离线",
  robot_list: "机器人列表",
  robot_location_lost: "机器人定位丢失",
  robot_locked: "机器人锁定",
  robot_malfunction: "机器人故障",
  robot_management: "机器人管理",
  robot_management_cloud_platform: "机器人管理云平台",
  robot_model: "机器人型号",
  robot_name: "机器人名称",
  robot_name_cannot_be_empty: "机器人名称不能为空",
  robot_network_exception_ope_failed: "机器人网络异常，操作失败",
  robot_not_bound: "未绑定机器人",
  robot_not_bound_to_map: "机器人未绑定地图",
  robot_offline: "机器人离线",
  robot_operating_voltage: "机器人工作电压",
  robot_point_inconsistent_with_platform: "机器人点位与平台不一致",
  robot_started_moving_towards_target_point: "机器人开始向目标点运动",
  robot_status: "机器人状态",
  robot_storage_config: "机器人存储配置",
  robot_successfully_switched_to_auto_mode: "机器人切换自动模式成功",
  robot_successfully_switched_to_manual_mode: "机器人切换手动模式成功",
  robot_system: "机器人系统",
  robot_unable_to_reach_target_point: "机器人无法到达目标点",
  robot_unresponsive: "机器人未响应",
  roi_temp: "roi测温",
  role: "角色",
  role_cannot_be_empty: "角色不能为空",
  role_data: "角色数据",
  role_id: "角色编号",
  role_information: "角色信息",
  role_management: "角色管理",
  role_name: "角色名称",
  role_name_cannot_be_empty: "角色名称不能为空",
  role_name_must_be_chinese_characters_or_letters_and_no_longer_th:
    "角色名称为中文或字母，且长度不超过20",
  role_name_must_be_letters_or_chinese_characters_and_no_longer_th:
    "角色名称为字母或中文，且长度不超过20",
  role_order: "角色顺序",
  role_order_cannot_be_empty: "角色顺序不能为空",
  role_settings: "角色设置",
  role_status: "角色状态",
  roof_materials: "屋顶材料",
  roof_of_the_car: "车顶",
  rotate_90clockwise: "顺时针旋转90°",
  rotate_90counterclockwise: "逆时针旋转90°",
  rotate_left: "左转",
  rotate_right: "右转",
  rotation_speed: "旋转速度",
  route_vector_layer: "路线矢量图层",
  row: "*列",
  row_details: "列内详情",
  row_no: "列号",
  rubber_soft_and_hard: "橡胶(软,硬质)",
  rule: "规则",
  rules_cannot_be_empty_and_there_must_be_at_least_one_enabled_rul:
    "规则不可为空，处于启用状态的规则不得少于一项。无法与规则匹配的报警，系统将认为其是误报，不予提示。",
  rule_name: "规则名称",
  rule_setting: "规则设置",
  rural_straw_burning: "农村秸秆",
  russian: "俄语",
  s: "秒",
  sailboat: "帆船",
  sale: "售",
  sales_volume: "销量",
  sales_volume_priority: "销量优先",
  same_as_browser_time: "与浏览器时间一致",
  same_as_current_location: "与当前位置一致",
  same_as_env_weather: "同环境天气",
  saturday: "周六",
  save: "保存",
  save_0_event_records: "保存0条事件记录",
  save_and_generate_reports: "保存并生成报告",
  save_as: "另存为",
  save_as_template: "保存为模板",
  save_curve: "保存曲线",
  save_directory: "保存路径",
  save_directory_is_required: "保存路径不能为空",
  save_failed: "保存失败",
  save_file: "保存文件",
  save_image: "保存图片",
  save_in_segment: "分段保存",
  save_password: "保存密码",
  save_path_format_error: "保存路径格式错误",
  save_path_starting_with_eg_mnt_record_storage:
    "保存路径,以 / 开头,如/mnt/record_storage",
  save_settings: "保存设置",
  save_settings_failed: "保存设置失败",
  save_success: "保存成功",
  save_view: "保存视图",
  scanning: "正在扫描",
  scan_qr_code: "扫描二维码",
  scan_tour: "扫描巡航",
  scan_to_download_app: "扫一扫下载APP",
  scene_mode: "场景模式",
  scheduled_reboot: "定时重启",
  scope: "瞄准镜",
  scope_calibration_unit: "瞄准镜计量单位",
  scope_height: "瞄准镜高度",
  scope_information: "瞄准镜信息",
  score: "分数",
  screenshot: "截图",
  screenshot_count: "截图(张)",
  screen_display: "画面显示",
  screen_tilt: "屏幕放倒",
  sd_card_detected_update: "检测到sd卡,开始更新",
  sd_card_is_full: "Sd卡已满",
  search: "搜索",
  searching: "搜索中",
  search_and_rescue_vessel: "搜救船",
  search_by_column_name: "输入栏位名搜索",
  search_by_informant: "根据告知人员搜索",
  search_by_robot_name: "根据机器人名称搜索",
  search_device: "搜索设备",
  search_failed: "搜索失败。",
  search_for_bluetooth_devices: "查找蓝牙设备",
  search_product: "搜索产品",
  search_resource: "搜索素材",
  secondary_server_status: "从服务器状态",
  second_calibration: "二次标定",
  select: "选择",
  selected: "已选中",
  select_all: "全选",
  select_color: "选择颜色",
  select_directory: "选择路径",
  select_the_current_wifi_name: "选择当前设备WiFi名称网络进行连接",
  seled: "已选择",
  selfie: "自拍",
  self_gps: "自身GPS",
  self_positioning: "自身定位",
  self_positioning_failed: "自身定位失败",
  sel_alarm_item: "选择报警项",
  sel_alarm_name: "选择报警名称",
  sel_alarm_source: "选择报警源",
  sel_channel: "选择通道",
  sel_coupon: "选择优惠券",
  sel_date: "选择日期",
  sel_device: "选择设备",
  sel_end_time: "选择结束日期",
  sel_inspection_points: "选择巡检点",
  sel_inspection_point_or_enter_distance: "选择巡检点或输入距离",
  sel_linkage_action: "选择联动动作",
  sel_notification_personnel: "选择告知人员",
  sel_parent_department: "选择上级部门",
  sel_picture: "选择图片",
  sel_pseudo_color: "选择伪彩",
  sel_recording_time: "选择录像时间",
  sel_robot: "选择机器人",
  sel_start_time: "选择开始日期",
  sel_the_wifi_network_with_current_device_name_to_connect:
    "选择含有当前设备名称的WiFi网络进行连接",
  sel_the_wifi_network_with_the_name_of_the_connecting_device:
    "根据连接设备选择正确的Wifi网络",
  sel_time: "选择时间",
  sel_time_cannot_be_empty: "选择时间不能为空",
  sel_time_range: "选择时间范围",
  sel_user: "选择用户",
  sending: "下发中",
  sending_failed: "发送失败",
  send_a_report: "发送报告",
  sensor: "传感器",
  sensor_alarm: "传感器报警",
  sensor_device: "机芯设备",
  sensor_malfunction: "传感器故障",
  sep: "九月",
  sequence: "轮巡",
  serial_number: "序列号",
  series: "系列",
  server_access_timeout: "访问服务器超时",
  server_address: "服务器地址",
  server_address_cannot_be_empty: "服务器地址不能为空",
  server_alarm: "服务器报警",
  server_background: "服务器后台",
  server_connection_failed: "连接服务器失败",
  server_ip_cant_be_empty: "服务器IP不能为空。",
  server_ip_invalid: "服务器IP无效。",
  server_offline: "服务器离线",
  server_port_cant_be_empty: "服务器端口不能为空。",
  server_recording_storage_settings: "服务器录像存储设置",
  service_exception: "服务异常",
  service_request_timed_out: "服务请求超时",
  servo: "舵机",
  servo_information: "舵机信息",
  servo_malfunction: "舵机异常",
  setting: "设置",
  settings_general_about_modify_name:
    "请参照以下路径修改手机热点的账号与设备一致：设置-通用-关于-修改名称；",
  settings_personal_hotspot_modify_settings_name_modify_password:
    "请按以下路径修改手机热点的账户密码与设备一致：设置-个人热点-修改设置名称-修改密码（不同手机型号可能有所差异）。",
  settings_successful_settings_failed_devices:
    "设置成功：{0}，设置失败：{1}，失败设备：{2}",
  setting_failed: "设置失败",
  setting_failed_pls_try_again: "设置失败，请重试",
  setting_in_process_pls_wait: "正在设置，请稍候",
  setting_success: "设置成功",
  settle: "结算",
  set_as_default: "设为默认",
  set_atmospheric_temp_failed: "设置环境温度失败",
  set_auto_tracking_succeeded: "设置自动跟随成功",
  set_brightness_failed: "设置亮度失败",
  set_color_palette_failed: "设置伪彩失败",
  set_contrast_failed: "设置对比度失败",
  set_dde_enabled_failed: "设置图像增强使能失败",
  set_dde_failed: "设置图像增强失败",
  set_distance_failed: "设置距离失败",
  set_emissisivity_failed: "设置发射率失败",
  set_filter_enabled_failed: "设置滤波使能失败",
  set_gain_mode_failed: "设置增益模式失败",
  set_image_flip_failed: "设置图像翻转失败",
  set_manual_tracking_succeeded: "设置手动跟随成功",
  set_measurement_range_failed: "设置测温范围失败",
  set_mobile_wifi: "设置手机WiFi",
  set_osd_failed: "设置网板叠加状态失败",
  set_phone_number_in_user_settings: "在用户设置中设置手机号",
  set_reflected_temp_failed: "设置反射温度失败",
  set_to_0: "设为 0",
  set_tracking_mode_failed: "设置跟随模式失败",
  set_tracking_status_failed: "设置跟随状态失败",
  set_transmittance_failed: "设置透过率失败",
  set_valid_environmental_parameters_failed: "设置环境参数生效失败",
  set_valid_env_parameters_succeeded: "设置环境参数生效成功",
  share: "分享",
  shared_channels: "已共享通道",
  shared_channel_number: "共享通道数",
  share_by_qrcode: "二维码分享",
  sheet_metal: "金属片",
  shield: "区域屏蔽",
  shielded_alarm: "屏蔽报警",
  shielded_area_config: "屏蔽区域设置",
  shielded_area_name: "屏蔽区域名称",
  shielded_area_sa: "屏蔽区域",
  shielding_distance_compensation: "屏蔽距离补偿",
  shield_area_layer: "屏蔽区域图层",
  shield_duration: "屏蔽时长",
  shield_name: "屏蔽名称",
  shield_range: "屏蔽范围",
  shipping_address: "收获地址",
  shipping_cost: "运费",
  shipping_credits: "配送费用",
  ships_equipped_with_pollution_prevention_facilities_or_equipment:
    "安装有防污染设施或设备的船",
  shld_ar_mgmt: "屏蔽区域管理",
  shooting_device: "拍摄设备",
  shooting_time: "拍摄时间",
  should_bigger_than_0: "应大于0",
  should_the_area_near_this_location_be_set_as_a_shieled_area:
    "是否将该位置附近设置成屏蔽区域？",
  show_details: "显示详情",
  show_logo: "显示Logo",
  show_only_malfunctioning_robots: "仅显示故障机",
  show_video: "展示视频",
  shutter: "快门",
  shutter_calibration_failed: "快门矫正失败",
  shutter_calibration_succeeded: "快门矫正成功",
  shutter_correction: "快门校正",
  shutter_correction_failed: "快门校正失败",
  sick_chicken_analysis: "病弱鸡分析",
  side_alarm_bar_switch: "侧边报警栏开关",
  signal_light: "信号灯",
  silk: "丝绸",
  simplified_chinese: "简体中文",
  single: "单次",
  single_frame_occurrence_confidence_threshold: "单帧/次可信阈值",
  single_rangefinding: "单次测距",
  single_task: "单次任务",
  sip_server_ip: "国标SIP服务器IP",
  sip_server_number: "国标SIP服务器编号",
  sip_server_number_should_be_20_characters_in_length:
    "国标SIP服务器编号长度应为20",
  sip_server_port: "国标SIP服务器端口",
  sip_service_ip: "SIP服务IP",
  sip_service_national_standard_code: "SIP服务国标编码",
  sip_service_national_standard_domain: "SIP服务国标域",
  sip_service_port: "SIP服务端口",
  skin: "皮肤",
  skip_frames: "跳帧",
  sky: "天空",
  slam_radar: "slam雷达",
  slam_radar_anomaly: "slam雷达异常",
  slam_radar_information: "slam雷达信息",
  slave_address: "从站地址",
  slave_address_range_2_254: "从站地址范围2-254",
  sleep: "休眠",
  slow: "慢放",
  slow_forward: "慢进",
  smart_image_capture_list: "智能拍摄列表",
  smart_import_will_automatically_create_single_ip_dual_channel_de:
    "智能导入将会自动创建单IP双通道设备关联关系、相似名称的单通道设备的关联关系，故在智能导入前，需设置系统内的设备名称和通道名称",
  smart_inspection_snapshot_is_disabled_under_visual_mode:
    "可见光模式暂不支持智能巡检拍摄",
  smart_patrol: "智能巡检",
  smart_patrol_tasks: "智能巡检任务",
  smokefire_detection: "烟火检测",
  smoke_detection: "烟雾检测",
  smoke_recognition_algorithm_visible: "烟识别算法(可见光)",
  smooth_black_paint: "平滑黑漆",
  sms: "短信",
  sms_login: "短信登录",
  sms_platform: "短信平台",
  sms_platform_account: "短信平台账号",
  sms_platform_password: "短信平台密码",
  sms_platform_settings: "短信平台设置",
  sms_sent: "短信已发送",
  sms_signature: "短信签名",
  sn: "sn码",
  snapshot: "抓图",
  snapshot_directory: "抓图路径",
  snapshot_failed: "抓图失败",
  snapshot_interval: "抓拍间隔时间",
  snapshot_limit_5_100: "抓拍张数限制5-100张",
  snapshot_resolution: "抓图分辨率",
  snapshot_success: "抓图成功",
  snapshot_time_limit_5_100s: "抓拍时间限制5-100S",
  snapshot_type: "抓图类型",
  sn_cannot_be_empty: "SN不能为空",
  software_license: "软件许可协议",
  software_license_and_services_agreement: "软件许可及服务协议",
  software_upgrade: "软件升级",
  software_ver: "软件版本",
  sold: "已售",
  solved: "解决",
  sorry_currently_no_data_available: "非常抱歉，目前暂无数据",
  sorry_this_feature_is_currently_occupied_by_the_computer_addres:
    "很抱歉，该功能已被{0}占用，该计算机地址为:{1}，MAC地址为：{2}，其使用完毕后您方能使用",
  sort: "排序",
  source: "设备源",
  source_address_error: "源地址错误",
  so_that_we_can_contact_you: "便于我们与您联系",
  space_cleanup_threshold: "空间清理阈值",
  spanish: "西班牙语",
  speaker: "喇叭",
  speaker_malfunction: "喇叭异常",
  special: "特殊",
  special1: "特殊1",
  special2: "特殊2",
  specified_time: "特定时间",
  speech_remarks: "语音备注",
  speed: "速度",
  speed_dome: "球机",
  speed_limit: "车速限制",
  speed_setting_failed: "速度设置失败",
  spot: "点测温",
  spot_number_reach_limit: "点测温数量达到上限",
  square_1_2_diagonal_length: "正方形，数字为1/2对角线长度",
  standby: "备用",
  start: "开始",
  start_a_new_order_after_settlement: "结算后再开启新订单",
  start_date: "开始日期",
  start_date_required: "开始日期不能为空",
  start_date_should_be_earlier_than_end_date: "开始日期应早于结束日期",
  start_frame_less_than_end_frame: "起始帧必须小于结束帧",
  start_from_d1_to_d2_record_from_t1_to_t2_for_each_w:
    "从 d1开始到 d2 结束， 每 w 的 t1 到 t2 录像",
  start_from_d_record_fromt1_to_t2_for_each_w_never_stop:
    "从 d 开始， 每 w 的 t1 到 t2 录像，永不结束",
  start_inspection: "开始巡检",
  start_locate: "开始定位",
  start_observing: "开始观测",
  start_recording: "开始录像",
  start_recording_failed: "开始录像失败",
  start_recording_success: "开始录像成功",
  start_smart_image_capture_auto_alarm_snapshot_paused:
    "智能拍摄开启,报警自动拍照暂停",
  start_time: "开始时间",
  start_timed_image_capture: "开始定时拍照",
  start_time_required: "开始时间不能为空",
  start_time_should_be_earlier_than_end_time: "开始时间应早于结束时间",
  start_tour: "开始巡航",
  start_upgrade: "开始升级",
  start_video_recording: "开始录制",
  start_zoom_speed: "启动变倍速度",
  start_zoom_speed_should_be_higher_than_end_zoom_speed:
    "启动变倍速度要求高于结束变倍速度",
  statistical_cloud_map: "统计云图",
  statistical_planning: "统计规划",
  statistical_results: "统计结果",
  statistical_rules: "统计规则",
  statistics: "统计",
  statistics_type: "统计类型",
  stats_failed: "统计失败。",
  status: "状态",
  steady_on: "常亮",
  step_1_configure_mobile_hotspot: "步骤1：配置手机热点",
  step_2_wait_for_the_device_to_connect: "步骤2：等待设备连接",
  step_3_device_connection_successful: "步骤3：设备连接成功",
  stone: "石头",
  stop: "停止",
  stop_alarm: "停止报警",
  stop_audio: "停止音频",
  stop_failed: "停止失败",
  stop_in_place: "停在原地",
  stop_moving_window: "停止移动窗口",
  stop_rangefinding: "停止测距",
  stop_record: "停止录像",
  stop_recording: "停止录制",
  stop_video_recording: "确定停止录制",
  storage: "存储",
  storage_space_alarm: "存储空间报警",
  storage_space_alarm_threshold: "存储空间报警阈值",
  storage_temperature_range: "存储温度",
  streaming: "码流",
  streaming_failed: "推流失败",
  streaming_media_server_exception: "流媒体服务器异常",
  streaming_media_server_ip: "流媒体服务器IP",
  streaming_media_server_port: "流媒体服务器端口",
  streaming_successful: "推流成功",
  stream_playback_failed: "播流失败",
  stream_switch_failed: "切换码流失败",
  stream_switch_succeeded: "切换码流成功",
  street_building_number_house_number: "街道、楼号、门牌号",
  strong_aluminium_oxide: "强氧化铝",
  stuck_chicken: "卡鸡",
  stuck_chicken_alarm: "卡鸡报警",
  stuck_chicken_analysis: "卡鸡分析",
  submission_failed: "提交失败",
  submission_failed_pls_check_your_network_connection:
    "提交失败，请检查网络连接",
  submit: "提交",
  submitted: "提交成功",
  submit_and_continue: "提交并继续",
  submit_order: "提交订单",
  subnet_mask: "子网掩码",
  subscriber_does_not_exist: "订阅人不存在",
  subscription_added_successfully: "添加订阅成功",
  subscription_information_already_exists_pls_modify_the_existing_:
    "已有订阅信息，请在原有基础上修改",
  subscription_information_does_not_exist: "订阅信息不存在",
  sub_application: "从应用",
  sub_stream: "辅码流",
  success: "成功",
  success_prompt: "成功提示",
  success_to_del_data_in_cloud: "从云平台删除成功",
  suggestions_and_feedback: "建议与反馈",
  suggest_for_you: "为你推荐",
  sunday: "周日",
  superior_function: "上级功能",
  superior_organization: "上级组织",
  superior_platform_code: "上级平台编码",
  superior_platform_ip: "上级平台IP",
  superior_platform_port: "上级平台端口",
  superior_platform_status: "上级平台状态",
  superior_sip_service_ip: "上级SIP服务IP",
  superior_sip_service_national_standard_code: "上级SIP服务国标编码",
  superior_sip_service_national_standard_domain: "上级SIP服务国标域",
  superior_sip_service_port: "上级SIP服务端口",
  super_admin_cannot_be_modified: "超级管理员不给予修改",
  super_resolution: "超分辨率",
  super_resolution_off: "关闭超分",
  super_resolution_on: "开启超分",
  sure_to_cancel_the_order: "确定取消订单吗",
  sure_to_close_the_order_and_settle: "您确定要结束订单并结算吗",
  surface: "面",
  surplus: "剩余",
  suspected_abnormal: "疑似异常",
  suspected_chicken_opening_mouth_detected: "疑似检测到鸡张嘴",
  suspected_dead_chickens_found_in_chicken_cage_x_x_layer_x:
    "鸡笼x-x第x层疑似发现死鸡",
  suspected_dead_chicken_detected: "疑似发现死鸡",
  suspected_dirty_chicken_coop_detected: "疑似检测到鸡笼脏污",
  suspected_discovery: "疑似发现",
  suspected_false_alarm: "疑似误报",
  suspected_non_laying_chicken_detected: "疑似发现绝产鸡",
  suspected_normal: "疑似正常",
  suspected_presence: "疑似存在",
  suspected_presence_of_x_chickens: "疑似存在x只",
  suspected_trapped_chicken_detected: "疑似发现卡鸡",
  suspected_uneven_feed_line_detected: "疑似检测到料线不均匀",
  suspected_water_line_anomaly_detected: "疑似检测到水线异常",
  suspected_weak_chicken_detected: "疑似发现弱鸡",
  switching_device_network: "正在切换设备网络",
  switching_failed_current_status_unchanged: "切换失败，当前状态不变",
  switching_successful_current_mode_is_1_restart_to_take_effect:
    "切换成功,当前模式%1,重启生效",
  switching_successful_in_high_gain_mode_now: "切换成功，当前状态为高增益",
  switching_successful_in_low_gain_mode_now: "切换成功，当前状态为低增益",
  switching_to_high_gain_mode_pls_wait: "即将切换为高增益，请耐心等待",
  switching_to_low_gain_mode_pls_wait: "即将切换为低增益，请耐心等待",
  switch_main_tream: "切换主码流",
  switch_mode: "切换模式",
  switch_soon: "即将切换",
  switch_sub_stream: "切换子码流",
  switch_successful: "切换成功",
  switch_target_failed: "切换目标失败",
  switch_tracking: "切换追踪",
  switch_view: "切换视图",
  sync: "同步",
  synchronization_time_failed: "同步时间失败",
  synchronization_time_succeeded: "同步时间成功",
  sync_phone_time_to_the_device: "将手机时间同步至设备",
  sync_playback: "同步回放",
  sync_points: "点位同步",
  sync_successful: "同步成功",
  sync_time: "同步时间",
  sync_to_platform: "同步至平台",
  system: "系统",
  system_alarm_email_subject: "【系统通知】系统运行报警统计通知",
  system_alarm_statistics_sending_settings: "系统报警统计发送设置",
  system_config: "系统配置",
  system_error: "系统错误",
  system_functions: "系统功能",
  system_function_mode: "系统功能模式",
  system_information: "系统信息",
  system_is_playing_a_video_do_you_want_to_shut_down:
    "系统正在播放录像，是否选择关机?",
  system_is_recording_do_you_want_to_shut_down: "系统正在录像，是否选择关机?",
  system_logo: "系统Logo",
  system_maintenance: "系统维护",
  system_management: "系统管理",
  system_name: "系统名称",
  system_name_cannot_exceed_10_characters: "系统名称不超过10字",
  system_setting: "系统设置",
  system_time: "系统时间",
  system_ver_information: "系统版本信息",
  sys_dev_online_ratio: "系统设备在线比例",
  s_resend: "s后重发",
  s_serial: "S系列",
  target_auto_excl: "目标自动剔除",
  target_azimuth_angle: "目标方位角度",
  target_distance: "目标距离",
  target_elevation_angle: "目标俯仰角度",
  target_gps: "目标GPS",
  target_latitude_and_longitude: "目标经纬度",
  target_location: "目标位置",
  target_point: "目标点",
  target_point_latitude: "目标点纬度",
  target_point_longitude: "目标点经度",
  target_positioning: "目标定位",
  target_positioning_failed: "目标定位失败",
  target_tracking: "切换目标跟随",
  target_traj_overlay: "目标轨迹叠加",
  target_type: "目标类型",
  tas: "测温分析系统",
  task: "任务",
  task_can_be_issued: "任务可以下发",
  task_completion_rate: "任务完成度",
  task_creation_time: "任务创建时间",
  task_details: "任务详情",
  task_distribution_failed_for_the_same_robot_recurring_tasks_and_:
    "任务下发失败，针对同一机器人，循环任务与定时任务不能同时存在",
  task_distribution_failed_only_one_recurring_task_can_be_issued_f:
    "任务下发失败，同一机器人仅能下发一个循环任务",
  task_distribution_invalid_cyclic_tasks_and_scheduled_tasks_canno:
    "任务下发无效！同一机器人，循环任务与定时任务不能同时存在",
  task_distribution_invalid_cyclic_task_start_and_end_times_cannot:
    "任务下发无效！循环任务开始和结束时间不能为空",
  task_distribution_invalid_only_one_cyclic_task_can_be_issued_for:
    "任务下发无效！同一机器人仅能下发一个循环任务",
  task_distribution_invalid_same_named_task_already_exists_for_the:
    "任务下发无效！机器人同名任务已存在",
  task_distribution_invalid_scheduled_task_start_time_cannot_be_wi:
    "任务下发无效！定时任务开始时间不允许在3分钟以内",
  task_end_time: "任务结束时间",
  task_execution: "任务执行",
  task_execution_frequency: "任务执行频率",
  task_execution_method: "任务执行方式",
  task_files_not_existed: "任务文件不存在",
  task_file_format_error: "任务文件格式错误",
  task_in_progress: "任务执行中",
  task_issuance: "任务下发",
  task_name: "任务名",
  task_name_already_exists_pls_modify_and_try_again:
    "任务名称已存在，请修改重试",
  task_name_cannot_be_empty: "任务名称不能为空",
  task_name_must_be_letters_numbers_or_chinese_characters_and_no_l:
    "任务名称为字母、数字或中文，且长度不超过20",
  task_name_validation_passed: "任务名称验证通过",
  task_progress: "任务进度",
  task_ready: "任务就绪",
  task_start_time: "任务开始时间",
  task_start_time_cannot_be_empty: "任务开始时间不能为空",
  task_status: "任务状态",
  task_success_rate: "任务成功率",
  task_template: "任务模板",
  task_template_cannot_be_empty: "任务模版不能为空",
  task_template_not_imported: "未导入任务模板",
  task_template_not_seled_cannot_import: "未选择任务模板,无法导入",
  task_termination: "任务终止",
  task_termination_failure: "任务终止失败",
  task_type: "任务类型",
  taxpayer_identification_number: "纳税人识别号",
  temp: "温度",
  temperature_parameter_settings: "温度参数设置",
  temperature_trend_display: "温度趋势显示",
  temperature_video_recording_mode: "温度视频录像模式",
  template_content: "模板内容",
  template_has_been_deld_pls_sel_again: "模板已删除，请重新选择",
  template_name: "模板名称",
  template_name_cannot_be_empty: "模板名称不能为空",
  template_name_duplicate: "模版名称重复",
  temp_alarm: "温度报警",
  temp_and_humidity_sensor_abnormal: "温湿度传感器异常",
  temp_calibration: "温度修正",
  temp_chart: "测温温度图",
  temp_cloud_map: "温度云图",
  temp_collection: "温度采集",
  temp_curve: "温度曲线",
  temp_diff: "差值温度",
  temp_difference: "温差",
  temp_difference_absolute_value: "温差绝对值",
  temp_difference_alarm: "温差报警",
  temp_difference_equal_to: "温度差值等于",
  temp_difference_greater_than: "温度差值大于",
  temp_difference_less_than: "温度差值小于",
  temp_error: "温度误差",
  temp_exceeds_limit: "温度超标",
  temp_greater_than: "温度大于",
  temp_icon_style: "温度样式",
  temp_information_display_mode: "温度信息显示模式",
  temp_interval: "温度区间",
  temp_less_than: "温度小于",
  temp_level_threshold_is_required: "温度级别阈值不能为空",
  temp_lower_limit_over_floating: "温度下限值超浮",
  temp_meas: "测温",
  temp_measurement_analysis_report: "测温分析报告",
  temp_measurement_enabled_successfully: "开启测温成功",
  temp_measurement_enablement_failed: "开启测温失败",
  temp_measurement_gear: "测温档位",
  temp_measurement_rule_name: "测温规则名称",
  temp_meas_rule: "测温规则",
  temp_range: "温宽拉伸范围",
  temp_range_setting: "温宽拉伸范围设置",
  temp_record: "测温记录",
  temp_rise: "温升温度",
  temp_rise_alarm: "温升报警",
  temp_rise_alarm_rise_by_t_every_s1_seconds_lasting_for_s2_secon:
    "温升报警(每{s1}秒升高{t}℃，持续{s2}秒)",
  temp_rise_alarm_rise_by_t_every_s_seconds_for_n_times:
    "温升报警(每{s}秒升高{t}℃，持续{n}次)",
  temp_rise_level_threshold_is_required: "温升级别阈值不能为空",
  temp_rise_threshold_is_required: "温升阈值不能为空",
  temp_rise_time_interval: "温升时间间隔",
  temp_sensor_status: "温度传感器状态",
  temp_slope: "温度斜率",
  temp_slope_equal_to: "温度斜率等于",
  temp_slope_greater_than: "温度斜率大于",
  temp_slope_less_than: "温度斜率小于",
  temp_statistics: "测温统计",
  temp_threshold_is_required: "温度阈值不能为空",
  temp_unit: "温度单位",
  temp_upper_limit_over_floating: "温度上限值超浮",
  temp_video_is_cannot_displayed_on_the_device: "温度视频不支持设备端播放",
  "temp℃": "温度(℃)",
  tenant_id_cannot_be_empty: "租户ID不能为空",
  ten_minutes: "10分钟",
  terminate: "终止",
  terminated_successfully: "中止成功",
  terminate_again: "再次终止",
  testing_environment: "测试环境",
  test_alarm: "模拟报警",
  test_reports: "测试报告",
  text_remarks: "文字备注",
  text_setting: "文本设置",
  tgt_dist_m: "目标距离(m)",
  thank_you_for_your_participation: "感谢您的参与",
  there_are_bound_users_under_this_role: "该角色下有绑定的用户",
  there_are_no_bound_users_under_this_role: "该角色下无绑定的用户",
  there_are_no_channels_being_playback: "没有正在播放的频道",
  there_are_no_channels_being_previewed: "没有正在预览的通道",
  there_are_still_count_points_not_inspected: "还有{count}个点未巡检",
  there_are_still_unprocessed_alarms_are_you_sure_you_want_to_leav:
    "还存在未处理的报警，确定不处理就离开吗？",
  there_are_users_bound_to_this_role_pls_unbind_all_users_before_d:
    "该角色下存在绑定的用户，请解绑所有用户后删除",
  there_can_be_no_cross_overlapping_isothermal_temperature_ranges:
    "等温带温度范围不能有交叉重叠",
  there_is_already_a_loop_task_on_the_device: "边端已存在循环任务",
  there_is_an_unfinished_video_export_task_pls_try_again_later:
    "当前有尚未完成的视频导出任务，请稍后再试",
  there_is_a_file_with_the_same_name_in_the_current_path:
    "当前路径下有同名文件",
  there_must_be_at_least_one_active_rule: "处于启用状态的规则不得少于一项",
  thermal: "单热图",
  thermal_camera: "红外相机",
  thermal_camera_information: "红外相机信息",
  thermal_camera_ver: "红外相机版本",
  thermal_fire: "热成像-火点",
  thermal_fire_detection: "热成像火点检测",
  thermal_fire_spreading: "热成像-火势变大",
  thermal_imaging_mode: "热成像模式",
  thermal_imgs: "红外图像",
  thermal_parameters: "红外参数",
  thermal_screenshot: "红外截图",
  thermal_x1_visual_x1: "单热图单可见光",
  thermo_center: "测温中心",
  thermo_report: "测温报告",
  thermo_report_template: "测温报告模板",
  the_affiliated_map_cannot_be_empty: "所属地图不能为空",
  the_affiliated_robot_cannot_be_empty: "所属机器人不能为空",
  the_allowed_input_distance: "允许输入的距离为",
  the_allowed_input_emissivity_is: "允许输入的辐射率为",
  the_allowed_input_env_temp_is: "允许输入的环境温度为",
  the_allowed_input_humidity_is: "允许输入的湿度为",
  the_allowed_reflected_temp: "允许输入的反射温度为",
  the_app_needs_to_use_your_local_network_to_send_the_broadcast:
    "App需要使用你的本地网络来发送广播",
  the_associated_inspection_task: "所属巡检任务",
  the_bad_pixel_is_being_saved: "盲元设置正在保存",
  the_blackhot_is_disabled_under_isotherm_mode: "等温线功能下黑热色板不可用",
  the_charging_point_cannot_be_empty: "充电点位不能为空",
  the_column_number_should_be_a_positive_integer: "列号格式为正整数",
  the_current_device_name_is_unable_to_capture_image: "当前设备名过长,无法拍摄",
  the_current_directory_contains_submenus_pls_del_the_submenus_fir:
    "当前目录含有子菜单, 请先删除子菜单",
  the_current_network_is_not_available_pls_connect_to_the_internet:
    "当前网络不可用，请将网络连接至互联网",
  the_current_ope_will_modify_the_existing_recording_schedule_time:
    "当前操作会使原有录像计划时间修改，将停止原有录像计划，按新时间计划执行, 是否继续?",
  the_current_robot_is_in_auto_mode_and_cannot_be_controlled:
    "当前机器人为自动模式，无法操控",
  the_current_software_ver_is: "当前软件版本为",
  the_current_video_is_not_playing_so_recording_is_not_possible:
    "当前视频未在播放，无法录制",
  the_current_video_is_not_playing_unable_to_capture_img:
    "当前视频未在播放，无法截取图像",
  the_data_volume_is_too_large_and_the_remaining_alarm_records_can:
    "数据量过多，剩余报警记录无法继续导出",
  the_device_already_exists: "设备已存在",
  the_device_discovered_an_emergency_in_the_direction_direction_at:
    "设备在{direction}方向{distance}处({villageName})发现警情。",
  the_device_does_not_currently_support_this_functionality:
    "设备暂不支持此功能",
  the_device_information_will_be_removed_after_factory_reset:
    "恢复出厂后设备信息会清空",
  the_device_is_currently_in_continuous_rangefinding_do_you_want_t:
    "设备当前处于连续测距中，是否停止",
  the_device_is_disabled: "该设备已禁用",
  the_device_is_upgrading_exiting_now_may_cause_the_upgrade_to_fai:
    "设备正在升级，当前退出可能导致设备升级失败",
  the_device_name_only_supports_chinese_and_english_numbers_dots_h:
    "设备别名仅支持中英文、数字、点、横杠、下划线",
  the_device_will_restart_shortly_pls_reconnect_to_the_device_late:
    "设备即将重启，稍后请重新连接设备",
  the_end_time_must_be_later_than_the_start_time: "结束时间需要晚于开始时间",
  the_horizontal_axis_must_increase_sequentially: "水平坐标必须依此增大",
  the_identifier_prefix_for_common_channel_0_does_not_match_the_de:
    "普通通道{0}的标识前缀与设备配置不一致，请检查",
  the_identifier_prefix_for_eos_channel_0_does_not_match_the_devic:
    "周扫通道{0}的标识前缀与设备配置不一致，请检查",
  the_image_has_already_been_captured: "该图片已拍摄,是否重新拍摄",
  the_information_of_the_cage_layer_is_incomplete: "列笼层信息不全",
  the_inspection_task_is_in_progress_pls_end_first: "巡检任务正在进行,请先结束",
  the_last_device_in_the_list_has_already_been_captured:
    "列表最后一个设备已拍摄完成",
  the_linked_channel_does_not_exist_in_the_system: "系统中不存在该联动通道",
  the_linked_device_does_not_exist_in_the_system: "系统中不存在该联动设备",
  the_max_env_temp_is_set_as: "环境温度最高设置为",
  the_max_reflected_temp_is_set_as: "反射温度最高设置为",
  the_min_env_temp_is_set_as: "环境温度最低设置为",
  the_min_illumination_of_visible_light: "可见光低照度",
  the_min_reflected_temp_is_set_as: "反射温度最低设置为",
  the_mobile_number_has_been_registered: "手机号码已经被注册",
  the_network_communication_is_abnormal_and_the_n1_inspection_task:
    "网络通信异常，{n1}巡检任务生成失败",
  the_next_day: "次日",
  the_number_of_digits_for_the_account_must_be_20_and_only_numbers:
    "账号输入位数需<=20，且仅允许输入数字/英文",
  the_number_of_triggers_for_intelligent_analysis_is_too_low:
    "触发智能研判次数过低",
  the_organization_name_is_a_combination_of_letters_numbers_or_chi:
    "组织名称为字母、数字或中文组合，且长度不超过20",
  the_password_does_not_meet_the_requirements: "密码不符合要求",
  the_password_length_is_8_16_characters: "密码长度为8~16",
  the_password_must_be_8_20_characters_long_and_include_both_numbe:
    "密码输入位数需8-20，同时包括数字及英文",
  the_password_should_be_5_20_characters: "密码5~20位字符",
  the_past_month: "近一月",
  the_past_three_months: "近三月",
  the_phone_is_connected_to_the_same_wi_fi_as_the_device:
    "手机与设备连接至同一Wi-Fi",
  the_phone_number_is_not_linked_to_any_account: "手机号未绑定账号!",
  the_preview_screen_shows_the_temperature: "预览画面显示温度",
  the_pwd_should_be_more_than_6_chars: "密码长度需大于6",
  the_pwd_should_be_more_than_8_chars: "密码长度需大于8",
  the_query_time_span_is_12_hour: "可查询时间跨度为12小时",
  the_query_time_span_is_1_hour: "可查询时间跨度为1小时",
  the_query_time_span_is_24_hour: "可查询时间跨度为24小时",
  the_range_maximum_value_needs_to_be_bigger_than_the_max:
    "注意：温宽拉伸范围最高值应大于最高温",
  the_range_minimum_value_needs_to_be_less_than_the_min:
    "注意：温宽拉伸范围最低值应小于最低温",
  the_range_minimum_value_needs_to_be_less_than_the_range_maximum:
    "注意：温宽拉伸范围最低值应小于最高值",
  the_recorded_file_has_reached_2gb_limit_pls_stop_recording:
    "录像文件已达2GB，请手动停止录像",
  the_recorded_file_has_reached_5gb_limit_pls_stop_recording:
    "录像文件已达5GB，请手动停止录像",
  the_report_is_being_exported_pls_view_it_under_the_specified_pat:
    "报表正在导出，请到该路径下查看",
  the_robot_is_already_bound_to_the_chicken_coop_pls_choose_again:
    "机器人已绑定鸡舍，请重新选择",
  the_robot_is_in_an_unlocked_state_are_you_sure_you_want_to_switc:
    "机器人处于解锁状态，确定切换为锁定状态吗？",
  the_robot_is_in_auto_mode_are_you_sure_you_want_to_switch_to_man:
    "机器人处于自动模式，确定切换为手动模式吗",
  the_robot_is_in_a_locked_state_are_you_sure_you_want_to_switch_t:
    "机器人处于锁定状态，确定切换为解锁状态吗？",
  the_rule_cannot_be_empty_and_cannot_continue_to_be_deld:
    "规则不可为空，不可继续删除",
  the_same: "同上",
  the_same_channel_cannot_have_multiple_associated_groups:
    "同一通道不能有多个关联组",
  the_selected_quantity_is: "已选择数量",
  the_server_is_having_a_hiccup_pls_try_again_later:
    "服务器开小差了，请稍后再试",
  the_slave_address_cannot_be_empty: "从站地址不能为空",
  the_specified_gb_standard_device_cannot_be_found_pls_check_if_th:
    "查询不到指定的国标设备，请检查设备是否脱机",
  the_system_does_not_support_this_device: "系统不支持此设备",
  the_system_is_initializing: "系统正在初始化",
  the_system_license_has_expired: "系统许可已到期",
  the_system_license_is_about_to_expire: "系统许可即将到期",
  the_target_has_left_the_alert_area_and_cannot_be_tracked:
    "目标已离开警戒区，无法追踪",
  the_template_name_already_exists: "模板名称已存在",
  the_template_name_or_content_cannot_be_empty: "模板名称或内容不能为空",
  the_template_name_should_consist_of_letters_numbers_or_chinese_c:
    "模板名称为字母、数字或中文，且长度不超过20",
  the_time_span_is_longer_than_2_hours: "时间跨度超过2小时",
  the_time_span_is_longer_than_one_day: "时间跨度超过一天",
  the_trigger_channel_does_not_exist_in_the_system: "系统中不存在该触发通道",
  the_trigger_device_does_not_exist_in_the_system: "系统中不存在该触发设备",
  the_username_only_supports_chinese_and_english_numbers_dots_hori:
    "用户名仅支持英文、数字、点、横杠、下划线",
  the_user_does_not_have_video_playback_permission_for_this_device:
    "该用户没有该设备录像回放权限",
  the_user_has_the_permission_to_record_and_replay_videos_on_the_device:
    "该用户有该设备录像回放权限",
  the_user_is_currently_unauthorized: "该用户当前无授权",
  the_video_is_currently_being_exported_mp4_after_deletion_the_exp:
    "当前该视频正在导出mp4，删除后将自动取消导出任务",
  the_view_of_the_linkage_ipc_is_beyond_the_panoramic_field_of_vie:
    "联动IPC所视超出全景视场，无法反向联动",
  the_whitehot_is_disabled_under_isotherm_mode: "等温线功能下白热色板不可用",
  the_wifi_name_does_not_meet_the_requirements: "WiFi名称不符合要求",
  the_wifi_name_length_is_1_32_characters: "WiFi名称长度为1~32",
  third_party_service_exception: "三方服务异常",
  this_bullet_cannot_be_deld: "该子弹不允许删除",
  this_channel_is_already_favorited: "该通道已经被收藏",
  this_channel_of_the_device_is_offline: "该设备此通道已离线",
  this_device_channel_has_been_deld: "该设备通道已删除",
  this_device_channel_is_offline: "该设备此通道已脱机",
  this_function_can_only_be_enabled: "该功能需要连接设备以后才能使用",
  this_is_already_the_first_alarm: "当前已是最前一条报警",
  this_is_already_the_last_alarm: "当前已是最后一条报警",
  this_is_a_piece_of_content: "这是一段内容",
  this_location_is_within_a_surveillance_blind_spot: "该位置为监控盲区",
  this_node_does_not_exist: "该节点不存在",
  this_organization_has_sub_organizations_cannot_be_deld:
    "该组织下有子组织，无法删除",
  this_organization_is_already_associated_with_a_face_database_can:
    "该组织已经关联人脸库，无法删除",
  this_organization_is_already_associated_with_users_cannot_be_del:
    "该组织已经关联用户，无法删除",
  this_organization_is_associated_with_devices_cannot_be_deld:
    "该组织已关联设备，无法删除",
  this_phone_number_is_already_in_use: "该手机号已经被使用",
  this_protocol_is_not_currently_supported: "暂不支持此协议",
  this_record: "本记录",
  this_robot_has_no_subordinate_channels_video_playback_is_not_pos:
    "该机器人无下属通道，无法进行视频播放",
  this_role_is_bound_to_users_cannot_be_deld: "该角色已绑定用户，无法删除",
  this_role_name_already_exists: "该角色名称已经存在",
  this_user_does_not_have_permi_to_capture_device_imgs:
    "该使用者没有设备抓图权限",
  this_user_does_not_have_permi_to_take_snapshots: "该用户没有设备抓图权限",
  this_user_does_not_have_ptz_control_permi_to_stop_this_device:
    "该使用者没有云台控制权限停止此设备",
  this_user_has_no_operable_devices: "该使用者没有可操作的设备",
  this_user_has_no_permi_to_download_device_recordings:
    "该用户没有该设备录像下载权限",
  this_user_has_no_permi_to_play_this_device: "该使用者没有权限播放此设备",
  this_user_has_no_subscription_information: "该用户没有订阅信息",
  this_user_has_permi_to_download_device_recordings:
    "该用户有该设备录像下载权限",
  this_video_is_currently_being_exported_mp4_do_you_want_to_re_exp:
    "该视频当前正在导出mp4，是否重新导出",
  this_video_server_is_associated_with_devices_pls_remove_the_asso:
    "该视频服务器已关联设备，请解除关联后再删除",
  three_primary_colors: "三原色",
  three_times_or_more: "三次及以上",
  threshold: "阈值",
  threshold_for_repeated_alarm_times: "重复报警次数阈值",
  threshold_for_repeated_alarm_times_cannot_be_empty:
    "重复报警次数阈值不能为空",
  threshold_range_must_be_greater_than_0: "阈值范围需大于0",
  threshold_range_must_be_less_than_or_equal_to_1: "阈值范围需小于等于1",
  threshold_switch: "阈值开关",
  thumbnail: "缩略图",
  thursday: "周四",
  tilt_lock_pitch_lock: "俯仰锁定",
  time: "时间",
  timed_tasks: "定时任务",
  timeline_format: "时间轴格式",
  timer_photo: "定时拍照",
  times: "*次",
  time_calibration_config: "校时配置",
  time_calibration_interval: "校时时间间隔",
  time_calibration_method: "校时方式",
  time_cost: "时间费用",
  time_interval_should_not_be_less_than_5s: "时间间隔不小于5s。",
  time_of_payment: "支付时间",
  time_price: "时间单价",
  time_span_cannot_exceed_24h: "时间跨度不能超过24h。",
  time_span_cannot_exceed_2h: "时间跨度不能超过2小时。",
  time_span_cannot_exceed_3_days: "时间跨度不能超过3天。",
  time_span_cannot_exceed_3_months: "时间跨度不能超过3个月。",
  time_span_cannot_exceed_5_min: "时间跨度不能超过5分钟。",
  time_span_cannot_exceed_6_months: "时间跨度不能超过6个月。",
  time_sync: "校时",
  time_synchronization: "时间同步",
  time_synchronization_interval_cannot_be_empty: "校时时间间隔不能为空",
  time_synchronization_interval_must_be_numeric: "校时时间间隔为数字",
  time_sync_setting: "校时设置",
  title: "标题",
  to: "至",
  today: "今天",
  todays_alarmed_points: "今日报警点位",
  todays_inspected_points: "今日巡检点位",
  token_auth_failed: "token认证失败",
  token_error_pls_check_device_time: "令牌错误,请检查设备时间",
  tolerance_temp: "容差温度",
  too_many_drawing_points_pls_redraw: "绘制点数过多，请重新绘制",
  top_left: "左上",
  top_level_menu: "顶级菜单",
  top_right: "右上",
  total: "总数",
  totally_rusted_cast_iron: "完全生锈铸铁",
  totally_rusted_iron_plate: "完全生锈铁板",
  totally_rusted_roll_iron_plate: "完全生锈轧铁板",
  totally_rusted_steel_oxide: "完全生锈氧化钢",
  total_entries: "共*条",
  total_frames: "帧数",
  total_height: "总高度",
  total_inspection_tasks: "总巡检任务",
  total_inventory: "盘点总数",
  total_number_of_ai_recognition_imgs_since_the_start_of_img_captu:
    "从开始截取图像后，总计截取的AI识别图像总量",
  total_number_of_columns: "栏位总数",
  total_number_of_dead_chickens: "死鸡总数",
  total_number_of_frames_for_ai_recognition_extraction: "AI识别取帧总量",
  total_number_of_pigsties: "猪栏总数",
  total_weight: "总重量",
  total_weight_of_column: "栏总重量",
  tour: "巡航",
  towboat: "拖轮",
  to_achieve_automatic_ptz_tracking_trajectory_recognition_in_the_:
    "为达到云台自动跟踪目标效果，需开启检测区域的轨迹识别。",
  to_adjust_the_ambient_temp_ensure_that_the_atmos_transmittance_i:
    "调整环境温度，需保证大气透过率小于1，请调整大气透过率",
  to_adjust_the_reflection_temp_ensure_that_the_emissivity_is_less:
    "调整反射温度，需保证发射率小于1，请调整发射率",
  to_settle: "去结算",
  tracking_status: "跟随状态",
  traditional_chinese: "繁体中文",
  trajectory_settings: "弹道设置",
  transfer_failed: "传输失败",
  transfer_firmware: "传输固件",
  transmission_mode: "传输模式",
  transmittance: "透过率",
  transmittance_is_out_of_range: "透过率超出范围",
  transmittance_is_required: "透过率不能为空",
  tripwire_intrusion: "绊线入侵",
  tropical: "热带",
  true_east: "正东",
  true_heading_of_vessel: "船艏真航向",
  true_north: "正北",
  true_south: "正南",
  true_west: "正西",
  tuesday: "周二",
  tugboat: "拖船",
  turkish: "土耳其语",
  turning_on_location_switch_required: "需要打开定位开关",
  turn_off_io_time: "(自动关闭报警)过滤时间",
  turn_on_message_notification_to_receive_device_information_in_ti:
    "开启消息通知，及时接收设备信息",
  twenty_minutes: "20分钟",
  twice: "两次",
  twist_rate: "缠线步距",
  two_point_rangefinding: "两点测距",
  type: "类型",
  typec_usb_interface: "Type-C USB接口",
  t_serial: "T系列",
  ultrasonic: "超声波",
  ultrasonic_anomaly: "超声波异常",
  unable_to_add_the_device_pls_install_the_certificate:
    "设备无法添加，请安装证书",
  unable_to_add_the_device_the_certificate_has_expired_pls_contac:
    "设备无法添加，证书已经过期；请联系管理员进行授权",
  unable_to_add_the_device_the_number_of_channels_exceeds_the_auth:
    "设备无法添加，通道数超过授权数量;请联系管理员进行授权",
  unable_to_del_while_downloading: "下载中，无法删除",
  unable_to_get_channel_information: "无法获取信道信息",
  unable_to_get_device_information: "无法获取设备信息",
  unable_to_get_device_information_pls_confirm_if_the_device_is_co:
    "无法获取设备信息，请确认是否已连接设备",
  unable_to_locate_the_fire_point: "未能定位火点",
  unable_to_read_file_format: "无法读取文件格式",
  unable_to_recognize_vessel_type: "无法识别船只类型",
  unable_to_record_temporarily: "暂时无法录像",
  unanalyzable_file: "此文件不能分析",
  unassigned: "未分配",
  unassociated: "未关联",
  unauthorized: "未授权",
  unbind: "解绑",
  unbind_user: "解绑用户",
  unbound: "未绑定",
  unbound_successfully: "解绑成功",
  uncertificated: "待认证",
  unchangeable_during_linkage_recording: "有通道联动录像中，不可修改",
  unconfirmed: "未确认",
  unconnected_device: "设备未连接",
  undeletable: "不能删除",
  undeletable_during_linkage_recording: "有通道联动录像中，不可删除",
  uneven_feed_line_alarm: "料线不均匀",
  unfavorite: "取消收藏",
  unfinished_download_tasks_will_be_cleared_after_exiting_are_you_:
    "退出后未完成的下载任务将清空，确定退出吗？",
  unfinished_download_tasks_will_be_cleared_after_logout_are_you_s:
    "退出后未完成的下载任务将清空，确定注销吗？",
  unfold: "展开",
  unilateral_inspection: "单边巡检",
  uninspected_points: "未巡检点位",
  unit: "单位",
  units: "*个",
  unit_settings: "单位设置",
  unknown: "未知",
  unknown_directory: "路径不存在",
  unknown_exception: "未知异常",
  unknown_folder: "文件夹不存在",
  unknown_img: "未知图像",
  unknown_ope: "未知操作",
  unknown_points_need_synchronization: "未知点位（需同步）",
  unknown_username_or_incorrect_pwd: "用户名不存在或密码错误",
  unlock: "解锁",
  unlocked: "未闭锁",
  unlock_failed: "解锁失败",
  unlock_succeeded: "解锁成功",
  unlock_the_robot: "解锁机器人",
  unpaid: "未付款",
  unprocessed: "未处理",
  unrecoverable_deletion: "删除后不可恢复",
  unsale: "下架",
  unseled: "未选择",
  unsel_all: "取消全选",
  up: "上",
  update: "更新升级",
  updated_inspection_point_successfully: "更新巡检点成功",
  update_and_import: "更新并导入",
  update_complete: "更新成功",
  update_date: "更新日期",
  update_failed: "更新失败",
  update_failed_check_code_error: "更新失败,校验码错误",
  update_files: "更新文件",
  update_file_not_detected: "更新文件不存在",
  update_firmware: "更新固件",
  update_from_sd_card: "从sd卡更新",
  update_information: "更新资料",
  update_location: "更新位置",
  update_palette: "更新色板",
  update_starup_picture: "更新开机画面",
  update_succeeded_auto_power_off_after_1_minute: "更新成功,1分钟后自动关机",
  update_success_pls_restart: "更新成功，请重启设备",
  update_time: "更新时间",
  updating_patrol_plan_succeeded: "更新轮巡计划成功",
  upgrade: "升级",
  upgrade_completed: "升级完成",
  upgrade_completed_rebooting: "升级完成，重启中",
  upgrade_failed: "升级失败",
  upgrade_failed_due_to_device_network_issue: "升级失败，设备网络异常",
  upgrade_failed_pls_exit_and_try_again: "升级失败，请退出重试",
  upgrade_now: "立即升级",
  upgrade_package_download_failed: "升级包下载失败",
  upgrade_package_download_successful: "升级包下载成功",
  upgrade_package_error: "升级包错误",
  upgrade_package_upload_failed: "升级包上传失败",
  upgrade_package_upload_successful: "升级包上传成功",
  upgrade_preparation: "升级准备",
  upgrade_reminder: "升级提醒",
  upgrade_successful: "升级成功",
  upload: "上传",
  uploaded_file_exceeds_the_limit: "上传文件已超过限制",
  uploaded_file_has_exceeded_limits: "上传档已超过限制",
  uploaded_img_size_exceeds: "上传图片大小超过",
  uploaded_logo_size_cannot_exceed_500kb: "上传LOGO大小不能超过 500kb",
  uploading: "正在上传",
  upload_error: "上传错误",
  upload_failed: "上传失败!",
  upload_finish: "上传完成",
  upload_log: "上传日志",
  upload_success: "上传成功",
  upload_the_upgrade_package_to_the_device: "上传升级包至设备",
  upper_temp_limit_should_be_greater_than_lower_temp_limit:
    "温度上限应大于温度下限",
  upper_threshold: "阈值上限",
  up_down_flip: "上下翻转",
  up_to_16_channels_can_be_seled: "最多可选16个通道",
  urban_fire: "城市火灾",
  usb_camera: "USB相机",
  usb_disk: "U盘",
  usb_mode: "USB模式",
  usb_to_serial_port: "USB转串口",
  used_to_receive_alert_messages: "用于接收告警短信",
  user: "用户",
  username: "用户名",
  username_must_be_letters_numbers_or_chinese_characters_and_no_lo:
    "用户名为字母、数字或中文，且长度不超过20",
  username_must_be_letters_or_numbers_and_no_longer_than_20_charac:
    "用户名为字母或数字，且长度不超过20",
  username_only_supports_english_numbers_period_hyphen_underscore:
    "用户名仅支持英文、数字、@、点、横杠、下划线、反斜杠",
  username_or_pwd_error: "用户名或密码错误",
  username_required: "用户名(必填)",
  users_full_name: "用户姓名",
  user_agreement: "用户协议",
  user_bound_to_app: "已绑定app用户",
  user_cannot_be_queried: "无法查询到用户",
  user_defined_frame: "自定义帧频",
  user_does_not_exist: "用户不存在",
  user_email: "用户邮箱",
  user_entity_corresponding_field: "user实体类对应字段",
  user_exist: "用户已存在",
  user_id: "用户编号",
  user_locked: "用户已锁定",
  user_management: "用户管理",
  user_manual: "用户手册",
  user_name: "姓名",
  user_name_cannot_be_empty: "用户姓名不能为空",
  user_name_is_required: "用户名不能为空",
  user_name_must_be_letters_or_chinese_characters_and_no_longer_th:
    "用户姓名为字母或中文，且长度不超过20",
  user_name_or_name: "用户名或姓名",
  user_nickname: "用户昵称",
  user_nickname_cannot_be_empty: "用户昵称不能为空",
  user_privacy_policy: "用户隐私政策",
  user_remarks: "用户备注",
  user_remarks_cannot_exceed_100_characters: "用户备注字数不超过100字",
  user_role: "用户角色",
  user_settings: "用户设置",
  user_table_corresponding_field: "用户表对应字段",
  val: "值",
  valid_after_software_restart: "软件重启后生效",
  valid_calibration_failed: "标定生效失败",
  valid_calibration_succeeded: "标定生效成功",
  vehicle: "车",
  vehicle_alarm: "车辆报警",
  vehicle_excavator_recognition_algorithm_thermal:
    "车辆、挖掘机识别算法(热成像)",
  vehicle_patrol: "车巡",
  ver: "版本",
  verification_code: "验证码",
  verification_code_format_error: "验证码格式错误",
  verification_code_generation_service_error: "验证码生成服务异常",
  verification_code_not_existed_or_expired: "验证码不存在或已过期",
  verification_code_sending_failed: "验证码发送失败",
  verification_code_sent_successfully: "验证码发送成功",
  verification_code_should_be_6_digits: "验证码不足6位",
  version: "版本号",
  vertical: "垂直",
  vertical_angle: "垂直角",
  vertical_click_value: "竖直咔哒刻度",
  vertical_up_down: "竖直（上、下-）",
  ver_check_failed: "版本检测失败",
  ver_cur: "当前版本",
  ver_upd: "版本更新",
  vessel: "船",
  vessel_coordinates: "船只坐标",
  vessel_destination: "船只目的地",
  vessel_latitude_and_longitude: "船只经纬度",
  vessel_name: "船只名称",
  vessel_speed_in_knots: "船只速度（节）",
  vessel_type: "船只类型",
  ves_speed_knots: "船只速度(节)",
  video: "视频",
  video_alarm: "视频报警",
  video_analysis: "视频分析",
  video_anomaly_recording_failed: "视频异常，录制失败",
  video_application: "视频应用",
  video_blocked: "视频遮挡",
  video_cannot_be_played: "视频无法播放",
  video_download: "录像下载",
  video_download_failed: "视频下载失败",
  video_inspection: "视频巡检",
  video_interval: "录像间隔",
  video_larger_than_500m_is_unabled_to_be_uploaded: "无法上传大于500M的视频",
  video_lost: "视频丢失",
  video_merging_in_progress_pls_wait: "视频合并生成中，请稍后",
  video_playback: "录像回放",
  video_playback_linkage_snapshot: "录像回放&联动抓图",
  video_query_failed: "查询录像失败。",
  video_recorded_successfully_pls_check_in_the_phone_gallery:
    "录像成功，请到手机相册中查看",
  video_recording: "录像中",
  video_replay: "视频回放",
  video_saving: "视频保存中",
  video_server: "视频服务器",
  video_server_already_exists: "视频服务器已存在",
  video_settings: "录像设置",
  video_surveillance_alarmvid_sur_alm: "视频监控报警",
  video_transcoding: "视频转码中",
  video_transcoding_succeeded: "视频转码成功",
  video_wall: "电视墙",
  view: "视图",
  viewtrack: "查看并追踪",
  view_and_manage_the_imgs_videos_in_the_device: "查看管理设备端视频、图片",
  view_cage_positions: "查看笼位",
  view_details: "查看详情",
  view_device_alarms: "设备报警查看",
  view_event_alarms: "业务报警查看",
  view_id: "视图ID",
  view_img: "查看图片",
  view_information: "查看信息",
  view_inspection_results: "巡检结果查看",
  view_logistics: "查看物流",
  view_map: "地图查看",
  view_mode: "图像模式",
  view_more: "查看更多",
  view_name: "视图名称",
  view_pen: "查看栏位",
  view_report: "报告查看",
  view_task_queue: "任务队列查看",
  view_the_report: "查看报告",
  view_video: "查看视频",
  vip: "会员",
  visible: "可见光",
  visible_fire: "可见光-火",
  visible_fire_detection: "可见光-火检测",
  visible_light_malfunction: "可见光故障",
  visible_mode: "可见光模式",
  visible_mode_no_measurement_set: "可见光模式下不支持测量设置",
  visible_mode_no_palette_set: "可见光模式下不支持伪彩设置",
  visible_mode_no_params_set: "可见光下不支持参数设置",
  visible_smoke: "可见光-烟",
  visible_smoke_detection: "可见光-烟检测",
  visible_smoke_detection_visible_fire_detection:
    "可见光-烟检测与可见光-火检测",
  visible_smoke_visible_fire: "可见光-烟与可见光-火",
  visual_imgs: "可见光图像",
  visual_screenshot: "可见光截图",
  visual_settings: "可见光设置",
  visual_smokefire_detection: "可见光烟火检测",
  visual_snapshot: "可见光抓图",
  vis_3000_player_format: "VIS-3000 Player格式",
  voice_announcement: "语音播报",
  voltage: "电压",
  volume: "音量",
  waiting: "等待中",
  waiting_for_download: "等待下载",
  wait_apply: "待审核",
  wait_pay: "待付款",
  wait_receive: "待收货",
  warning: "警告",
  warning_blue: "警示蓝",
  warning_green: "警示绿",
  warning_prompt: "警告提示",
  warning_red: "警示红",
  warranty: "质保",
  water: "水",
  waterline: "水线",
  waterline_recognition: "水线识别",
  watermark: "水印",
  water_line_alarm: "水线报警",
  wavelength: "波长",
  weak_chicken_alarm: "弱鸡报警",
  weak_gps_signal: "GPS信号弱",
  weather: "天气",
  website: "网址",
  wechat_pay: "微信支付",
  wednesday: "周三",
  week: "星期",
  weekly: "每周",
  weight: "重量",
  weight_analysis: "重量分析",
  weight_gain_analysis: "增重分析",
  welcome: "欢迎使用",
  welcome_login: "欢迎登录",
  welcome_to: "欢迎来到",
  west_northwest: "西偏北",
  west_southeast: "西偏南",
  we_detected_that_you_are_currently_using_mobile_data_for_the_dow:
    "检测到您当前正在使用流量进行下载，是否继续",
  when_setting_a_shielded_area_for_a_specific_period_the_valid_tim:
    "屏蔽区域设置为期限时，有效时间不能为空",
  whether_there_are_other_hotspots_with_the_same_name_around_the_d:
    "设备周围是否有其他同名热点",
  whether_the_hotspot_name_matches_the_device: "热点名称与设备是否匹配",
  whether_the_mobile_hotspot_is_turned_on: "手机热点是否开启",
  whether_to_del_sel: "是否删除所选项目",
  white_brick: "白砖",
  white_hot: "白热",
  wifi: "设备WiFi",
  wifi_characters: "wifi名称只能为1-32大小写字母和数字",
  wifi_image_transmission: "WiFi图传",
  wifi_information_setting_failed: "wifi信息设置失败",
  wifi_modified_restart: "WiFi修改成功！若发生无法连接设备的情况，建议重启设备",
  wifi_modified_successfully: "修改WIFI成功",
  wifi_modified_successfully_the_device_needs_to_be_restarted_to_t:
    "WiFi修改成功，设备需重启后生效",
  wifi_must_be_enabled_on_the_device: "Wi-Fi必须通过设备打开",
  wifi_name: "WiFi名称",
  wifi_name_cannot_be_longer_than_32_chars: "WiFi名称不能长于32位",
  wifi_name_too_short: "Wi-Fi名称过短",
  wifi_password: "WiFi密码",
  wifi_password_too_short: "Wi-Fi密码过短",
  wifi_pwd_modified_restart:
    "设备WiFi密码已修改成功,请手动重启设备,并重新进入App",
  wifi_setting: "WIFI设置",
  wind: "风",
  wind_direction: "风向",
  wind_speed: "风速",
  wind_speed_cloud_map: "风速云图",
  wind_speed_m_s: "风速(m/s)",
  wind_speed_sensor_status: "风速传感器状态",
  wiper: "雨刷",
  wiper_control_exception_pls_check_the_device: "雨刷控制异常，请检查设备",
  wireless_device: "无线设备",
  wlan: "WLAN",
  wlan_hotspot_switch: "热点开关",
  wood: "木材",
  wool: "羊毛",
  write: "写入",
  write_files_to_the_phone_memory: "App会向手机存储写入图像和视频文件",
  wrong_password_attempts_left: "密码错误,还有%1次尝试机会",
  xsentry_main_server_status: "XSENTRY服务器1状态",
  xsentry_secondary_server_status: "XSENTRY服务器2状态",
  xxx_inspection_task_failed_to_resume_execution_due_to_network_co:
    "XXX巡检任务恢复执行失败，网络连接异常",
  xxx_inspection_task_failed_to_re_execute_due_to_network_connecti:
    "XXX巡检任务重新执行失败，网络连接异常",
  xxx_inspection_task_issuance_failed_xxx_robot_not_responding:
    "XXX巡检任务下发失败，XXX机器人未响应",
  xxx_inspection_task_issuance_failed_xxx_robot_points_do_not_matc:
    "XXX巡检任务下发失败，XXX机器人点位与平台不一致",
  xxx_inspection_task_issued_successfully: "XXX巡检任务下发成功",
  xxx_inspection_task_issuing: "XXX巡检任务下发中",
  xxx_inspection_task_is_resuming: "XXX巡检任务恢复中",
  xxx_inspection_task_is_re_executing: "XXX巡检任务重新执行中",
  xxx_inspection_task_resumed_successfully: "XXX巡检任务恢复成功",
  xxx_inspection_task_re_executed_successfully: "XXX巡检任务重新重新执行成功",
  xxx_inspection_task_re_execution_failed_xxx_robot_did_not_respon:
    "XXX巡检任务重新执行失败，XXX机器人未响应",
  xxx_inspection_task_terminated_successfully: "XXX巡检任务终止成功",
  xxx_inspection_task_terminating: "XXX巡检任务终止中",
  xxx_inspection_task_termination_failed_network_connection_error:
    "XXX巡检任务终止失败，网络连接异常",
  xxx_inspection_task_termination_failed_xxx_robot_not_responding:
    "XXX巡检任务终止失败，XXX机器人未响应",
  yacht: "游艇",
  yaw_angle_offset: "转角偏移量",
  year: "年",
  year_month: "*年*月",
  yes: "是",
  yesterday: "昨天",
  your_access_is_too_frequent_pls_retry_after_30_seconds:
    "您的访问过于频繁，请30秒后重试",
  you_can_enter_1_32_characters_including_digits_letters___and_or:
    "允许输入1~32位的数字、字母、-、_",
  you_can_enter_8_16_characters_including_digits_letters___and_or:
    "允许输入8~16位的数字、字母、-、_",
  you_can_upgrade_in_device_information_check_for_updates:
    "可在设备信息-检查更新中进行升级",
  you_have_not_completed_the_company_information: "您尚未完善企业信息",
  you_need_to_enable_location_services_to_discover_new_devices:
    "需打开定位才能发现新设备",
  you_need_to_turn_on_bluetooth_to_discover_new_devices:
    "需要打开蓝牙才能发现新设备",
  zeroing_config_unit: "归零设置计量单位",
  zeroing_distance: "归零距离",
  zeroing_weather: "归零天气",
  zoom: "变倍",
  zoom_level: "缩放级别",
  zoom_out: "缩小",
};
